import React, { useEffect, useState } from "react";
import "./style.css";
import { Dialog } from "primereact/dialog";
import { type } from "@testing-library/user-event/dist/type";
import Loader from "../Loader";
import { addDocument } from "../Firebase/CloudFirestore/SetData";
import "primereact/resources/themes/saga-blue/theme.css";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";

import { Dropdown } from "primereact/dropdown";
import AutoCompelte from "../AutoCompelte";

export default function Chatbot() {
  // State to track the selected category
  const [visible, setVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [loading6, setLoading6] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    category: "",
    type: "",
    series: "",
    modal: "",
    deviceType: "",
    deviceColor: "",
    storage: "",
    ram: "",
    processor: "",
    layout: "",
    unibody: "",
    underside: "",
    defective: "",
    cover: "",
    display: "",
    frame: "",
    backCase: "",
  });
  const fieldOrder = [
    "category",
    "type",
    "modal",
    "deviceType",
    "defective",
    "deviceColor",
    "storage",
    "ram",
    "processor",
    "layout",
    "display",
    "frame",
    "backCase",
    "cover",
    "unibody",
    "underside",
  ];
  const [selectedModel, setSelectedModel] = useState(null);
  const [modelListing, setModelListing] = useState([]);
  const clearBelowStates1 = (clickedField) => {
    // console.log(clickedField);
    setData({
      category: "",
      type: "",
      series: "",
      modal: "",
      deviceType: "",
      deviceColor: "",
      storage: "",
      ram: "",
      processor: "",
      layout: "",
      unibody: "",
      underside: "",
      cover: "",
      display: "",
      frame: "",
      backCase: "",
    });
  };
  const clearBelowStates = (clickedField) => {
    // alert("usman")
    setData((prevData) => {
      const newData = { ...prevData };

      // Find the index of the clicked field in the fieldOrder array
      const index = fieldOrder.indexOf(clickedField);

      // Clear all fields that come after the clicked field
      fieldOrder.slice(index).forEach((field) => {
        newData[field] = "";
      });

      return newData;
    });
  };
  const handleCategoryClick = (obj) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setData((prev) => ({
        ...prev,
        ...obj,
      }));
    }, 500);
    // setLoading(false);
    // 1000 milliseconds = 1 second
  };
  function handlePhoneClick() {
    // console.log("ksdh");
  }
  const resetData = () => {
    setData({
      category: "",
    });
    setSelectedCategory("");
  };
  const resetData2 = () => {
    setData({
      type: "",
    });
    setSelectedCategory("");
  };

  useEffect(() => {
    let newModel = {
      phone: model["iPhone"],
      phone2: model["A Series"],
      phone3: model["Note Series"],
      phone4: model["Fold Flip Series"],
      phone5: model["Samsung Galaxy"],
      phone7: model["Huawei"],
      phone6: model["Samsung Tab"],
    };
    let data = Object.values(newModel);
    // console.log(data.flat());
    setModelListing(
      data.flat().map((res) => ({ label: res.name, value: res.name }))
    );
  }, []);

  async function SubmitData() {
    try {
      let res = await addDocument("chatdata", data);
      console.log(res);
    } catch (err) {
      console.log(err);
    }
  }

  let extraData = {
    Gebraucht: "Wie ist der Zustand Ihres Displays?",
    "Mangelhaft/Defekt": "Wie ist der Zustand Ihres Displays?",
  };
  let extraData2 = {
    Gebraucht: "Wie ist der Zustand Ihres Rahmens?",
    "Mangelhaft/Defekt": "Wie ist der Zustand Ihres Rahmens?",
  };
  let extraData3 = {
    Gebraucht: "Wie ist der Zustand Ihrer Rückseite?",
    "Mangelhaft/Defekt": "Wie ist der Zustand Ihrer Rückseite?",
  };

  // additional computer question
  let extraData4 = {
    Gebraucht: "Wie ist der Zustand des Deckels?",
    "Mangelhaft/Defekt": "Wie ist der Zustand des Deckels?",
  };

  let extraData5 = {
    Gebraucht: "Wie ist der Zustand des Unibody Gehauses?",
    "Mangelhaft/Defekt": "Wie ist der Zustand des Unibody Gehauses?",
  };

  let extraData6 = {
    Gebraucht: "Wie ist der Zustand der Unterseite?",
    "Mangelhaft/Defekt": "Wie ist der Zustand der Unterseite?",
  };

  let display = [
    { name: "Keine Gebrauchsspuren)", type: "Keine Gebrauchsspuren" },
    { name: "Sichtbare Gebrauchsspuren", type: "Sichtbare Gebrauchsspuren" },
    { name: "Spubare Gebrauchsspuren", type: "Spubare Gebrauchsspuren" },
  ];

  let frame = [
    { name: "Keine Gebrauchsspuren)", type: "Keine Gebrauchsspuren" },
    { name: "Sichtbare Gebrauchsspuren", type: "Sichtbare Gebrauchsspuren" },
    { name: "Spubare Gebrauchsspuren", type: "Spubare Gebrauchsspuren" },
  ];
  let backCase = [
    { name: "Keine Gebrauchsspuren)", type: "Keine Gebrauchsspuren" },
    { name: "Sichtbare Gebrauchsspuren", type: "Sichtbare Gebrauchsspuren" },
    { name: "Spubare Gebrauchsspuren", type: "Spubare Gebrauchsspuren" },
  ];
  let cover = [
    { name: "Keine Gebrauchsspuren)", type: "Keine Gebrauchsspuren" },
    { name: "Sichtbare Gebrauchsspuren", type: "Sichtbare Gebrauchsspuren" },
    { name: "Spubare Gebrauchsspuren", type: "Spubare Gebrauchsspuren" },
  ];
  let unibody = [
    { name: "Keine Gebrauchsspuren)", type: "Keine Gebrauchsspuren" },
    { name: "Sichtbare Gebrauchsspuren", type: "Sichtbare Gebrauchsspuren" },
    { name: "Spubare Gebrauchsspuren", type: "Spubare Gebrauchsspuren" },
  ];
  let underside = [
    { name: "Keine Gebrauchsspuren)", type: "Keine Gebrauchsspuren" },
    { name: "Sichtbare Gebrauchsspuren", type: "Sichtbare Gebrauchsspuren" },
    { name: "Spubare Gebrauchsspuren", type: "Spubare Gebrauchsspuren" },
  ];

  let ram = {
    "64GB SSD": [
      { name: "8GB", type: "8GB" },
      { name: "16GB", type: "16GB" },
      { name: "24GB", type: "24GB" },
    ],
    "128GB SSD": [
      { name: "8GB", type: "8GB" },
      { name: "16GB", type: "16GB" },
      { name: "24GB", type: "24GB" },
    ],

    "256GB SSD": [
      { name: "8GB", type: "8GB" },
      { name: "16GB", type: "16GB" },
      { name: "24GB", type: "24GB" },
    ],
    "512GB SSD": [
      { name: "16GB", type: "16GB" },
      { name: "32GB", type: "32GB" },
      { name: "64GB", type: "64GB" },
      { name: "96GB", type: "96GB" },
    ],
    "1TB SSD": [
      { name: "16GB", type: "16GB" },
      { name: "32GB", type: "32GB" },
      { name: "64GB", type: "64GB" },
      { name: "96GB", type: "96GB" },
    ],
    "2TB SSD": [
      { name: "16GB", type: "16GB" },
      { name: "32GB", type: "32GB" },
      { name: "64GB", type: "64GB" },
      { name: "96GB", type: "96GB" },
    ],
    "4TB SSD": [
      { name: "16GB", type: "16GB" },
      { name: "32GB", type: "32GB" },
      { name: "64GB", type: "64GB" },
      { name: "96GB", type: "96GB" },
    ],
    "8TB SSD": [
      { name: "16GB", type: "16GB" },
      { name: "32GB", type: "32GB" },
      { name: "64GB", type: "64GB" },
      { name: "96GB", type: "96GB" },
    ],
  };
  let layout = {
    MacBook: [
      {
        name: "Anderes Tastatur Layout",
        type: "Anderes Tastatur Layout",
      },
      {
        name: "CH-Tastatur Layout",
        type: "CH-Tastatur Layout",
      },
    ],
    "Mac Mini": [
      {
        name: "Anderes Tastatur Layout",
        type: "Anderes Tastatur Layout",
      },
      {
        name: "CH-Tastatur Layout",
        type: "CH-Tastatur Layout",
      },
    ],
    iMac: [
      {
        name: "Anderes Tastatur Layout",
        type: "Anderes Tastatur Layout",
      },
      {
        name: "CH-Tastatur Layout",
        type: "CH-Tastatur Layout",
      },
    ],
    // "Apple M2 with 8-core CPU and 10-core GPU": [
    //   {
    //     name: "Different keyboard layout",
    //     type: "Different keyboard layout",
    //   },
    //   {
    //     name: "CH keyboard layout",
    //     type: "CH keyboard layout",
    //   },
    // ],
    // "Apple M2 with 8-core CPU and 10-core GPU": [
    //   {
    //     name: "Different keyboard layout",
    //     type: "Different keyboard layout",
    //   },
    //   {
    //     name: "CH keyboard layout",
    //     type: "CH keyboard layout",
    //   },
    // ],
    // "Apple M2 with 8-core CPU and 10-core GPU": [
    //   {
    //     name: "Different keyboard layout",
    //     type: "Different keyboard layout",
    //   },
    //   {
    //     name: "CH keyboard layout",
    //     type: "CH keyboard layout",
    //   },
    // ],
  };
  let processor = {
    "8GB": {
      "Macbook Air 15 inch M2(year 2023)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 15 inch M3(year 2024)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13 inch M3(year 2024)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13.6 inch M2(year 2022)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13 M1(year end 2020)": [
        {
          name: "Apple M1 chip with 8-core CPU and 7-core GPU",
          type: "Apple M1 chip with 8-core CPU and 7-core GPU",
        },
        {
          name: "Apple M1 chip with 8‑core CPU and 8‑core GPU",
          type: "Apple M1 chip with 8‑core CPU and 8‑core GPU",
        },
      ],
      "Macbook Air 13(year 2020)": [
        {
          name: "1.1 GHz dual-core Intel Core i3 (10th generation)",
          type: "1.1 GHz dual-core Intel Core i3 (10th generation)",
        },
        {
          name: "1.1 GHz quad-core Intel Core i5 (10th generation)",
          type: "1.1 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "1.2 GHz quad-core Intel Core i7 (10th generation)",
          type: "1.2 GHz quad-core Intel Core i7 (10th generation)",
        },
      ],
      "Macbook Air 13(year 2019)": [
        {
          name: "1.1 GHz dual-core Intel Core i3 (10th generation)",
          type: "1.1 GHz dual-core Intel Core i3 (10th generation)",
        },
        {
          name: "1.1 GHz quad-core Intel Core i5 (10th generation)",
          type: "1.1 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "1.2 GHz quad-core Intel Core i7 (10th generation)",
          type: "1.2 GHz quad-core Intel Core i7 (10th generation)",
        },
      ],
      "MacBook Pro 13 (2020)(Year 2020)": [
        {
          name: "1.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "1.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        {
          name: "1.7 GHz quad-core Intel Core i7 (8th generation)",
          type: "1.7 GHz quad-core Intel Core i7 (8th generation)",
        },
        {
          name: "2.0 GHz quad-core Intel Core i5 (10th generation)",
          type: "2.0 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "2.0 GHz quad-core Intel Core i5 (10th generation)",
          type: "2.0 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "2.3 GHz quad-core Intel Core i7 (10th generation)",
          type: "2.3 GHz quad-core Intel Core i7 (10th generation)",
        },
        { name: "Apple M1 chip", type: "Apple M1 chip" },
      ],
      "MacBook Pro 15 (2019)(Year 2019)": [
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.4GHz 8-Core Intel Core i9",
          type: "2.4GHz 8-Core Intel Core i9",
        },
        {
          name: "2.3GHz 8-Core Intel Core i9",
          type: "2.3GHz 8-Core Intel Core i9",
        },
      ],
      "MacBook Pro 16 (2019)(Year 2019)": [
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.4GHz 8-Core Intel Core i9",
          type: "2.4GHz 8-Core Intel Core i9",
        },
        {
          name: "2.3GHz 8-Core Intel Core i9",
          type: "2.3GHz 8-Core Intel Core i9",
        },
      ],
      "MacBook Pro 13 (2019)(Year 2019)": [
        {
          name: "1.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "1.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        {
          name: "2.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "2.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        { name: "1.4GHz Dual Core i7", type: "1.4GHz Dual Core i7" },
        { name: "2.8GHz Quad Core i7", type: "2.8GHz Quad Core i7" },
      ],
      "MacBook Pro 13 (2018)(Year 2018)": [
        {
          name: "2.3 GHz dual-core Intel Core i5",
          type: "2.3 GHz dual-core Intel Core i5",
        },
        {
          name: "2.7GHz quad-core Intel Core i7",
          type: "2.7GHz quad-core Intel Core i7",
        },
        {
          name: "2.3GHz quad-core Intel Core i5",
          type: "2.3GHz quad-core Intel Core i5",
        },
      ],
      "MacBook Pro 15 (2018)(Year 2018)": [
        {
          name: "2.2GHz 6-core Intel Core i7",
          type: "2.2GHz 6-core Intel Core i7",
        },
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.9GHz 6-core Intel Core i9",
          type: "2.9GHz 6-core Intel Core i9",
        },
      ],
      "Macbook Pro 16 inch M3(year end 2023)": [
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Max chip with 14-core CPU, 30-core GPU",
          type: "M3 Max chip with 14-core CPU, 30-core GPU",
        },
        {
          name: "M3 Max chip with 16-core CPU, 40-core GPU",
          type: "M3 Max chip with 16-core CPU, 40-core GPU",
        },
      ],
      "Macbook Pro 14 inch M3(year end 2023)": [
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
        {
          name: "M3 Pro with 11-core CPU, 14-core GPU",
          type: "M3 Pro with 11-core CPU, 14-core GPU",
        },
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Max chip with 14-core CPU, 30-core GPU",
          type: "M3 Max chip with 14-core CPU, 30-core GPU",
        },
        {
          name: "M3 Max chip with 16-core CPU, 40-core GPU",
          type: "M3 Max chip with 16-core CPU, 40-core GPU",
        },
      ],
      "Macbook Pro 16 inch M2(year end 2023)": [
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 30-core GPU",
          type: "Apple M2 Max with 12-core CPU and 30-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 38-core GPU",
          type: "Apple M2 Max with 12-core CPU and 38-core GPU",
        },
      ],
      "Macbook Pro 14 inch M2(year early 2023)": [
        {
          name: "Apple M2 Pro with 10-core CPU and 16-core GPU",
          type: "Apple M2 Pro with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 30-core GPU",
          type: "Apple M2 Max with 12-core CPU and 30-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 38-core GPU",
          type: "Apple M2 Max with 12-core CPU and 38-core GPU",
        },
      ],
      "MacBook Pro 13 inch (Touchbar)(Year 2022)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
      ],
      "MacBook Pro 16(Year 2021)": [
        {
          name: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
      ],
      "MacBook Pro 14(2021 release)": [
        {
          name: "Apple M1 Pro chip with 8-core CPU and 14-core GPU",
          type: "Apple M1 Pro chip with 8-core CPU and 14-core GPU",
        },
        {
          name: "Apple M1 Pro chip with 10-core CPU and 14-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 14-core GPU",
        },
        {
          name: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
      ],
      "Mac Mini(2023)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
        {
          name: "Apple M2 Pro with 10-core CPU and 16-core GPU",
          type: "Apple M2 Pro with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
      ],
      "Mac Mini(2020)": [
        {
          name: "3.6 GHz Intel Core i3 (8th generation)",
          type: "3.6 GHz Intel Core i3 (8th generation)",
        },
        {
          name: "3.0GHz 6-Core i5 (8th Generation)",
          type: "3.0GHz 6-Core i5 (8th Generation)",
        },
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        { name: "Apple M1 chip", type: "Apple M1 chip" },
      ],
      "Mac Mini(2018)": [
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        {
          name: "3.0GHz 6-Core i5 (8th Generation)",
          type: "3.0GHz 6-Core i5 (8th Generation)",
        },
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        {
          name: "3.6 GHz Intel Core i3 (8th generation)",
          type: "3.6 GHz Intel Core i3 (8th generation)",
        },
      ],
      "Mac Studio": [
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
        },
      ],
      "iMac 24 inch(year 2023)": [
        {
          name: "Apple M1 chip with 8-core CPU and 7-core GPU",
          type: "Apple M1 chip with 8-core CPU and 7-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
        },
      ],
      "iMac 24 inch(year 2021)": [
        {
          name: "M3 with 8-core CPU, 8-core GPU",
          type: "M3 with 8-core CPU, 8-core GPU",
        },
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
      ],
      "iMac 5K 27 inch(year 2019)": [
        {
          name: "M3 with 8-core CPU, 8-core GPU",
          type: "M3 with 8-core CPU, 8-core GPU",
        },
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
      ],
    },
    "16GB": {
      "Macbook Air 15 inch M2(year 2023)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 15 inch M3(year 2024)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13 inch M3(year 2024)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13.6 inch M2(year 2022)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13 M1(year end 2020)": [
        {
          name: "Apple M1 chip with 8-core CPU and 7-core GPU",
          type: "Apple M1 chip with 8-core CPU and 7-core GPU",
        },
        {
          name: "Apple M1 chip with 8‑core CPU and 8‑core GPU",
          type: "Apple M1 chip with 8‑core CPU and 8‑core GPU",
        },
      ],
      "Macbook Air 13(year 2020)": [
        {
          name: "1.1 GHz dual-core Intel Core i3 (10th generation)",
          type: "1.1 GHz dual-core Intel Core i3 (10th generation)",
        },
        {
          name: "1.1 GHz quad-core Intel Core i5 (10th generation)",
          type: "1.1 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "1.2 GHz quad-core Intel Core i7 (10th generation)",
          type: "1.2 GHz quad-core Intel Core i7 (10th generation)",
        },
      ],
      "MacBook Pro 13 (2020)(Year 2020)": [
        {
          name: "1.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "1.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        {
          name: "1.7 GHz quad-core Intel Core i7 (8th generation)",
          type: "1.7 GHz quad-core Intel Core i7 (8th generation)",
        },
        {
          name: "2.0 GHz quad-core Intel Core i5 (10th generation)",
          type: "2.0 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "2.0 GHz quad-core Intel Core i5 (10th generation)",
          type: "2.0 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "2.3 GHz quad-core Intel Core i7 (10th generation)",
          type: "2.3 GHz quad-core Intel Core i7 (10th generation)",
        },
        { name: "Apple M1 chip", type: "Apple M1 chip" },
      ],
      "MacBook Pro 15 (2019)(Year 2019)": [
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.4GHz 8-Core Intel Core i9",
          type: "2.4GHz 8-Core Intel Core i9",
        },
        {
          name: "2.3GHz 8-Core Intel Core i9",
          type: "2.3GHz 8-Core Intel Core i9",
        },
      ],
      "MacBook Pro 16 (2019)(Year 2019)": [
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.4GHz 8-Core Intel Core i9",
          type: "2.4GHz 8-Core Intel Core i9",
        },
        {
          name: "2.3GHz 8-Core Intel Core i9",
          type: "2.3GHz 8-Core Intel Core i9",
        },
      ],
      "MacBook Pro 13 (2019)(Year 2019)": [
        {
          name: "1.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "1.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        {
          name: "2.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "2.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        { name: "1.4GHz Dual Core i7", type: "1.4GHz Dual Core i7" },
        { name: "2.8GHz Quad Core i7", type: "2.8GHz Quad Core i7" },
      ],
      "MacBook Pro 13 (2018)(Year 2018)": [
        {
          name: "2.3 GHz dual-core Intel Core i5",
          type: "2.3 GHz dual-core Intel Core i5",
        },
        {
          name: "2.7GHz quad-core Intel Core i7",
          type: "2.7GHz quad-core Intel Core i7",
        },
        {
          name: "2.3GHz quad-core Intel Core i5",
          type: "2.3GHz quad-core Intel Core i5",
        },
      ],
      "MacBook Pro 15 (2018)(Year 2018)": [
        {
          name: "2.2GHz 6-core Intel Core i7",
          type: "2.2GHz 6-core Intel Core i7",
        },
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.9GHz 6-core Intel Core i9",
          type: "2.9GHz 6-core Intel Core i9",
        },
      ],
      "Macbook Pro 16 inch M3(year end 2023)": [
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Max chip with 14-core CPU, 30-core GPU",
          type: "M3 Max chip with 14-core CPU, 30-core GPU",
        },
        {
          name: "M3 Max chip with 16-core CPU, 40-core GPU",
          type: "M3 Max chip with 16-core CPU, 40-core GPU",
        },
      ],
      "Macbook Pro 14 inch M3(year end 2023)": [
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
        {
          name: "M3 Pro with 11-core CPU, 14-core GPU",
          type: "M3 Pro with 11-core CPU, 14-core GPU",
        },
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Max chip with 14-core CPU, 30-core GPU",
          type: "M3 Max chip with 14-core CPU, 30-core GPU",
        },
        {
          name: "M3 Max chip with 16-core CPU, 40-core GPU",
          type: "M3 Max chip with 16-core CPU, 40-core GPU",
        },
      ],
      "Macbook Pro 16 inch M2(year end 2023)": [
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 30-core GPU",
          type: "Apple M2 Max with 12-core CPU and 30-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 38-core GPU",
          type: "Apple M2 Max with 12-core CPU and 38-core GPU",
        },
      ],
      "Macbook Pro 14 inch M2(year early 2023)": [
        {
          name: "Apple M2 Pro with 10-core CPU and 16-core GPU",
          type: "Apple M2 Pro with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 30-core GPU",
          type: "Apple M2 Max with 12-core CPU and 30-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 38-core GPU",
          type: "Apple M2 Max with 12-core CPU and 38-core GPU",
        },
      ],
      "MacBook Pro 13 inch (Touchbar)(Year 2022)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
      ],
      "MacBook Pro 16(Year 2021)": [
        {
          name: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
      ],
      "MacBook Pro 14(2021 release)": [
        {
          name: "Apple M1 Pro chip with 8-core CPU and 14-core GPU",
          type: "Apple M1 Pro chip with 8-core CPU and 14-core GPU",
        },
        {
          name: "Apple M1 Pro chip with 10-core CPU and 14-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 14-core GPU",
        },
        {
          name: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
      ],
      "Mac Mini(2023)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
        {
          name: "Apple M2 Pro with 10-core CPU and 16-core GPU",
          type: "Apple M2 Pro with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
      ],
      "Mac Mini(2020)": [
        {
          name: "3.6 GHz Intel Core i3 (8th generation)",
          type: "3.6 GHz Intel Core i3 (8th generation)",
        },
        {
          name: "3.0GHz 6-Core i5 (8th Generation)",
          type: "3.0GHz 6-Core i5 (8th Generation)",
        },
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        { name: "Apple M1 chip", type: "Apple M1 chip" },
      ],
      "Mac Mini(2018)": [
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        {
          name: "3.0GHz 6-Core i5 (8th Generation)",
          type: "3.0GHz 6-Core i5 (8th Generation)",
        },
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        {
          name: "3.6 GHz Intel Core i3 (8th generation)",
          type: "3.6 GHz Intel Core i3 (8th generation)",
        },
      ],
      "Mac Studio": [
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
        },
      ],
      "iMac 24 inch(year 2023)": [
        {
          name: "Apple M1 chip with 8-core CPU and 7-core GPU",
          type: "Apple M1 chip with 8-core CPU and 7-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
        },
      ],
      "iMac 24 inch(year 2021)": [
        {
          name: "M3 with 8-core CPU, 8-core GPU",
          type: "M3 with 8-core CPU, 8-core GPU",
        },
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
      ],
      "iMac 5K 27 inch(year 2019)": [
        {
          name: "M3 with 8-core CPU, 8-core GPU",
          type: "M3 with 8-core CPU, 8-core GPU",
        },
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
      ],
    },
    "24GB": {
      "Macbook Air 15 inch M2(year 2023)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 15 inch M3(year 2024)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13 inch M3(year 2024)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13.6 inch M2(year 2022)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13 M1(year end 2020)": [
        {
          name: "Apple M1 chip with 8-core CPU and 7-core GPU",
          type: "Apple M1 chip with 8-core CPU and 7-core GPU",
        },
        {
          name: "Apple M1 chip with 8‑core CPU and 8‑core GPU",
          type: "Apple M1 chip with 8‑core CPU and 8‑core GPU",
        },
      ],
      "Macbook Air 13(year 2020)": [
        {
          name: "1.1 GHz dual-core Intel Core i3 (10th generation)",
          type: "1.1 GHz dual-core Intel Core i3 (10th generation)",
        },
        {
          name: "1.1 GHz quad-core Intel Core i5 (10th generation)",
          type: "1.1 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "1.2 GHz quad-core Intel Core i7 (10th generation)",
          type: "1.2 GHz quad-core Intel Core i7 (10th generation)",
        },
      ],
      "MacBook Pro 13 (2020)(Year 2020)": [
        {
          name: "1.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "1.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        {
          name: "1.7 GHz quad-core Intel Core i7 (8th generation)",
          type: "1.7 GHz quad-core Intel Core i7 (8th generation)",
        },
        {
          name: "2.0 GHz quad-core Intel Core i5 (10th generation)",
          type: "2.0 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "2.0 GHz quad-core Intel Core i5 (10th generation)",
          type: "2.0 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "2.3 GHz quad-core Intel Core i7 (10th generation)",
          type: "2.3 GHz quad-core Intel Core i7 (10th generation)",
        },
        { name: "Apple M1 chip", type: "Apple M1 chip" },
      ],
      "MacBook Pro 15 (2019)(Year 2019)": [
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.4GHz 8-Core Intel Core i9",
          type: "2.4GHz 8-Core Intel Core i9",
        },
        {
          name: "2.3GHz 8-Core Intel Core i9",
          type: "2.3GHz 8-Core Intel Core i9",
        },
      ],
      "MacBook Pro 16 (2019)(Year 2019)": [
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.4GHz 8-Core Intel Core i9",
          type: "2.4GHz 8-Core Intel Core i9",
        },
        {
          name: "2.3GHz 8-Core Intel Core i9",
          type: "2.3GHz 8-Core Intel Core i9",
        },
      ],
      "MacBook Pro 13 (2019)(Year 2019)": [
        {
          name: "1.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "1.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        {
          name: "2.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "2.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        { name: "1.4GHz Dual Core i7", type: "1.4GHz Dual Core i7" },
        { name: "2.8GHz Quad Core i7", type: "2.8GHz Quad Core i7" },
      ],
      "MacBook Pro 13 (2018)(Year 2018)": [
        {
          name: "2.3 GHz dual-core Intel Core i5",
          type: "2.3 GHz dual-core Intel Core i5",
        },
        {
          name: "2.7GHz quad-core Intel Core i7",
          type: "2.7GHz quad-core Intel Core i7",
        },
        {
          name: "2.3GHz quad-core Intel Core i5",
          type: "2.3GHz quad-core Intel Core i5",
        },
      ],
      "MacBook Pro 15 (2018)(Year 2018)": [
        {
          name: "2.2GHz 6-core Intel Core i7",
          type: "2.2GHz 6-core Intel Core i7",
        },
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.9GHz 6-core Intel Core i9",
          type: "2.9GHz 6-core Intel Core i9",
        },
      ],
      "Macbook Pro 16 inch M3(year end 2023)": [
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Max chip with 14-core CPU, 30-core GPU",
          type: "M3 Max chip with 14-core CPU, 30-core GPU",
        },
        {
          name: "M3 Max chip with 16-core CPU, 40-core GPU",
          type: "M3 Max chip with 16-core CPU, 40-core GPU",
        },
      ],
      "Macbook Pro 14 inch M3(year end 2023)": [
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
        {
          name: "M3 Pro with 11-core CPU, 14-core GPU",
          type: "M3 Pro with 11-core CPU, 14-core GPU",
        },
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Max chip with 14-core CPU, 30-core GPU",
          type: "M3 Max chip with 14-core CPU, 30-core GPU",
        },
        {
          name: "M3 Max chip with 16-core CPU, 40-core GPU",
          type: "M3 Max chip with 16-core CPU, 40-core GPU",
        },
      ],
      "Macbook Pro 16 inch M2(year end 2023)": [
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 30-core GPU",
          type: "Apple M2 Max with 12-core CPU and 30-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 38-core GPU",
          type: "Apple M2 Max with 12-core CPU and 38-core GPU",
        },
      ],
      "Macbook Pro 14 inch M2(year early 2023)": [
        {
          name: "Apple M2 Pro with 10-core CPU and 16-core GPU",
          type: "Apple M2 Pro with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 30-core GPU",
          type: "Apple M2 Max with 12-core CPU and 30-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 38-core GPU",
          type: "Apple M2 Max with 12-core CPU and 38-core GPU",
        },
      ],
      "MacBook Pro 13 inch (Touchbar)(Year 2022)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
      ],
      "MacBook Pro 16(Year 2021)": [
        {
          name: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
      ],
      "MacBook Pro 14(2021 release)": [
        {
          name: "Apple M1 Pro chip with 8-core CPU and 14-core GPU",
          type: "Apple M1 Pro chip with 8-core CPU and 14-core GPU",
        },
        {
          name: "Apple M1 Pro chip with 10-core CPU and 14-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 14-core GPU",
        },
        {
          name: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
      ],
      "Mac Mini(2023)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
        {
          name: "Apple M2 Pro with 10-core CPU and 16-core GPU",
          type: "Apple M2 Pro with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
      ],
      "Mac Mini(2020)": [
        {
          name: "3.6 GHz Intel Core i3 (8th generation)",
          type: "3.6 GHz Intel Core i3 (8th generation)",
        },
        {
          name: "3.0GHz 6-Core i5 (8th Generation)",
          type: "3.0GHz 6-Core i5 (8th Generation)",
        },
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        { name: "Apple M1 chip", type: "Apple M1 chip" },
      ],
      "Mac Mini(2018)": [
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        {
          name: "3.0GHz 6-Core i5 (8th Generation)",
          type: "3.0GHz 6-Core i5 (8th Generation)",
        },
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        {
          name: "3.6 GHz Intel Core i3 (8th generation)",
          type: "3.6 GHz Intel Core i3 (8th generation)",
        },
      ],
      "Mac Studio": [
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
        },
      ],
      "iMac 24 inch(year 2023)": [
        {
          name: "Apple M1 chip with 8-core CPU and 7-core GPU",
          type: "Apple M1 chip with 8-core CPU and 7-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
        },
      ],
      "iMac 24 inch(year 2021)": [
        {
          name: "M3 with 8-core CPU, 8-core GPU",
          type: "M3 with 8-core CPU, 8-core GPU",
        },
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
      ],
      "iMac 5K 27 inch(year 2019)": [
        {
          name: "M3 with 8-core CPU, 8-core GPU",
          type: "M3 with 8-core CPU, 8-core GPU",
        },
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
      ],
    },
    "32GB": {
      "Macbook Air 15 inch M2(year 2023)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 15 inch M3(year 2024)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13 inch M3(year 2024)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13.6 inch M2(year 2022)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13 M1(year end 2020)": [
        {
          name: "Apple M1 chip with 8-core CPU and 7-core GPU",
          type: "Apple M1 chip with 8-core CPU and 7-core GPU",
        },
        {
          name: "Apple M1 chip with 8‑core CPU and 8‑core GPU",
          type: "Apple M1 chip with 8‑core CPU and 8‑core GPU",
        },
      ],
      "Macbook Air 13(year 2020)": [
        {
          name: "1.1 GHz dual-core Intel Core i3 (10th generation)",
          type: "1.1 GHz dual-core Intel Core i3 (10th generation)",
        },
        {
          name: "1.1 GHz quad-core Intel Core i5 (10th generation)",
          type: "1.1 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "1.2 GHz quad-core Intel Core i7 (10th generation)",
          type: "1.2 GHz quad-core Intel Core i7 (10th generation)",
        },
      ],
      "MacBook Pro 13 (2020)(Year 2020)": [
        {
          name: "1.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "1.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        {
          name: "1.7 GHz quad-core Intel Core i7 (8th generation)",
          type: "1.7 GHz quad-core Intel Core i7 (8th generation)",
        },
        {
          name: "2.0 GHz quad-core Intel Core i5 (10th generation)",
          type: "2.0 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "2.0 GHz quad-core Intel Core i5 (10th generation)",
          type: "2.0 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "2.3 GHz quad-core Intel Core i7 (10th generation)",
          type: "2.3 GHz quad-core Intel Core i7 (10th generation)",
        },
        { name: "Apple M1 chip", type: "Apple M1 chip" },
      ],
      "MacBook Pro 15 (2019)(Year 2019)": [
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.4GHz 8-Core Intel Core i9",
          type: "2.4GHz 8-Core Intel Core i9",
        },
        {
          name: "2.3GHz 8-Core Intel Core i9",
          type: "2.3GHz 8-Core Intel Core i9",
        },
      ],
      "MacBook Pro 16 (2019)(Year 2019)": [
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.4GHz 8-Core Intel Core i9",
          type: "2.4GHz 8-Core Intel Core i9",
        },
        {
          name: "2.3GHz 8-Core Intel Core i9",
          type: "2.3GHz 8-Core Intel Core i9",
        },
      ],
      "MacBook Pro 13 (2019)(Year 2019)": [
        {
          name: "1.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "1.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        {
          name: "2.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "2.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        { name: "1.4GHz Dual Core i7", type: "1.4GHz Dual Core i7" },
        { name: "2.8GHz Quad Core i7", type: "2.8GHz Quad Core i7" },
      ],
      "MacBook Pro 13 (2018)(Year 2018)": [
        {
          name: "2.3 GHz dual-core Intel Core i5",
          type: "2.3 GHz dual-core Intel Core i5",
        },
        {
          name: "2.7GHz quad-core Intel Core i7",
          type: "2.7GHz quad-core Intel Core i7",
        },
        {
          name: "2.3GHz quad-core Intel Core i5",
          type: "2.3GHz quad-core Intel Core i5",
        },
      ],
      "MacBook Pro 15 (2018)(Year 2018)": [
        {
          name: "2.2GHz 6-core Intel Core i7",
          type: "2.2GHz 6-core Intel Core i7",
        },
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.9GHz 6-core Intel Core i9",
          type: "2.9GHz 6-core Intel Core i9",
        },
      ],
      "Macbook Pro 16 inch M3(year end 2023)": [
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Max chip with 14-core CPU, 30-core GPU",
          type: "M3 Max chip with 14-core CPU, 30-core GPU",
        },
        {
          name: "M3 Max chip with 16-core CPU, 40-core GPU",
          type: "M3 Max chip with 16-core CPU, 40-core GPU",
        },
      ],
      "Macbook Pro 14 inch M3(year end 2023)": [
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
        {
          name: "M3 Pro with 11-core CPU, 14-core GPU",
          type: "M3 Pro with 11-core CPU, 14-core GPU",
        },
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Max chip with 14-core CPU, 30-core GPU",
          type: "M3 Max chip with 14-core CPU, 30-core GPU",
        },
        {
          name: "M3 Max chip with 16-core CPU, 40-core GPU",
          type: "M3 Max chip with 16-core CPU, 40-core GPU",
        },
      ],
      "Macbook Pro 16 inch M2(year end 2023)": [
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 30-core GPU",
          type: "Apple M2 Max with 12-core CPU and 30-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 38-core GPU",
          type: "Apple M2 Max with 12-core CPU and 38-core GPU",
        },
      ],
      "Macbook Pro 14 inch M2(year early 2023)": [
        {
          name: "Apple M2 Pro with 10-core CPU and 16-core GPU",
          type: "Apple M2 Pro with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 30-core GPU",
          type: "Apple M2 Max with 12-core CPU and 30-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 38-core GPU",
          type: "Apple M2 Max with 12-core CPU and 38-core GPU",
        },
      ],
      "MacBook Pro 13 inch (Touchbar)(Year 2022)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
      ],
      "MacBook Pro 16(Year 2021)": [
        {
          name: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
      ],
      "MacBook Pro 14(2021 release)": [
        {
          name: "Apple M1 Pro chip with 8-core CPU and 14-core GPU",
          type: "Apple M1 Pro chip with 8-core CPU and 14-core GPU",
        },
        {
          name: "Apple M1 Pro chip with 10-core CPU and 14-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 14-core GPU",
        },
        {
          name: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
      ],
      "Mac Mini(2023)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
        {
          name: "Apple M2 Pro with 10-core CPU and 16-core GPU",
          type: "Apple M2 Pro with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
      ],
      "Mac Mini(2020)": [
        {
          name: "3.6 GHz Intel Core i3 (8th generation)",
          type: "3.6 GHz Intel Core i3 (8th generation)",
        },
        {
          name: "3.0GHz 6-Core i5 (8th Generation)",
          type: "3.0GHz 6-Core i5 (8th Generation)",
        },
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        { name: "Apple M1 chip", type: "Apple M1 chip" },
      ],
      "Mac Mini(2018)": [
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        {
          name: "3.0GHz 6-Core i5 (8th Generation)",
          type: "3.0GHz 6-Core i5 (8th Generation)",
        },
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        {
          name: "3.6 GHz Intel Core i3 (8th generation)",
          type: "3.6 GHz Intel Core i3 (8th generation)",
        },
      ],
      "Mac Studio": [
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
        },
      ],
      "iMac 24 inch(year 2023)": [
        {
          name: "Apple M1 chip with 8-core CPU and 7-core GPU",
          type: "Apple M1 chip with 8-core CPU and 7-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
        },
      ],
      "iMac 24 inch(year 2021)": [
        {
          name: "M3 with 8-core CPU, 8-core GPU",
          type: "M3 with 8-core CPU, 8-core GPU",
        },
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
      ],
      "iMac 5K 27 inch(year 2019)": [
        {
          name: "M3 with 8-core CPU, 8-core GPU",
          type: "M3 with 8-core CPU, 8-core GPU",
        },
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
      ],
    },
    "64GB": {
      "Macbook Air 15 inch M2(year 2023)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 15 inch M3(year 2024)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13 inch M3(year 2024)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13.6 inch M2(year 2022)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13 M1(year end 2020)": [
        {
          name: "Apple M1 chip with 8-core CPU and 7-core GPU",
          type: "Apple M1 chip with 8-core CPU and 7-core GPU",
        },
        {
          name: "Apple M1 chip with 8‑core CPU and 8‑core GPU",
          type: "Apple M1 chip with 8‑core CPU and 8‑core GPU",
        },
      ],
      "Macbook Air 13(year 2020)": [
        {
          name: "1.1 GHz dual-core Intel Core i3 (10th generation)",
          type: "1.1 GHz dual-core Intel Core i3 (10th generation)",
        },
        {
          name: "1.1 GHz quad-core Intel Core i5 (10th generation)",
          type: "1.1 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "1.2 GHz quad-core Intel Core i7 (10th generation)",
          type: "1.2 GHz quad-core Intel Core i7 (10th generation)",
        },
      ],
      "MacBook Pro 13 (2020)(Year 2020)": [
        {
          name: "1.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "1.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        {
          name: "1.7 GHz quad-core Intel Core i7 (8th generation)",
          type: "1.7 GHz quad-core Intel Core i7 (8th generation)",
        },
        {
          name: "2.0 GHz quad-core Intel Core i5 (10th generation)",
          type: "2.0 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "2.0 GHz quad-core Intel Core i5 (10th generation)",
          type: "2.0 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "2.3 GHz quad-core Intel Core i7 (10th generation)",
          type: "2.3 GHz quad-core Intel Core i7 (10th generation)",
        },
        { name: "Apple M1 chip", type: "Apple M1 chip" },
      ],
      "MacBook Pro 15 (2019)(Year 2019)": [
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.4GHz 8-Core Intel Core i9",
          type: "2.4GHz 8-Core Intel Core i9",
        },
        {
          name: "2.3GHz 8-Core Intel Core i9",
          type: "2.3GHz 8-Core Intel Core i9",
        },
      ],
      "MacBook Pro 16 (2019)(Year 2019)": [
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.4GHz 8-Core Intel Core i9",
          type: "2.4GHz 8-Core Intel Core i9",
        },
        {
          name: "2.3GHz 8-Core Intel Core i9",
          type: "2.3GHz 8-Core Intel Core i9",
        },
      ],
      "MacBook Pro 13 (2019)(Year 2019)": [
        {
          name: "1.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "1.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        {
          name: "2.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "2.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        { name: "1.4GHz Dual Core i7", type: "1.4GHz Dual Core i7" },
        { name: "2.8GHz Quad Core i7", type: "2.8GHz Quad Core i7" },
      ],
      "MacBook Pro 13 (2018)(Year 2018)": [
        {
          name: "2.3 GHz dual-core Intel Core i5",
          type: "2.3 GHz dual-core Intel Core i5",
        },
        {
          name: "2.7GHz quad-core Intel Core i7",
          type: "2.7GHz quad-core Intel Core i7",
        },
        {
          name: "2.3GHz quad-core Intel Core i5",
          type: "2.3GHz quad-core Intel Core i5",
        },
      ],
      "MacBook Pro 15 (2018)(Year 2018)": [
        {
          name: "2.2GHz 6-core Intel Core i7",
          type: "2.2GHz 6-core Intel Core i7",
        },
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.9GHz 6-core Intel Core i9",
          type: "2.9GHz 6-core Intel Core i9",
        },
      ],
      "Macbook Pro 16 inch M3(year end 2023)": [
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Max chip with 14-core CPU, 30-core GPU",
          type: "M3 Max chip with 14-core CPU, 30-core GPU",
        },
        {
          name: "M3 Max chip with 16-core CPU, 40-core GPU",
          type: "M3 Max chip with 16-core CPU, 40-core GPU",
        },
      ],
      "Macbook Pro 14 inch M3(year end 2023)": [
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
        {
          name: "M3 Pro with 11-core CPU, 14-core GPU",
          type: "M3 Pro with 11-core CPU, 14-core GPU",
        },
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Max chip with 14-core CPU, 30-core GPU",
          type: "M3 Max chip with 14-core CPU, 30-core GPU",
        },
        {
          name: "M3 Max chip with 16-core CPU, 40-core GPU",
          type: "M3 Max chip with 16-core CPU, 40-core GPU",
        },
      ],
      "Macbook Pro 16 inch M2(year end 2023)": [
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 30-core GPU",
          type: "Apple M2 Max with 12-core CPU and 30-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 38-core GPU",
          type: "Apple M2 Max with 12-core CPU and 38-core GPU",
        },
      ],
      "Macbook Pro 14 inch M2(year early 2023)": [
        {
          name: "Apple M2 Pro with 10-core CPU and 16-core GPU",
          type: "Apple M2 Pro with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 30-core GPU",
          type: "Apple M2 Max with 12-core CPU and 30-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 38-core GPU",
          type: "Apple M2 Max with 12-core CPU and 38-core GPU",
        },
      ],
      "MacBook Pro 13 inch (Touchbar)(Year 2022)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
      ],
      "MacBook Pro 16(Year 2021)": [
        {
          name: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
      ],
      "MacBook Pro 14(2021 release)": [
        {
          name: "Apple M1 Pro chip with 8-core CPU and 14-core GPU",
          type: "Apple M1 Pro chip with 8-core CPU and 14-core GPU",
        },
        {
          name: "Apple M1 Pro chip with 10-core CPU and 14-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 14-core GPU",
        },
        {
          name: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
      ],
      "Mac Mini(2023)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
        {
          name: "Apple M2 Pro with 10-core CPU and 16-core GPU",
          type: "Apple M2 Pro with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
      ],
      "Mac Mini(2020)": [
        {
          name: "3.6 GHz Intel Core i3 (8th generation)",
          type: "3.6 GHz Intel Core i3 (8th generation)",
        },
        {
          name: "3.0GHz 6-Core i5 (8th Generation)",
          type: "3.0GHz 6-Core i5 (8th Generation)",
        },
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        { name: "Apple M1 chip", type: "Apple M1 chip" },
      ],
      "Mac Mini(2018)": [
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        {
          name: "3.0GHz 6-Core i5 (8th Generation)",
          type: "3.0GHz 6-Core i5 (8th Generation)",
        },
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        {
          name: "3.6 GHz Intel Core i3 (8th generation)",
          type: "3.6 GHz Intel Core i3 (8th generation)",
        },
      ],
      "Mac Studio": [
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
        },
      ],
      "iMac 24 inch(year 2023)": [
        {
          name: "Apple M1 chip with 8-core CPU and 7-core GPU",
          type: "Apple M1 chip with 8-core CPU and 7-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
        },
      ],
      "iMac 24 inch(year 2021)": [
        {
          name: "M3 with 8-core CPU, 8-core GPU",
          type: "M3 with 8-core CPU, 8-core GPU",
        },
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
      ],
      "iMac 5K 27 inch(year 2019)": [
        {
          name: "M3 with 8-core CPU, 8-core GPU",
          type: "M3 with 8-core CPU, 8-core GPU",
        },
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
      ],
    },
    "96GB": {
      "Macbook Air 15 inch M2(year 2023)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 15 inch M3(year 2024)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13 inch M3(year 2024)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13.6 inch M2(year 2022)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
      ],
      "Macbook Air 13 M1(year end 2020)": [
        {
          name: "Apple M1 chip with 8-core CPU and 7-core GPU",
          type: "Apple M1 chip with 8-core CPU and 7-core GPU",
        },
        {
          name: "Apple M1 chip with 8‑core CPU and 8‑core GPU",
          type: "Apple M1 chip with 8‑core CPU and 8‑core GPU",
        },
      ],
      "Macbook Air 13(year 2020)": [
        {
          name: "1.1 GHz dual-core Intel Core i3 (10th generation)",
          type: "1.1 GHz dual-core Intel Core i3 (10th generation)",
        },
        {
          name: "1.1 GHz quad-core Intel Core i5 (10th generation)",
          type: "1.1 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "1.2 GHz quad-core Intel Core i7 (10th generation)",
          type: "1.2 GHz quad-core Intel Core i7 (10th generation)",
        },
      ],
      "MacBook Pro 13 (2020)(Year 2020)": [
        {
          name: "1.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "1.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        {
          name: "1.7 GHz quad-core Intel Core i7 (8th generation)",
          type: "1.7 GHz quad-core Intel Core i7 (8th generation)",
        },
        {
          name: "2.0 GHz quad-core Intel Core i5 (10th generation)",
          type: "2.0 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "2.0 GHz quad-core Intel Core i5 (10th generation)",
          type: "2.0 GHz quad-core Intel Core i5 (10th generation)",
        },
        {
          name: "2.3 GHz quad-core Intel Core i7 (10th generation)",
          type: "2.3 GHz quad-core Intel Core i7 (10th generation)",
        },
        { name: "Apple M1 chip", type: "Apple M1 chip" },
      ],
      "MacBook Pro 15 (2019)(Year 2019)": [
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.4GHz 8-Core Intel Core i9",
          type: "2.4GHz 8-Core Intel Core i9",
        },
        {
          name: "2.3GHz 8-Core Intel Core i9",
          type: "2.3GHz 8-Core Intel Core i9",
        },
      ],
      "MacBook Pro 16 (2019)(Year 2019)": [
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.4GHz 8-Core Intel Core i9",
          type: "2.4GHz 8-Core Intel Core i9",
        },
        {
          name: "2.3GHz 8-Core Intel Core i9",
          type: "2.3GHz 8-Core Intel Core i9",
        },
      ],
      "MacBook Pro 13 (2019)(Year 2019)": [
        {
          name: "1.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "1.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        {
          name: "2.4 GHz quad-core Intel Core i5 (8th generation)",
          type: "2.4 GHz quad-core Intel Core i5 (8th generation)",
        },
        { name: "1.4GHz Dual Core i7", type: "1.4GHz Dual Core i7" },
        { name: "2.8GHz Quad Core i7", type: "2.8GHz Quad Core i7" },
      ],
      "MacBook Pro 13 (2018)(Year 2018)": [
        {
          name: "2.3 GHz dual-core Intel Core i5",
          type: "2.3 GHz dual-core Intel Core i5",
        },
        {
          name: "2.7GHz quad-core Intel Core i7",
          type: "2.7GHz quad-core Intel Core i7",
        },
        {
          name: "2.3GHz quad-core Intel Core i5",
          type: "2.3GHz quad-core Intel Core i5",
        },
      ],
      "MacBook Pro 15 (2018)(Year 2018)": [
        {
          name: "2.2GHz 6-core Intel Core i7",
          type: "2.2GHz 6-core Intel Core i7",
        },
        {
          name: "2.6GHz 6-core Intel Core i7",
          type: "2.6GHz 6-core Intel Core i7",
        },
        {
          name: "2.9GHz 6-core Intel Core i9",
          type: "2.9GHz 6-core Intel Core i9",
        },
      ],
      "Macbook Pro 16 inch M3(year end 2023)": [
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Max chip with 14-core CPU, 30-core GPU",
          type: "M3 Max chip with 14-core CPU, 30-core GPU",
        },
        {
          name: "M3 Max chip with 16-core CPU, 40-core GPU",
          type: "M3 Max chip with 16-core CPU, 40-core GPU",
        },
      ],
      "Macbook Pro 14 inch M3(year end 2023)": [
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
        {
          name: "M3 Pro with 11-core CPU, 14-core GPU",
          type: "M3 Pro with 11-core CPU, 14-core GPU",
        },
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Pro with 12-core CPU, 18-core GPU",
          type: "M3 Pro with 12-core CPU, 18-core GPU",
        },
        {
          name: "M3 Max chip with 14-core CPU, 30-core GPU",
          type: "M3 Max chip with 14-core CPU, 30-core GPU",
        },
        {
          name: "M3 Max chip with 16-core CPU, 40-core GPU",
          type: "M3 Max chip with 16-core CPU, 40-core GPU",
        },
      ],
      "Macbook Pro 16 inch M2(year end 2023)": [
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 30-core GPU",
          type: "Apple M2 Max with 12-core CPU and 30-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 38-core GPU",
          type: "Apple M2 Max with 12-core CPU and 38-core GPU",
        },
      ],
      "Macbook Pro 14 inch M2(year early 2023)": [
        {
          name: "Apple M2 Pro with 10-core CPU and 16-core GPU",
          type: "Apple M2 Pro with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 30-core GPU",
          type: "Apple M2 Max with 12-core CPU and 30-core GPU",
        },
        {
          name: "Apple M2 Max with 12-core CPU and 38-core GPU",
          type: "Apple M2 Max with 12-core CPU and 38-core GPU",
        },
      ],
      "MacBook Pro 13 inch (Touchbar)(Year 2022)": [
        {
          name: "Apple M2 with 8-core CPU and 8-core GPU",
          type: "Apple M2 with 8-core CPU and 8-core GPU",
        },
      ],
      "MacBook Pro 16(Year 2021)": [
        {
          name: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
      ],
      "MacBook Pro 14(2021 release)": [
        {
          name: "Apple M1 Pro chip with 8-core CPU and 14-core GPU",
          type: "Apple M1 Pro chip with 8-core CPU and 14-core GPU",
        },
        {
          name: "Apple M1 Pro chip with 10-core CPU and 14-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 14-core GPU",
        },
        {
          name: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
          type: "Apple M1 Pro chip with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
      ],
      "Mac Mini(2023)": [
        {
          name: "Apple M2 with 8-core CPU and 10-core GPU",
          type: "Apple M2 with 8-core CPU and 10-core GPU",
        },
        {
          name: "Apple M2 Pro with 10-core CPU and 16-core GPU",
          type: "Apple M2 Pro with 10-core CPU and 16-core GPU",
        },
        {
          name: "Apple M2 Pro with 12-core CPU and 19-core GPU",
          type: "Apple M2 Pro with 12-core CPU and 19-core GPU",
        },
      ],
      "Mac Mini(2020)": [
        {
          name: "3.6 GHz Intel Core i3 (8th generation)",
          type: "3.6 GHz Intel Core i3 (8th generation)",
        },
        {
          name: "3.0GHz 6-Core i5 (8th Generation)",
          type: "3.0GHz 6-Core i5 (8th Generation)",
        },
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        { name: "Apple M1 chip", type: "Apple M1 chip" },
      ],
      "Mac Mini(2018)": [
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        {
          name: "3.0GHz 6-Core i5 (8th Generation)",
          type: "3.0GHz 6-Core i5 (8th Generation)",
        },
        {
          name: "3.2GHz 6-Core i7 (8th generation)",
          type: "3.2GHz 6-Core i7 (8th generation)",
        },
        {
          name: "3.6 GHz Intel Core i3 (8th generation)",
          type: "3.6 GHz Intel Core i3 (8th generation)",
        },
      ],
      "Mac Studio": [
        {
          name: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 24-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
        },
      ],
      "iMac 24 inch(year 2023)": [
        {
          name: "Apple M1 chip with 8-core CPU and 7-core GPU",
          type: "Apple M1 chip with 8-core CPU and 7-core GPU",
        },
        {
          name: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
          type: "Apple M1 Max chip with 10-core CPU and 32-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 48-core GPU",
        },
        {
          name: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
          type: "Apple M1 Ultra chip with 20-core CPU and 64-core GPU",
        },
      ],
      "iMac 24 inch(year 2021)": [
        {
          name: "M3 with 8-core CPU, 8-core GPU",
          type: "M3 with 8-core CPU, 8-core GPU",
        },
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
      ],
      "iMac 5K 27 inch(year 2019)": [
        {
          name: "M3 with 8-core CPU, 8-core GPU",
          type: "M3 with 8-core CPU, 8-core GPU",
        },
        {
          name: "M3 with 8-core CPU, 10-core GPU",
          type: "M3 with 8-core CPU, 10-core GPU",
        },
      ],
    },
  };
  // console.log(processor["8GB"]["Macbook Air 13.6 inch M2(year 2022)"]);

  // Function to clear states below the clicked item

  let category = {
    Smartphones: [
      { name: "iPhone", type: "iPhone" },
      { name: "Samsung Galaxy", type: "Samsung Galaxy" },
      { name: "Huawei", type: "huawei" },
    ],
    Tablet: [{ name: "iPad" }, { name: "Samsung Tab" }],
    Computer: [{ name: "MacBook" }, { name: "Mac Mini" }, { name: "iMac" }],
  };

  let messageData = {
    Smartphones: "Von welcher Marke ist Ihr Smartphone?",
    Tablet: "Von welcher Marke ist Ihr Tablet?",
    Computer: "Von welcher Marke ist Ihr Computer?",

    iPhone: "Welches  iPhone haben Sie?",
    // Which  Iphone  do you have ?
    "Samsung Galaxy": "Welches Samsung Galaxy Untermodell haben Sie?",
    // Which Samsung Galaxy submodel do you have?----asking series
    Huawei: "Welches Huawei haben Sie?",
    // Which Huawei do you have ?

    iPad: "Welches  iPad Untermodell haben Sie?",

    "iPad Air": "Welches  iPad Air haben Sie?",
    "iPad Pro": "Welches  iPad Pro haben Sie?",
    "iPad mini": "Welches  iPad Mini haben Sie?",
    "Samsung Tab": "Welches Samsung Tab hast du?",

    "iphone 11 pro": "Wie ist der Zustand des Geräte?",
    // "deviceCol": 'Welche Farbe hat Ihr Gerät?',
    "Neu (verschweisst)": "Welche Farbe hat Ihr Gerät?",
    Gebraucht: "Welche Farbe hat Ihr Gerät?",
    "Mangelhaft/Defekt": "Was ist bei Ihrem Gerät mangelhaft und/oder defekt?",
    "Space Grey": "Welche Speichergröße haben Sie?",
    "Titanium Black": "Welche Speichergröße haben Sie?",

    MacBook: "Welches MacBook Untermodell haben Sie?",
    "Mac Mini": "Welchen Mac Mini hast du?",

    MacBookAir: "Welches MacBook Air hast du?",
    // Which MacBook Air do you have?
    "MacBook Pro with M processor": "Welchen Mac Mini hast du?",
    "Macbook Pro with Touch Bar": "Welches MacBook haben Sie?",
    "Mac Mini(2023)": "Welchen Mac Mini hast du?",
    "Mac Mini(2020)": "Welchen Mac Mini hast du?",
    "Mac Mini(2018)": "Welchen Mac Mini hast du?",
    "Mac Studio": "Welchen Mac Studio hast du?",

    iMac: "Welchen iMac hast du?",
    "iMac 24 inch": "Welchen iMac hast du?",
    "iMac 27 inch": "Welchen iMac hast du?",
    "Samsung Galaxy A55 5G (2024)": "Welches iMac-Untermodell haben Sie?",

    // Samsung Galaxy Series choose question------------------
    "A Series": "Welches Samsung Galaxy haben Sie?",
    "S Series": "Welches Samsung Galaxy haben Sie?",
    "Note Series": "Welches Samsung Galaxy haben Sie?",
    "Fold Flip Series": "Welches Samsung Galaxy haben Sie?",
    // Which Samsung Galaxy do you have?
    "1286SSD": "Wie viel RAM hat Ihr Gerät?",
    "256SSD": "Wie viel RAM hat Ihr Gerät?",
    "512SSD": "Wie viel RAM hat Ihr Gerät?",
    "1TBSSD": "Wie viel RAM hat Ihr Gerät?",
    "2TBSSD": "Wie viel RAM hat Ihr Gerät?",
    "4TBSSD": "Wie viel RAM hat Ihr Gerät?",
  };

  let deviceType = [
    { name: "Neu (verschweisst)", type: "Neu (verschweisst)" },
    { name: "Gebraucht", type: "Gebraucht" },
    { name: "Mangelhaft/Defekt", type: "Mangelhaft/Defekt" },
  ];

  let defective = {
    "Mangelhaft/Defekt": [
      { name: "Front glass", type: "Front glass" },
      { name: "Touch screen", type: "Touch screen" },
      { name: "LCD", type: "LCD" },
      { name: "earpiece", type: "earpiece" },
      { name: "battery", type: "battery" },
      { name: "Speakers", type: "Speakers" },
      { name: "Front camera", type: "Front camera" },
      { name: "Rear camera", type: "Rear camera" },
      { name: "Back cover glass", type: "Front glass" },
      { name: "Motherboard", type: "Motherboard" },
      { name: "SIM reader", type: "SIM reader" },
      { name: "microphone", type: "microphone" },
    ],
  };

  // console.log(deviceType)
  let Series = {
    iPad: [
      {
        name: "iPad 11th Gen Cellular (2024)",
        type: "iPad 11th Gen Cellular (2024)",
      },
      { name: "iPad 11th Gen (2024)", type: "iPad 11th Gen (2024)" },
      {
        name: "iPad 10th Gen Cellular (2022)",
        type: "iPad 10th Gen Cellular (2022)",
      },
      { name: "iPad 10th Gen (2022)", type: "iPad 10th Gen (2022)" },
      {
        name: "iPad 9th Gen 10.2 Cellular (2021)",
        type: "iPad 9th Gen 10.2 Cellular (2021)",
      },
      { name: "iPad 9th Gen (2021)", type: "iPad 9th Gen (2021)" },
      {
        name: "iPad 8th Gen Cellular (2020)",
        type: "iPad 8th Gen Cellular (2020)",
      },
      {
        name: "iPad 8th generation (2020)",
        type: "iPad 8th generation (2020)",
      },
      {
        name: "iPad 7th Gen Cellular (2019)",
        type: "iPad 7th Gen Cellular (2019)",
      },
      {
        name: "iPad 7th generation (2019)",
        type: "iPad 7th generation (2019)",
      },
      {
        name: "iPad 6th Gen Cellular (2018)",
        type: "iPad 6th Gen Cellular (2018)",
      },
      {
        name: "iPad 6th generation (2018)",
        type: "iPad 6th generation (2018)",
      },
    ],

    "iPad Air": [
      {
        name: "iPad Air 13 6th Gen Cellular 2024",
        type: "iPad Air 13 6th Gen Cellular 2024",
      },
      {
        name: "iPad Air 13 6th Gen Wifi 2024",
        type: "iPad Air 13 6th Gen Wifi 2024",
      },
      {
        name: "iPad Air 6th Gen Cellular 2024",
        type: "iPad Air 6th Gen Cellular 2024",
      },
      {
        name: "iPad Air 6th Gen Wi-Fi 2024",
        type: "iPad Air 6th Gen Wi-Fi 2024",
      },
      {
        name: "iPad Air 5th Gen Cellular 2022",
        type: "iPad Air 5th Gen Cellular 2022",
      },
      {
        name: "iPad Air 5th Gen Wi-Fi 2022",
        type: "iPad Air 5th Gen Wi-Fi 2022",
      },
      {
        name: "iPad Air 4th Gen Cellular 2020",
        type: "iPad Air 4th Gen Cellular 2020",
      },
      { name: "iPad Air 4th Gen 2020", type: "iPad Air 4th Gen 2020" },
      { name: "iPad Air 3rd Gen Cellular", type: "iPad Air 3rd Gen Cellular" },
      { name: "iPad Air 3rd Gen", type: "iPad Air 3rd Gen" },
    ],
    "iPad Pro": [
      {
        name: "iPad Pro 13 Cellular 1st Gen (2024)",
        type: "iPad Pro 13 Cellular 1st Gen (2024)",
      },
      {
        name: "iPad Pro 13 1st Gen (2024)",
        type: "iPad Pro 13 1st Gen (2024)",
      },
      {
        name: "iPad Pro 12.9 Cellular 6th Gen (2022)",
        type: "iPad Pro 12.9 Cellular 6th Gen (2022)",
      },
      {
        name: "iPad Pro 12.9 Wifi 6th Gen (2022)",
        type: "iPad Pro 12.9 Wifi 6th Gen (2022)",
      },
      {
        name: "iPad Pro 12.9 Cellular 5th Gen (2021)",
        type: "iPad Pro 12.9 Cellular 5th Gen (2021)",
      },
      {
        name: "iPad Pro 12.9 Wifi 5th Gen (2021)",
        type: "iPad Pro 12.9 Wifi 5th Gen (2021)",
      },
      {
        name: "iPad Pro 12.9 Cellular 4th Gen (2020)",
        type: "iPad Pro 12.9 Cellular 4th Gen (2020)",
      },
      {
        name: "iPad Pro 12.9 Wi-Fi 4th Gen (2020)",
        type: "iPad Pro 12.9 Wi-Fi 4th Gen (2020)",
      },
      {
        name: "iPad Pro 12.9 Cellular 3rd Gen (2018)",
        type: "iPad Pro 12.9 Cellular 3rd Gen (2018)",
      },
      {
        name: "iPad Pro 12.9 Wifi 3rd Gen (2018)",
        type: "iPad Pro 12.9 Wifi 3rd Gen (2018)",
      },
      {
        name: "iPad Pro 12.9 Cellular 2nd Gen (2017)",
        type: "iPad Pro 12.9 Cellular 2nd Gen (2017)",
      },
      {
        name: "iPad Pro 12.9 2nd Gen (2017)",
        type: "iPad Pro 12.9 2nd Gen (2017)",
      },
      {
        name: "iPad Pro 11 Cellular 5th Gen (2024)",
        type: "iPad Pro 11 Cellular 5th Gen (2024)",
      },
      {
        name: "iPad Pro 11 Wi-Fi 5th Gen (2024)",
        type: "iPad Pro 11 Wi-Fi 5th Gen (2024)",
      },
      {
        name: "iPad Pro 11 Cellular 4th Gen (2022)",
        type: "iPad Pro 11 Cellular 4th Gen (2022)",
      },
      {
        name: "iPad Pro 11 Wi-Fi 4th Gen (2022)",
        type: "iPad Pro 11 Wi-Fi 4th Gen (2022)",
      },
      {
        name: "iPad Pro 11 Cellular 3rd Gen (2021)",
        type: "iPad Pro 11 Cellular 3rd Gen (2021)",
      },
      {
        name: "iPad Pro 11 Wi-Fi 3rd Gen (2021)",
        type: "iPad Pro 11 Wi-Fi 3rd Gen (2021)",
      },
      {
        name: "iPad Pro 11 Cellular 2nd Gen (2020)",
        type: "iPad Pro 11 Cellular 2nd Gen (2020)",
      },
      {
        name: "iPad Pro 11 2nd Gen (2020)",
        type: "iPad Pro 11 2nd Gen (2020)",
      },
      {
        name: "iPad Pro 11 1st Gen Cellular (2018)",
        type: "iPad Pro 11 1st Gen Cellular (2018)",
      },
      {
        name: "iPad Pro 11 1st Gen Wi-Fi (2018)",
        type: "iPad Pro 11 1st Gen Wi-Fi (2018)",
      },
      {
        name: "iPad Pro 10.5 Cellular (2017)",
        type: "iPad Pro 10.5 Cellular (2017)",
      },
      { name: "iPad Pro 10.5 (2017)", type: "iPad Pro 10.5 (2017)" },
    ],
    "iPad mini": [
      { name: "iPad Mini 6 Cellular", type: "iPad Mini 6 Cellular" },
      { name: "iPad mini 6", type: "iPad mini 6" },
      { name: "iPad Mini 5 Cellular", type: "iPad Mini 5 Cellular" },
      { name: "iPad mini 5", type: "iPad mini 5" },
    ],

    // Samsung Galaxy Series and their submodel --------------
    "A Series": [
      {
        name: "Samsung Galaxy A55 5G (2024)",
        type: "Samsung Galaxy A55 5G (2024)",
      },
      {
        name: "Samsung Galaxy A35 5G (2024)",
        type: "Samsung Galaxy A35 5G (2024)",
      },
      {
        name: "Samsung Galaxy A25 5G (2024)",
        type: "Samsung Galaxy A25 5G (2024)",
      },
      {
        name: "Samsung Galaxy A15 5G (2024)",
        type: "Samsung Galaxy A15 5G (2024)",
      },
      {
        name: "Samsung Galaxy A15 4G (2024)",
        type: "Samsung Galaxy A15 4G (2024)",
      },
      {
        name: "Samsung Galaxy A54 5G (2023)",
        type: "Samsung Galaxy A54 5G (2023)",
      },
      {
        name: "Samsung Galaxy A34 5G (2023)",
        type: "Samsung Galaxy A34 5G (2023)",
      },
      {
        name: "Samsung Galaxy A73 5G (2022)",
        type: "Samsung Galaxy A73 5G (2022)",
      },
      {
        name: "Samsung Galaxy A53 5G (2022)",
        type: "Samsung Galaxy A53 5G (2022)",
      },
      {
        name: "Samsung Galaxy A33 5G (2022)",
        type: "Samsung Galaxy A33 5G (2022)",
      },
      {
        name: "Samsung Galaxy A72 5G (2021)",
        type: "Samsung Galaxy A72 5G (2021)",
      },
      {
        name: "Samsung Galaxy A52s 5G (2021)",
        type: "Samsung Galaxy A52 5G (2021)",
      },
      {
        name: "Samsung Galaxy A52 4G (2021)",
        type: "Samsung Galaxy A52 4G (2021)",
      },
      {
        name: "Samsung  A51",
        type: "Samsung  A51",
      },
      {
        name: "Samsung Galaxy A42 5G (2020)",
        type: "Samsung Galaxy A42 5G (2020)",
      },
      {
        name: "Samsung Galaxy A32 5G (2021)",
        type: "Samsung Galaxy A32 5G (2021)",
      },
      {
        name: "Samsung Galaxy A32 4G (2021)",
        type: "Samsung Galaxy A32 4G (2021)",
      },
    ],

    "S Series": [
      { name: "Galaxy S24 Ultra", type: "Galaxy S24 Ultra" },
      { name: "Galaxy S24+", type: "Galaxy S24+" },
      { name: "GalaxyS24", type: "GalaxyS24" },
      { name: "Galaxy S23 FE", type: "Galaxy S23 FE" },
      { name: "Galaxy S23 Ultra", type: "Galaxy S23 Ultra" },
      { name: "GalaxyS23+", type: "GalaxyS23+" },
      { name: "GalaxyS23", type: "GalaxyS23" },
      { name: "Galaxy S22 Ultra", type: "Galaxy S22 Ultra" },
      { name: "Galaxy S22+", type: "Galaxy S22+" },
      { name: "GalaxyS22", type: "GalaxyS22" },
      { name: "Galaxy S21 FE 5G", type: "Galaxy S21 FE 5G" },
      { name: "Galaxy S21 Ultra", type: "Galaxy S21 Ultra" },
      { name: "Galaxy S21+", type: "Galaxy S21+" },
      { name: "Samsung Galaxy S21", type: "Samsung Galaxy S21" },
      { name: "Galaxy S10 Lite", type: "Series" },
      { name: "Galaxy S10 Lite", type: "Galaxy S10 Lite" },
      { name: "Galaxy S20 Ultra 5G", type: "Galaxy S20 Ultra 5G" },
      { name: "Galaxy S20+ 5G", type: "Galaxy S20+ 5G" },
      { name: "Samsung Galaxy S20+", type: "Samsung Galaxy S20+" },
      { name: "Samsung Galaxy S20 5G", type: "Samsung Galaxy S20 5G" },
      { name: "Samsung Galaxy S20 4G", type: "Samsung Galaxy S20 4G" },
      { name: "Galaxy S20 FE 5G", type: "Galaxy S20 FE 5G" },
      { name: "Galaxy S20 FE 4G", type: "Galaxy S20 FE 4G" },
      { name: "Samsung Galaxy S10 5G", type: "Samsung Galaxy S10 5G" },
      { name: "GalaxyS10+", type: "GalaxyS10+" },
      { name: "Samsung Galaxy S10", type: "Samsung Galaxy S10" },
    ],
    "Note Series": [
      { name: "Galaxy Note 20 Ultra 5G", type: "Galaxy Note 20 Ultra 5G" },
      { name: "Galaxy Note 20 Ultra", type: "Galaxy Note 20 Ultra" },
      { name: "Galaxy Note20", type: "Galaxy Note20" },
      { name: "Galaxy Note10+ 5G", type: "Galaxy Note10+ 5G" },
      { name: "Galaxy Note10+", type: "Galaxy Note10+" },
      { name: "Galaxy Note 10 Lite", type: "Galaxy Note 10 Lite" },
      { name: "Galaxy Note10", type: "Galaxy Note10" },
    ],

    "Fold Flip Series": [
      { name: "Galaxy Z Fold6", type: "Galaxy Z Fold6" },
      { name: "Galaxy Z Fold5", type: "Galaxy Z Fold5" },
      { name: "Galaxy Z Flip6", type: "Galaxy Z Flip6" },
      { name: "Galaxy Z Flip5", type: "Galaxy Z Flip5" },
    ],

    MacBookAir: [
      {
        name: "Macbook Air 15 inch M3(year 2024)",
        type: "Macbook Air 15 inch M3(year 2024)",
      },
      {
        name: "Macbook Air 13 inch M3(year 2024)",
        type: "Macbook Air 13 inch M3(year 2024)",
      },
      {
        name: "Macbook Air 15 inch M2(year 2023",
        type: "Macbook Air 15 inch M2(year 2023)",
      },
      {
        name: "Macbook Air 13.6 inch M2(year 2022)",
        type: "Macbook Air 13.6 inch M2(year 2022)",
      },
      {
        name: "Macbook Air 13 M1(year end 2020)",
        type: "Macbook Air 13 M1(year end 2020)",
      },
      { name: "Macbook Air 13(year 2020)", type: "Macbook Air 13(year 2020)" },
      { name: "Macbook Air 13(year 2019)", type: "Macbook Air 13(year 2019)" },
      { name: "Macbook Air 13(year 2018)", type: "Macbook Air 13(year 2018)" },
    ],
    "Macbook Pro with Touch Bar": [
      {
        name: "MacBook Pro 13 (2020)(Year 2020)",
        type: "MacBook Pro 13 (2020)(Year 2020)",
      },
      {
        name: "MacBook Pro 16 (2019)(Year 2019)",
        type: "MacBook Pro 16 (2019)(Year 2019)",
      },
      {
        name: "MacBook Pro 15 (2019)(Year 2019)",
        type: "MacBook Pro 15 (2019)(Year 2019)",
      },
      {
        name: "MacBook Pro 13 (2018)(Year 2018",
        type: "MacBook Pro 13 (2018)(Year 2018)",
      },
      {
        name: "MacBook Pro 13 (2019)(Year 2019)",
        type: "MacBook Pro 13 (2019)(Year 2019)",
      },
      {
        name: "MacBook Pro 15 (2018)(Year 2018)",
        type: "MacBook Pro 15 (2018)(Year 2018)",
      },
    ],

    "Mac Min": [
      { name: "Mac Mini(2023)", type: "Mac Mini(2023)" },
      { name: "Mac Mini(2020)", type: "Mac Mini(2020)" },
      { name: "Mac Mini(2018)", type: "Mac Mini(2018)" },
      { name: "Mac Studio", type: "Mac Studio" },
    ],
    "Mac Mini(2020)": [{ name: "Mac Mini(2020)", type: "Mac Mini(2020)" }],
    "Mac Mini(2018)": [{ name: "Mac Mini(2018)", type: "Mac Mini(2018)" }],
    "Mac Studio": [{ name: "Mac Studio", type: "Mac Studio" }],

    "MacBook Pro with M processor": [
      {
        name: "Macbook Pro 16 inch M3(year end 2023)",
        type: "Macbook Pro 16 inch M3(year end 2023)",
      },
      {
        name: "Macbook Pro 14 inch M3(year end 2023)",
        type: "Macbook Pro 14 inch M3(year end 2023)",
      },
      {
        name: "Macbook Pro 16 inch M2(year early 2023)",
        type: "Macbook Pro 16 inch M2(year early 2023)",
      },
      {
        name: "Macbook Pro 14 inch M2(year early 2023)",
        type: "Macbook Pro 14 inch M2(year early 2023)",
      },
      {
        name: "MacBook Pro 13 inch (Touchbar)(Year 2022)",
        type: "MacBook Pro 13 inch (Touchbar)(Year 2022)",
      },
      { name: "MacBook Pro 16(Year 2021)", type: "MacBook Pro 16(Year 2021)" },
      {
        name: "MacBook Pro 14(2021 release)",
        type: "MacBook Pro 14(2021 release)",
      },
    ],
    "iMac 27 inch": [
      {
        name: "iMac 5K 27 inch(year 2019)",
        type: "iMac 5K 27 inch(year 2019)",
      },
    ],
    "iMac 24 inch": [
      { name: "iMac 24 inch(year 2023)", type: "iMac 24 inch(year 2023)" },
      { name: "iMac 24 inch(year 2021)", type: "iMac 24 inch(year 2021)" },
    ],
  };

  let color = {
    "iPad 11th Gen Cellular (2024)": [
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Yellow",
        type: "Yellow",
        Yellow: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Pink",
        type: "Pink",
        Pink: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPad 11th Gen (2024)": [
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Yellow",
        type: "Yellow",
        Yellow: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Pink",
        type: "Pink",
        Pink: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPad 10th Gen Cellular (2022)": [
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Yellow",
        type: "Yellow",
        Yellow: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Rose",
        type: "Rose",
        Rose: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPad 10th Gen (2022)": [
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Yellow",
        type: "Yellow",
        Yellow: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Rose",
        type: "Rose",
        Rose: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPad 9th Gen 10.2 Cellular (2021)": [
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Spec Grey",
        type: "Spec Grey",
        "Spec Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPad 9th Gen (2021)": [
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Spec Grey",
        type: "Spec Grey",
        "Spec Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPad 8th Gen Cellular (2020)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "32GB", type: "32GB" },
          { name: "64GB", type: "64GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "32GB", type: "32GB" },
          { name: "64GB", type: "64GB" },
        ],
      },
      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "32GB", type: "32GB" },
          { name: "64GB", type: "64GB" },
        ],
      },
    ],

    "iPad 7th Gen Cellular (2019": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "32GB", type: "32GB" },
          { name: "128GB", type: "128GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "32GB", type: "32GB" },
          { name: "128GB", type: "128GB" },
        ],
      },
      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "32GB", type: "32GB" },
          { name: "128GB", type: "128GB" },
        ],
      },
    ],
    "iPad 7th generation (2019)": [
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "32GB", type: "32GB" },
          { name: "128GB", type: "128GB" },
        ],
      },
      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "32GB", type: "32GB" },
          { name: "128GB", type: "128GB" },
        ],
      },
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "32GB", type: "32GB" },
          { name: "128GB", type: "128GB" },
        ],
      },
    ],
    "iPad 6th Gen Cellular (2018)": [
      {
        name: "Silver",
        type: "Silver",
        Silver: [{ name: "32GB" }, { name: "128GB" }],
      },
      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "32GB", type: "32GB" },
          { name: "128GB", type: "128GB" },
        ],
      },
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "32GB", type: "32GB" },
          { name: "128GB", type: "128GB" },
        ],
      },
    ],
    "iPad 6th generation (2018)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "32GB", type: "32GB" },
          { name: "64GB", type: "64GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "64Gb" },
        ],
      },
      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "64Gb" },
        ],
      },
    ],

    //  I Pad Air

    "iPad Air 13 6th Gen Cellular 2024": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Violet",
        type: "Violet",
        Violet: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Air 13 6th Gen Wifi 2024": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Violet",
        type: "Violet",
        Violet: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Air 6th Gen Cellular 2024": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Violet",
        type: "Violet",
        Violet: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Air 6th Gen Wi-Fi 2024": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Violet",
        type: "Violet",
        Violet: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Air 5th Gen Cellular 2022": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Violet",
        type: "Violet",
        Violet: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Rose",
        type: "Rose",
        Rose: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPad Air 5th Gen Wi-Fi 2022": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Violet",
        type: "Violet",
        Violet: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Rose",
        type: "Rose",
        Rose: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPad Air 4th Gen Cellular 2020": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Sky Blue",
        type: "Sky Blue",
        "Sky Blue": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Green",
        type: "Green",
        Green: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Rose Gold",
        type: "Rose Gold",
        "Rose Gold": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPad Air 4th Gen 2020": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Sky Blue",
        type: "Sky Blue",
        "Sky Blue": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Green",
        type: "Green",
        Green: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Rose Gold",
        type: "Rose Gold",
        "Rose Gold": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPad Air 3rd Gen Cellular": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPad Air 3rd Gen": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],

    //  I pad mini

    "iPad Mini 6 Cellular": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Pink",
        type: "Pink",
        Pink: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Voilet",
        type: "Voilet",
        Voilet: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: " Starlight",
        type: "Starlight",
        Starlight: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPad mini 6": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Pink",
        type: "Pink",
        Pink: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Voilet",
        type: "Voilet",
        Voilet: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: " Starlight",
        type: "Starlight",
        Starlight: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPad Mini 5 Cellular": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPad mini 5": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],

    // I pad Pro
    "iPad Pro 13 Cellular 1st Gen (2024)": [
      {
        name: "Space Black",
        type: "Space Black",
        "Space Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
    ],
    "iPad Pro 13 1st Gen (2024)": [
      {
        name: "Space Black",
        type: "Space Black",
        "Space Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
    ],
    "iPad Pro 12.9 Cellular 6th Gen (2022)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
    ],
    "iPad Pro 12.9 Wifi 6th Gen (2022)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
    ],
    "iPad Pro 12.9 Wifi 5th Gen (2021)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
    ],
    "iPad Pro 12.9 Cellular 4th Gen (2020)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
    ],
    "iPad Pro 12.9 Wi-Fi 4th Gen (2020)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
    ],
    "iPad Pro 12.9 Cellular 3rd Gen (2018": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Pro 12.9 Wifi 3rd Gen (2018)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Pro 12.9 Cellular 2nd Gen (2017": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Pro 12.9 2nd Gen (2017)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Pro 11 Cellular 5th Gen (2024)": [
      {
        name: "Space Black",
        type: "Space Black",
        "Space Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB" },
          { name: "512GB" },
          { name: "1TB" },
          { name: "2TB" },
        ],
      },
    ],
    "iPad Pro 11 Wi-Fi 5th Gen (2024)": [
      {
        name: "Space Black",
        type: "Space Black",
        "Space Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
    ],
    "iPad Pro 11 Cellular 4th Gen (2022)": [
      {
        name: "Space Black",
        type: "Space Black",
        "Space Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
          { name: "2TB", type: "2TB" },
        ],
      },
    ],
    "iPad Pro 11 Wi-Fi 4th Gen (2022)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Pro 11 Cellular 3rd Gen (2021)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Pro 11 Wi-Fi 3rd Gen (2021)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Pro 11 Cellular 2nd Gen (2020)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Pro 11 2nd Gen (2020)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Pro 11 1st Gen Cellular (2018)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Pro 11 1st Gen Wi-Fi (2018)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Pro 11 1st Gen Cellular (2018)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Pro 10.5 Cellular (2017)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iPad Pro 10.5 (2017)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    //  Computer

    // macBook Air
    "Macbook Air 15 inch M3(year 2024)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "midnight",
        type: "midnight",
        midnight: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
    ],
    "Macbook Air 13 inch M3(year 2024)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "midnight",
        type: "midnight",
        midnight: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
    ],
    "Macbook Air 15 inch M2(year 2023)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "midnight",
        type: "midnight",
        midnight: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
    ],
    "Macbook Air 13.6 inch M2(year 2022)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "midnight",
        type: "midnight",
        midnight: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
    ],
    "Macbook Air 13 M1(year end 2020)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "midnight",
        type: "midnight",
        midnight: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
    ],
    "Macbook Air 13(year 2020)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "midnight",
        type: "midnight",
        midnight: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
    ],
    "Macbook Air 13(year 2018)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
        ],
      },
      {
        name: "midnight",
        type: "midnight",
        midnight: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
        ],
      },
    ],
    "Macbook Air 13(year 2019)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB SSD" },
          { name: "128GB", type: "128GB SSD" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB SSD" },
          { name: "128GB", type: "128GB SSD" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
        ],
      },
      {
        name: "midnight",
        type: "midnight",
        midnight: [
          { name: "64GB", type: "64GB SSD" },
          { name: "128GB", type: "128GB SSD" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "64GB", type: "64GB SSD" },
          { name: "128GB", type: "128GB SSD" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
        ],
      },
    ],

    //    Mac book Pro
    "MacBook Pro 13 (2020)(Year 2020)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
    ],
    "MacBook Pro 16 (2019)(Year 2019)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
    ],
    "MacBook Pro 15 (2019)(Year 2019)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
    ],
    "MacBook Pro 13 (2018)(Year 2018)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
    ],
    "Macbook Pro 14 inch M2(year early 2023)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
    ],
    "MacBook Pro 13 (2019)(Year 2019)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
    ],
    "MacBook Pro 15 (2018)(Year 2018)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
          ,
        ],
      },
    ],
    "Macbook Pro 16 inch M2(year early 2023)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
    ],
    "Macbook Pro 14 inch M3(year end 2023)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
    ],
    // MacBook Pro Processor

    "Macbook Pro 16 inch M3(year end 2023)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
    ],
    "MacBook Pro 16 (2019)(Year 2019)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
    ],
    "MacBook Pro 15 (2019)(Year 2019)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
    ],
    "MacBook Pro 13 (2018)(Year 2018)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
    ],
    "MacBook Pro 13 (2019)(Year 2019)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
    ],
    "MacBook Pro 15 (2018)(Year 2018)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
        ],
      },
    ],
    //   Mac Studio

    "Mac Mini(2023)": [
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
          { name: "4TB SSD", type: "4TB SSD" },
          { name: "8TB SSD", type: "8TB SSD" },
        ],
      },
    ],
    "Mac Mini(2020)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "128GB SSD", type: "128GB SSD" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB SSD", type: "128GB SSD" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
    ],
    "Mac Mini(2018)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "128GB SSD", type: "128GB SSD" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
    ],
    "Mac Studio": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "128GB SSD", type: "128GB SSD" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
    ],
    // Imac

    "iMac 5K 27 inch(year 2019)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "128GB SSD", type: "128GB SSD" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "512GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
    ],
    "iMac 24 inch(year 2023)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "128GB SSD", type: "128GB SSD" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "256GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
    ],
    "iMac 24 inch(year 2021)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "128GB SSD", type: "128GB SSD" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "256GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
    ],
    "iMac 5K 27 inch(year 2019)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "128GB SSD", type: "128GB SSD" },
          { name: "256GB SSD", type: "256GB SSD" },
          { name: "512GB SSD", type: "256GB SSD" },
          { name: "1TB SSD", type: "1TB SSD" },
          { name: "2TB SSD", type: "2TB SSD" },
        ],
      },
    ],
    // SasmSung

    "Galaxy S24 Ultra": [
      {
        name: "Titanium Black",
        type: "Titanium Black",
        "Titanium Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Titanium violet",
        type: "Titanium violet",
        "Titanium violet": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Titanium grey",
        type: "Titanium grey",
        "Titanium grey": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Titanium yellow",
        type: "Titanium yellow",
        "Titanium yellow": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Titanium Green",
        type: "Titanium Green",
        "Titanium Green": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Titanium Blue",
        type: "Titanium Blue",
        "Titanium Blue": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],

    "Galaxy S24+": [
      {
        name: "Black Onyx",
        type: "Black Onyx",
        "Black Onyx": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Marble grey",
        type: "Marble grey",
        "Marble grey": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Amber yellow",
        type: "Amber yellow",
        "Amber yellow": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Cobalt violet",
        type: "Cobalt violet",
        "Cobalt violet": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Sapphire Blue",
        type: "Sapphire Blue",
        "Sapphire Blue": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Jade Green",
        type: "Jade Green",
        "Jade Green": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Sandstone Orange",
        type: "Sandstone Orange",
        "Sandstone Orange": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    GalaxyS24: [
      {
        name: "Black Onyx",
        type: "Black Onyx",
        "Black Onyx": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Marble grey",
        type: "Marble grey",
        "Marble grey": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Amber yellow",
        type: "Amber yellow",
        "Amber yellow": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Cobalt violet",
        type: "Cobalt violet",
        "Cobalt violet": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Sapphire Blue",
        type: "Sapphire Blue",
        "Sapphire Blue": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Jade Green",
        type: "Jade Green",
        "Jade Green": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Sandstone Orange",
        type: "Sandstone Orange",
        "Sandstone Orange": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "Galaxy S23 FE": [
      {
        name: "Mint",
        type: "Mint",
        Mint: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Purple",
        type: "Purple",
        Purple: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Cream",
        type: "Cream",
        Cream: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "Galaxy S23 Ultra": [
      {
        name: "Green",
        type: "Green",
        Green: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Lavender",
        type: "Lavender",
        Lavender: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Cream",
        type: "Cream",
        Cream: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Phantom Black",
        type: "Phantom Black",
        "Phantom Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Lime",
        type: "Lime",
        Lime: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Red",
        type: "Red",
        Red: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Sky Blue",
        type: "Sky Blue",
        "Sky Blue": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "GalaxyS23+": [
      {
        name: "Green",
        type: "Green",
        Green: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Lavender",
        type: "Lavender",
        Lavender: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Cream",
        type: "Cream",
        Cream: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Phantom Black",
        type: "Phantom Black",
        "Phantom Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Lime",
        type: "Lime",
        Lime: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    GalaxyS23: [
      {
        name: "Green",
        type: "Green",
        Green: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Lavender",
        type: "Lavender",
        Lavender: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Cream",
        type: "Cream",
        Cream: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Phantom Black",
        type: "Phantom Black",
        "Phantom Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Lime",
        type: "Lime",
        Lime: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "Galaxy S22 Ultra": [
      {
        name: "Phantom Black",
        type: "Phantom Black",
        "Phantom Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },

      {
        name: "White",
        type: "White",
        White: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Red",
        type: "Red",
        Red: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Sky Blue",
        type: "Sky Blue",
        "Sky Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "Galaxy S22+": [
      {
        name: "Phantom Black",
        type: "Phantom Black",
        "Phantom Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "White",
        type: "White",
        White: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Pink Gold",
        type: "Pink Gold",
        "Pink Gold": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Sky Blue",
        type: "Sky Blue",
        "Sky Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Voilet",
        type: "Voilet",
        Voilet: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy S22": [
      {
        name: "Phantom Black",
        type: "Phantom Black",
        "Phantom Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "White",
        type: "White",
        White: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Pink Gold",
        type: "Pink Gold",
        "Pink Gold": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Sky Blue",
        type: "Sky Blue",
        "Sky Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Voilet",
        type: "Voilet",
        Voilet: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy S21 FE 5G": [
      {
        name: "White",
        type: "White",
        White: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Levender",
        type: "Levender",
        Levender: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Green",
        type: "Green",
        Green: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy S21 Ultra": [
      {
        name: "Phantom Black",
        type: "Phantom Black",
        "Phantom Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Phantom Silver",
        type: "Phantom Silver",
        "Phantom Silver": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Phantom Brown",
        type: "Phantom Brown",
        "Phantom Brown": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy S21+": [
      {
        name: "Phantom Black",
        type: "Phantom Black",
        "Phantom Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Phantom Silver",
        type: "Phantom Silver",
        "Phantom Silver": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Phantom Silver",
        type: "Phantom Silver",
        "Phantom Silver": [{ name: "128GB" }, { name: "256GB" }],
      },
      {
        name: "Phantom Pink",
        type: "Phantom Pink",
        "Phantom Pink": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Samsung Galaxy S21": [
      {
        name: "Phantom Gray",
        type: "Phantom Gray",
        "Phantom Gray": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Phantom White",
        type: "Phantom White",
        "Phantom Silver": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Phantom Voilet",
        type: "Phantom Voilet",
        "Phantom Voilet": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Phantom Pink",
        type: "Phantom Pink",
        "Phantom Pink": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy S10 Lite": [
      {
        name: "Prism Black",
        type: "Prism Black",
        "Prism Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Prism Blue",
        type: "Prism Blue",
        "Prism Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Prism White",
        type: "Prism White",
        "Prism White": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy S20 Ultra 5G": [
      {
        name: "Cloud Lavender",
        type: "Cloud Lavender",
        "Cloud Lavender": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Cloud Mint",
        type: "Cloud Mint",
        "Cloud Mint": [{ name: "128GB", type: "128GB" }],
      },
      {
        name: "Cloud White",
        type: "Cloud White",
        "Cloud White": [{ name: "128GB", type: "128GB" }],
      },
      {
        name: "Cloud Navy",
        type: "Cloud Navy",
        "Cloud Navy": [{ name: "128GB", type: "128GB" }],
      },
      {
        name: "Cloud Red",
        type: "Cloud Red",
        "Cloud Red": [{ name: "128GB", type: "128GB" }],
      },
      {
        name: "Cloud Orange",
        type: "Cloud Orange",
        "Cloud Orange": [{ name: "128GB", type: "128GB" }],
      },
    ],
    "Galaxy S20+ 5G": [
      {
        name: "Cosmic Black",
        type: "Cosmic Black",
        "Cosmic Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Cloud Blue",
        type: "Cloud Blue",
        "Cloud Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cosmic Grey",
        type: "Cosmic Grey",
        "Cosmic Grey": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cloud White",
        type: "Cloud White",
        "Cloud White": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Samsung Galaxy S20+": [
      {
        name: "Cosmic Black",
        type: "Cosmic Black",
        "Cosmic Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Cloud Blue",
        type: "Cloud Blue",
        "Cloud Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cosmic Grey",
        type: "Cosmic Grey",
        "Cosmic Grey": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Samsung Galaxy S20 5G": [
      {
        name: "Cloud Pink",
        type: "Cloud Pink",
        "Cloud Pink": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Cloud Blue",
        type: "Cloud Blue",
        "Cloud Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cosmic Grey",
        type: "Cosmic Grey",
        "Cosmic Grey": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cloud White",
        type: "Cloud White",
        "Cloud White": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],

    "Samsung Galaxy S20 4G": [
      {
        name: "Cloud Pink",
        type: "Cloud Pink",
        "Cloud Pink": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Cloud Blue",
        type: "Cloud Blue",
        "Cloud Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cosmic Grey",
        type: "Cosmic Grey",
        "Cosmic Grey": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy S20 FE 5G": [
      {
        name: "Cloud Mint",
        type: "Cloud Mint",
        "Cloud Mint": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Cloud Blue",
        type: "Cloud Blue",
        "Cloud Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cloud Lavender",
        type: "Cloud Lavender",
        "Cloud Lavender": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cloud White",
        type: "Cloud White",
        "Cloud White": [{ name: "128GB" }, { name: "256GB" }],
      },
      {
        name: "Cloud Navy",
        type: "Cloud Navy",
        "Cloud Navy": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cloud Red",
        type: "Cloud Red",
        "Cloud Red": [
          { name: "128GB" },
          { name: "256GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cloud Orange",
        type: "Cloud Orange",
        "Cloud Orange": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy S20 FE 4G": [
      {
        name: "Cloud Mint",
        type: "Cloud Mint",
        "Cloud Mint": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Cloud Blue",
        type: "Cloud Blue",
        "Cloud Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cloud Lavender",
        type: "Cloud Lavender",
        "Cloud Lavender": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cloud White",
        type: "Cloud White",
        "Cloud White": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cloud Navy",
        type: "Cloud Navy",
        "Cloud Navy": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cloud Red",
        type: "Cloud Red",
        "Cloud Red": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cloud Orange",
        type: "Cloud Orange",
        "Cloud Orange": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],

    "Samsung Galaxy S10 5G": [
      {
        name: "Crown Silver",
        type: "Crown Silver",
        "Crown Silver": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Majestic Black",
        type: "Majestic Black",
        "Majestic Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],

    "GalaxyS10+": [
      {
        name: "Prism White",
        type: "Prism White",
        "Prism White": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Prism Black",
        type: "Prism Black",
        "Prism Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Prism Blue",
        type: "Prism Blue",
        "Prism Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Prism Green",
        type: "Prism Green",
        "Prism Green": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Ceramic White",
        type: "Ceramic White",
        "Ceramic White": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Ceramic Black",
        type: "Ceramic Black",
        "Ceramic Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Cardinal Red",
        type: "Cardinal Red",
        "Cardinal Red": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Samsung Galaxy S10": [
      {
        name: "Prism White",
        type: "Prism White",
        "Prism White": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Prism Black",
        type: "Prism Black",
        "Prism Black": [
          { name: "128GB", type: "128GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Prism Blue",
        type: "Prism Blue",
        "Prism Blue": [
          { name: "128GB", type: "128GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Prism Green",
        type: "Prism Green",
        "Prism Green": [
          { name: "128GB", type: "128GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Ceramic White",
        type: "Ceramic White",
        "Ceramic White": [
          { name: "128GB", type: "128GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Ceramic Black",
        type: "Ceramic Black",
        "Ceramic Black": [
          { name: "128GB", type: "128GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Cardinal Red",
        type: "Cardinal Red",
        "Cardinal Red": [
          { name: "128GB", type: "128GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],

    "Galaxy Note 20 Ultra 5G": [
      {
        name: "Mystic White",
        type: "Mystic White",
        "Mystic White": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Mystic Black",
        type: "Mystic Black",
        "Mystic Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Mystic Bronze",
        type: "Mystic Bronze",
        "Mystic Bronze": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],

    "Galaxy Note 20 Ultra": [
      {
        name: "Mystic Bronze",
        type: "Mystic Bronze",
        "Mystic Bronze": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Mystic Black",
        type: "Mystic Black",
        "Mystic Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Mystic White",
        type: "Mystic White",
        "Mystic White": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "Galaxy Note20": [
      {
        name: "Mystic Green",
        type: "Mystic Green",
        "Mystic Green": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Mystic Bronze",
        type: "Mystic Bronze",
        "Mystic Bronze": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Mystic Gray",
        type: "Mystic Gray",
        "Mystic Gray": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Mystic Blue",
        type: "Mystic Blue",
        "Mystic Blue": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Mystic Red",
        type: "Mystic Red",
        "Mystic Red": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "Galaxy Note10+ 5G": [
      {
        name: "Aura Glow",
        type: "Aura Glow",
        "Aura Glow": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Aura Black",
        type: "Aura Black",
        "Aura Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "Galaxy Note10+": [
      {
        name: "Aura White",
        type: "Aura White",
        "Aura White": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Aura Glow",
        type: "Aura Glow",
        "Aura Glow": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Aura Black",
        type: "Aura Black",
        "Aura Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "Galaxy Note 10 Lite": [
      {
        name: "Aura Glow",
        type: "Aura Glow",
        "Aura Glow": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Aura Black",
        type: "Aura Black",
        "Aura Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Aura Red",
        type: "Aura Red",
        "Aura Red": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "Galaxy Note10": [
      {
        name: "Aura Glow",
        type: "Aura Glow",
        "Aura Glow": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Aura Black",
        type: "Aura Black",
        "Aura Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Aura Pink",
        type: "Aura Pink",
        "Aura Pink": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Aura White",
        type: "Aura White",
        "Aura White": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],

    "Galaxy Z Fold6": [
      {
        name: "Crafted Black",
        type: "Crafted Black",
        "Crafted Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "White",
        type: "White",
        White: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver Shadow",
        type: "Silver Shadow",
        "Silver Shadow": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Pink",
        type: "Pink",
        Pink: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Navy",
        type: "Navy",
        Navy: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "Galaxy Z Fold5": [
      {
        name: "Cream",
        type: "Cream",
        Cream: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Ice Blue",
        type: "Ice Blue",
        "Ice Blue": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Phantom Black",
        type: "Phantom Black",
        "Phantom Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],

    "Galaxy Z Flip6": [
      {
        name: "Crafted Black",
        type: "Crafted Black",
        "Crafted Black": [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Cream",
        type: "Cream",
        Cream: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "White",
        type: "White",
        White: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Mint",
        type: "Mint",
        Mint: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Silver Shadow",
        type: "Silver Shadow",
        "Silver Shadow": [{ name: "256GB" }, { name: "512GB" }],
      },
      {
        name: "Yellow",
        type: "Yellow",
        Yellow: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "Galaxy Z Flip5": [],

    "Samsung Galaxy A35 5G (2024)": [
      {
        name: "Lime",
        type: "Lime",
        Lime: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Graphite",
        type: "Graphite",
        Graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Violet",
        type: "Violet",
        Violet: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Samsung Galaxy A25 5G (2024)": [
      {
        name: "Black",
        type: "Black",
        Black: [{ name: "128GB", type: "128GB" }],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [{ name: "128GB", type: "128GB" }],
      },
      {
        name: "Yellow",
        type: "Yellow",
        Yellow: [{ name: "128GB", type: "128GB" }],
      },
    ],
    "Samsung Galaxy A15 5G (2024)": [
      {
        name: "Black",
        type: "Black",
        Black: [{ name: "128GB", type: "128GB" }],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [{ name: "128GB", type: "128GB" }],
      },
      {
        name: "Yellow",
        type: "Yellow",
        Yellow: [{ name: "128GB", type: "128GB" }],
      },
    ],
    "Samsung Galaxy A15 4G (2024)": [
      {
        name: "Black",
        type: "Black",
        Black: [{ name: "128GB", type: "128GB" }],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [{ name: "128GB", type: "128GB" }],
      },
      {
        name: "Yellow",
        type: "Yellow",
        Yellow: [{ name: "128GB", type: "128GB" }],
      },
    ],
    "Samsung Galaxy A54 5G (2023)": [
      {
        name: "Lime",
        type: "Lime",
        Lime: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Graphite",
        type: "Graphite",
        Graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Violet",
        type: "Violet",
        Violet: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "white",
        type: "white",
        white: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Samsung Galaxy A34 5G (2023)": [
      {
        name: "Lime",
        type: "Lime",
        Lime: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Graphite",
        type: "Graphite",
        Graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Violet",
        type: "Violet",
        Violet: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Samsung Galaxy A73 5G (2022)": [
      {
        name: "Black",
        type: "Black",
        Black: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Samsung Galaxy A53 5G (2022)": [
      {
        name: "Black",
        type: "Black",
        Black: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "White",
        type: "White",
        White: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Peach",
        type: "Peach",
        Peach: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Samsung Galaxy A33 5G (2022)": [
      {
        name: "Black",
        type: "Black",
        Black: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "White",
        type: "White",
        White: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Peach",
        type: "Peach",
        Peach: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Samsung Galaxy A72 5G (2021)": [
      {
        name: "Awesome Black",
        type: "Awesome Black",
        "Awesome Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Awesome Blue",
        type: "Awesome Blue",
        "Awesome Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Awesome White",
        type: "Awesome White",
        "Awesome White": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Awesome Voilet",
        type: "Awesome Voilet",
        "Awesome Voilet": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Samsung Galaxy A52 4G (2021)": [
      { name: "128GB", type: "128GB" },
      { name: "256GB", type: "256GB" },
    ],
    "Samsung  A51": [
      { name: "128GB", type: "128GB" },
      { name: "256GB", type: "256GB" },
    ],
    "Samsung Galaxy A42 5G (2020)": [
      {
        name: "Prism Dot Black",
        type: "Prism Dot White",
        "Prism Dot White": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Prism Dot Gray",
        type: "Prism Dot Gray",
        "Prism Dot Gray": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Prism Dot White",
        type: "Prism Dot White",
        "Prism Dot White": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Samsung Galaxy A32 5G (2021)": [
      {
        name: "Awesome Black",
        type: "Awesome Black",
        "Awesome Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Awesome Blue",
        type: "Awesome Blue",
        "Awesome Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Awesome White",
        type: "Awesome White",
        "Awesome White": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Awesome Voilet",
        type: "Awesome Voilet",
        "Awesome Voilet": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Samsung Galaxy A32 4G (2021)": [
      {
        name: "Awesome Black",
        type: "Awesome Black",
        "Awesome Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Awesome Blue",
        type: "Awesome Blue",
        "Awesome Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Awesome White",
        type: "Awesome White",
        "Awesome White": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Awesome Voilet",
        type: "Awesome Voilet",
        "Awesome Voilet": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],

    "Huawei Mate 20 Pro": [
      {
        name: "Black",
        type: "Black",
        Black: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Emerald Green",
        type: "Emerald Green",
        "Emerald Green": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Twilight",
        type: "Twilight",
        Twilight: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Midnight Blue",
        type: "Midnight Blue",
        "Midnight Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Huawei P30 Lite": [
      {
        name: "Black",
        type: "Black",
        Black: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "White",
        type: "White",
        White: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Huawei P40 Lite": [
      {
        name: "Auroa Blure",
        type: "Auroa Blure",
        "Auroa Blure": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Amber Sunrise",
        type: "Amber Sunrise",
        "Amber Sunrise": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Black",
        type: "Black",
        Black: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Breathing Crystal",
        type: "Breathing Crystal",
        "Breathing Crystal": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Silver Frost",
        type: "Silver Frost",
        "Silver Frost": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "Huawei Mate 30 Pro": [
      {
        name: "Silver",
        type: "Silver",
        Silver: [],
      },

      {
        name: "Black",
        type: "Black",
        Black: [],
      },
    ],
    "Huawei P40 Lite E": [
      {
        name: "Aurora Blue",
        type: "Aurora Blue",
        "Aurora Blue": [{ name: "64GB", type: "64GB" }],
      },
      {
        name: "Midnight Black",
        type: "Midnight Black",
        "Midnight Black": [{ name: "64GB", type: "64GB" }],
      },
    ],
    "Huawei P40 Lite": [
      {
        name: "Black",
        type: "Black",
        Black: [{ name: "128GB", type: "128GB" }],
      },
      {
        name: "Emerald Green",
        type: "Emerald Green",
        "Emerald Green": [{ name: "128GB", type: "128GB" }],
      },
      {
        name: "Pink",
        type: "Pink",
        Pink: [{ name: "128GB", type: "128GB" }],
      },
    ],
    "Huawei P40": [
      {
        name: "Silver Frost",
        type: "Silver Frost",
        "Silver Frost": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Blush Gold",
        type: "Blush Gold",
        "Blush Gold": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Deep Sea Blue",
        type: "Deep Sea Blue",
        "Deep Sea Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Ice White",
        type: "Ice White",
        "Ice White": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Black",
        type: "Black",
        Black: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Huawei P40 Pro": [
      {
        name: "Silver Frost",
        type: "Silver Frost",
        "Silver Frost": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Blush Gold",
        type: "Blush Gold",
        "Blush Gold": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Deep Sea Blue",
        type: "Deep Sea Blue",
        "Deep Sea Blue": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Ice White",
        type: "Ice White",
        "Ice White": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Black",
        type: "Black",
        Black: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "Huawei P30 Pro": [
      {
        name: "Silver Frost",
        type: "Silver Frost",
        "Silver Frost": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Blush Gold",
        type: "Blush Gold",
        "Blush Gold": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Deep Sea Blue",
        type: "Deep Sea Blue",
        "Deep Sea Blue": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Ice White",
        type: "Ice White",
        "Ice White": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Black",
        type: "Black",
        Black: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],

    iPhone8: [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "512GB", type: "512GB" },
        ],
      },

      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "(PRODUCT)RED",
        type: "(PRODUCT)RED",
        "(PRODUCT)RED": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "iPhone 8 Plus": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "(PRODUCT)RED",
        type: "(PRODUCT)RED",
        "(PRODUCT)RED": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPhone X": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Silver",
        type: " Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],

    "iPhone XR": [
      {
        name: "White",
        type: "White",
        White: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Black",
        type: "Black",
        Black: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Yellow",
        type: "Yellow",
        Yellow: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "coral",
        type: "coral",
        Blcoralue: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "(PRODUCT)RED",
        type: "(PRODUCT)RED",
        "(PRODUCT)RED": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],

    "iPhone SE (2022)": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          // { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iPhone XS": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", price: "349CHF", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },

      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],

    "iPhone XS Max": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },

      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "iphone 11 pro max": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Night Green",
        type: "Night Green",
        "Night Green": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "iphone 11 pro": [
      {
        name: "Space Grey",
        type: "Space Grey",
        "Space Grey": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Night Green",
        type: "Night Green",
        "Night Green": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "iphone 11": [
      {
        name: "White",
        type: "White",
        White: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },

      {
        name: "Black",
        type: "Black",
        Black: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Green",
        type: "Green",
        "Night Green": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Yellow",
        type: "Yellow",
        Yellow: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Violet",
        type: "Violet",
        Violet: [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "(PRODUCT)RED",
        type: "(PRODUCT)RED",
        "(PRODUCT)RED": [
          { name: "64GB", type: "64GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "iphone 12 pro max": [
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Gold",
        type: "Titanium BlackGold",
        "Titanium BlackGold": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Pacific Blue",
        type: "Pacific Blue",
        "Pacific Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "iphone 12 pro": [
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Gold",
        type: "Titanium BlackGold",
        "Titanium BlackGold": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Pacific Blue",
        type: "Pacific Blue",
        "Pacific Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],

    "iphone 12": [
      {
        name: "(PRODUCT)RED",
        type: "(PRODUCT)RED",
        "(PRODUCT)RED": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Black",
        type: "Black",
        Black: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Green",
        type: "Green",
        Green: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "White",
        type: "White",
        White: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "iphone 12 mini": [
      {
        name: "(PRODUCT)RED",
        type: "(PRODUCT)RED",
        "(PRODUCT)RED": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Black",
        type: "Black",
        Black: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Green",
        type: "Green",
        Green: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "White",
        type: "White",
        White: [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],

    "iphone 13 pro max": [
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Sierra Blue",
        type: "Sierra Blue",
        "Sierra Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Alpine Green",
        type: "Alpine Green",
        "Alpine Green": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iphone 13 pro": [
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Sierra Blue",
        type: "Sierra Blue",
        "Sierra Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Alpine Green",
        type: "Alpine Green",
        "Alpine Green": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],

    "iphone 13 mini": [
      {
        name: "(PRODUCT)RED",
        type: "(PRODUCT)RED",
        "(PRODUCT)RED": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Rose",
        type: "Rose",
        Rose: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "midnight",
        type: "midnight",
        midnight: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Green",
        type: "Green",
        Green: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "iphone 13": [
      {
        name: "(PRODUCT)RED",
        type: "(PRODUCT)RED",
        "(PRODUCT)RED": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Rose",
        type: "Rose",
        Rose: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "midnight",
        type: "midnight",
        midnight: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Green",
        type: "Green",
        Green: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "iphone 14 pro max": [
      {
        name: "Dark purple",
        type: "Dark purple",
        "Dark purple": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Space black",
        type: "Space black",
        "Space black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      ,
    ],
    "iphone 14 pro": [
      {
        name: "Dark purple",
        type: "Dark purple",
        "Dark purple": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Space black",
        type: "Space black",
        "Space black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },

      {
        name: "Gold",
        type: "Gold",
        Gold: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],

    "iphone 14": [
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Violet",
        type: "Violet",
        Violet: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "midnight",
        type: "midnight",
        midnight: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Polar Star",
        type: "Polar Star",
        "Polar Star": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "(PRODUCT)RED",
        type: "(PRODUCT)RED",
        "(PRODUCT)RED": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Yellow",
        type: "Yellow",
        Yellow: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "iphone 15 pro": [
      {
        name: "Titanium Blue",
        type: "Titanium Blue",
        "Titanium Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Titanium White",
        type: "Titanium White",
        "Titanium White": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Titanium Natural",
        type: "Titanium Natural",
        "Titanium Natural": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "iphone 15 Pro Max": [
      {
        name: "Titanium Blue",
        type: "Titanium Blue",
        "Titanium Blue": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Titanium White",
        type: "Titanium White",
        "Titanium White": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "Titanium Natural",
        type: "Titanium Natural",
        "Titanium Natural": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],

    "iphone 15": [
      {
        name: "Green",
        type: "Green",
        Green: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },

          ,
        ],
      },
      {
        name: "Yellow",
        type: "Yellow",
        Yellow: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Rose",
        type: "Rose",
        Rose: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Black",
        type: "Black",
        Black: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "iphone 15 Plus": [
      {
        name: "Green",
        type: "Green",
        Green: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Yellow",
        type: "Yellow",
        Yellow: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Blue",
        type: "Blue",
        Blue: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Rose",
        type: "Rose",
        Rose: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "Black",
        type: "Black",
        Black: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],

    // SamSung TAb

    "Galaxy Tab S9+": [
      {
        name: "Beige",
        type: "Beige",
        Beige: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "Galaxy Tab S9+ 5G": [
      {
        name: "Beige",
        type: "Beige",
        Beige: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
          { name: "1TB", type: "1TB" },
        ],
      },
    ],
    "Samsung Galaxy S9 5G": [
      {
        name: "Beige",
        type: "Beige",
        Beige: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "Galaxy Tab S9": [
      {
        name: "Beige",
        type: "Beige",
        Beige: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy Tab S9 FE 5G": [
      {
        name: "Mint",
        type: "Mint",
        Mint: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Gray",
        type: "Gray",
        Gray: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Lavender",
        type: "Lavender",
        Lavender: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy Tab S9 FE": [
      {
        name: "Mint",
        type: "Mint",
        Mint: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Gray",
        type: "Gray",
        Gray: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Voilet",
        type: "Voilet",
        Lavender: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy Tab S8 5G": [
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "Galaxy Tab S8": [
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
          { name: "512GB", type: "512GB" },
        ],
      },
    ],
    "Galaxy Tab S8+ 5G": [
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Pink Gold",
        type: "Pink Gold",
        "Pink Gold": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy Tab S8+": [
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Pink Gold",
        type: "Pink Gold",
        "Pink Gold": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy Tab S8 5G": [
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Pink Gold",
        type: "Pink Gold",
        "Pink Gold": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy Tab S8": [
      {
        name: "Silver",
        type: "Silver",
        Silver: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "graphite",
        type: "graphite",
        graphite: [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "Pink Gold",
        type: "Pink Gold",
        "Pink Gold": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy Tab S7 FE 5G": [
      {
        name: "Mystic Black",
        type: "Mystic Black",
        "Mystic Black": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "mystic silver",
        type: "mystic silver",
        "mystic silver": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "mystic Green",
        type: "mystic Green",
        "mystic Green": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "mystic Pink",
        type: "mystic Pink",
        "mystic Pink": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy Tab S7": [
      {
        name: "Mystic Black",
        type: "Mystic Black",
        "Mystic Black": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "mystic silver",
        type: "mystic silver",
        "mystic silver": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "mystic Green",
        type: "mystic Green",
        "mystic Green": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "mystic Pink",
        type: "mystic Pink",
        "mystic Pink": [
          { name: "64GB", type: "64GB" },
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy Tab S7+ 5G": [
      {
        name: "Mystic Black",
        type: "Mystic Black",
        "Mystic Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "mystic silver",
        type: "mystic silver",
        "mystic silver": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "mystic Bronze",
        type: "mystic Bronze",
        "mystic Bronze": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "mystic Navy",
        type: "mystic Navy",
        "mystic Navy": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy Tab S7+": [
      {
        name: "Mystic Black",
        type: "Mystic Black",
        "Mystic Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "mystic silver",
        type: "mystic silver",
        "mystic silver": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "mystic Bronze",
        type: "mystic Bronze",
        "mystic Bronze": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "mystic Navy",
        type: "mystic Navy",
        "mystic Navy": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
    "Galaxy Tab S7": [
      {
        name: "Mystic Black",
        type: "Mystic Black",
        "Mystic Black": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "mystic silver",
        type: "mystic silver",
        "mystic silver": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
      {
        name: "mystic Bronze",
        type: "mystic Bronze",
        "mystic Bronze": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },

      {
        name: "mystic Navy",
        type: "mystic Navy",
        "mystic Navy": [
          { name: "128GB", type: "128GB" },
          { name: "256GB", type: "256GB" },
        ],
      },
    ],
  };
  let newss = color["iphone 11 pro"];
  // console.log(newss?.find((res) => res?.name == data?.deviceColor));

  let price = {
    "iPhone XS": {
      "64GB": "349CHF",
      "128GB": 0,
    },
    "iphone 12": {
      "64GB": 0,
      "128GB": "429CHF",
    },
    "iphone 13": {
      "64GB": 0,
      "128GB": "529CHF",
    },
    "Samsung Galaxy S10": {
      "64GB": 0,
      "128GB": "299CHF",
    },
    "Samsung  A51": {
      "64GB": 0,
      "128GB": "179CHF",
    },
    "iPhone SE (2022)": {
      "64GB": "419CHF",
      "128GB": 0,
    },
  };

  console.log(price);

  function findCategoryByName(name, data) {
    // Iterate over each key in the data object
    for (let key in data) {
      // Check if the value is an array
      if (Array.isArray(data[key])) {
        // Iterate through the array to find the item with the given name
        for (let item of data[key]) {
          if (item.name === name) {
            return key; // Return the key if the name matches
          }
        }
      }
    }
    // If the name is not found, return null or undefined
    return "";
  }

  const model = {
    iPhone: [
      { name: "iPhone8", type: "iPhone8" },
      { name: "iPhone 8 Plus", type: "iPhone 8 Plus" },
      { name: "iPhone SE (2022)", type: "iPhone SE (2022)" },
      { name: "iPhone X", type: "iPhone X" },
      { name: "iPhone XR", type: "iPhone XR" },
      { name: "iPhone XS", type: "iPhone XS" },
      { name: "iPhone XS Max", type: "iPhone XS Max" },
      { name: "iphone 11 pro max", type: "iphone 11 pro max" },
      { name: "iphone 11 pro", type: "iphone 11 pro" },
      { name: "iphone 11 pro", type: "iphone 11 pro" },
      { name: "iphone 11", type: "iphone 11" },
      { name: "iphone 12 pro max", type: "iphone 12 pro max" },
      { name: "iphone 12 pro", type: "iphone 12 pro" },
      { name: "iphone 12", type: "iphone 12" },
      { name: "iphone 12 mini", type: "iphone 12 mini" },
      { name: "iphone 13 pro max", type: "iphone 13 pro max" },
      { name: "iphone 13 pro", type: "iphone 13 pro" },
      { name: "iphone 13 mini", type: "iphone 13 mini" },
      { name: "iphone 13", type: "iphone 13" },
      { name: "iphone 14 pro max", type: "iphone 14 pro max" },
      { name: "iphone 14 pro", type: "iphone 14 pro" },
      { name: "iphone 14", type: "iphone 14" },
      { name: "iphone 15 pro", type: "iphone 15 pro" },
      { name: "iphone 15 Pro Max", type: "iphone 15 Pro Max" },
      { name: "iphone 15 Plus", type: "iphone 15 Plus" },
      { name: "iphone 15", type: "iphone 15" },
    ],

    "Samsung Galaxy": [
      { name: "A Series", type: "A Series" },
      { name: "S Series", type: "S Series" },
      { name: "Fold Flip Series", type: "Fold Flip Series" },
      { name: "Note Series", type: "Note Series" },
    ],

    "A Series": [
      {
        name: "Samsung Galaxy A55 5G (2024)",
        type: "Samsung Galaxy A55 5G (2024)",
      },
      {
        name: "Samsung Galaxy A35 5G (2024)",
        type: "Samsung Galaxy A35 5G (2024)",
      },
      {
        name: "Samsung Galaxy A25 5G (2024)",
        type: "Samsung Galaxy A25 5G (2024)",
      },
      {
        name: "Samsung Galaxy A15 5G (2024)",
        type: "Samsung Galaxy A15 5G (2024)",
      },
      {
        name: "Samsung Galaxy A15 4G (2024)",
        type: "Samsung Galaxy A15 4G (2024)",
      },
      {
        name: "Samsung Galaxy A54 5G (2023)",
        type: "Samsung Galaxy A54 5G (2023)",
      },
      {
        name: "Samsung Galaxy A34 5G (2023)",
        type: "Samsung Galaxy A34 5G (2023)",
      },
      {
        name: "Samsung Galaxy A73 5G (2022)",
        type: "Samsung Galaxy A73 5G (2022)",
      },
      {
        name: "Samsung Galaxy A53 5G (2022)",
        type: "Samsung Galaxy A53 5G (2022)",
      },
      {
        name: "Samsung Galaxy A33 5G (2022)",
        type: "Samsung Galaxy A33 5G (2022)",
      },
      {
        name: "Samsung Galaxy A72 5G (2021)",
        type: "Samsung Galaxy A72 5G (2021)",
      },
      {
        name: "Samsung Galaxy A52s 5G (2021)",
        type: "Samsung Galaxy A52 5G (2021)",
      },
      {
        name: "Samsung Galaxy A52 4G (2021)",
        type: "Samsung Galaxy A52 4G (2021)",
      },
      {
        name: "Samsung Galaxy A42 5G (2020)",
        type: "Samsung Galaxy A42 5G (2020)",
      },
      {
        name: "Samsung Galaxy A32 5G (2021)",
        type: "Samsung Galaxy A32 5G (2021)",
      },
      {
        name: "Samsung Galaxy A32 4G (2021)",
        type: "Samsung Galaxy A32 4G (2021)",
      },
    ],

    "S Series": [
      { name: "Galaxy S24 Ultra", type: "Galaxy S24 Ultra" },
      { name: "Galaxy S24+", type: "Galaxy S24+" },
      { name: "GalaxyS24", type: "GalaxyS24" },
      { name: "Galaxy S23 FE", type: "Galaxy S23 FE" },
      { name: "Galaxy S23 Ultra", type: "Galaxy S23 Ultra" },
      { name: "GalaxyS23+", type: "GalaxyS23+" },
      { name: "GalaxyS23", type: "GalaxyS23" },
      { name: "Galaxy S22 Ultra", type: "Galaxy S22 Ultra" },
      { name: "Galaxy S22+", type: "Galaxy S22+" },
      { name: "GalaxyS22", type: "GalaxyS22" },
      { name: "Galaxy S21 FE 5G", type: "Galaxy S21 FE 5G" },
      { name: "Galaxy S21 Ultra", type: "Galaxy S21 Ultra" },
      { name: "Galaxy S21+", type: "Galaxy S21+" },
      { name: "Samsung Galaxy S21", type: "Samsung Galaxy S21" },
      { name: "Galaxy S10 Lite", type: "Series" },
      { name: "Galaxy S10 Lite", type: "Galaxy S10 Lite" },
      { name: "Galaxy S20 Ultra 5G", type: "Galaxy S20 Ultra 5G" },
      { name: "Galaxy S20+ 5G", type: "Galaxy S20+ 5G" },
      { name: "Samsung Galaxy S20+", type: "Samsung Galaxy S20+" },
      { name: "Samsung Galaxy S20 5G", type: "Samsung Galaxy S20 5G" },
      { name: "Samsung Galaxy S20 4G", type: "Samsung Galaxy S20 4G" },
      { name: "Galaxy S20 FE 5G", type: "Galaxy S20 FE 5G" },
      { name: "Galaxy S20 FE 4G", type: "Galaxy S20 FE 4G" },
      { name: "Samsung Galaxy S10 5G", type: "Samsung Galaxy S10 5G" },
      { name: "GalaxyS10+", type: "GalaxyS10+" },
      { name: "Samsung Galaxy S10", type: "Samsung Galaxy S10" },
    ],
    "Note Series": [
      { name: "Galaxy Note 20 Ultra 5G", type: "Galaxy Note 20 Ultra 5G" },
      { name: "Galaxy Note 20 Ultra", type: "Galaxy Note 20 Ultra" },
      { name: "Galaxy Note20", type: "Galaxy Note20" },
      { name: "Galaxy Note10+ 5G", type: "Galaxy Note10+ 5G" },
      { name: "Galaxy Note10+", type: "Galaxy Note10+" },
      { name: "Galaxy Note 10 Lite", type: "Galaxy Note 10 Lite" },
      { name: "Galaxy Note10", type: "Galaxy Note10" },
    ],

    "Fold Flip Series": [
      { name: "Galaxy Z Fold6", type: "Galaxy Z Fold6" },
      { name: "Galaxy Z Fold5", type: "Galaxy Z Fold5" },
      { name: "Galaxy Z Flip6", type: "Galaxy Z Flip6" },
      { name: "Galaxy Z Flip5", type: "Galaxy Z Flip5" },
    ],

    Huawei: [
      { name: "Huawei P40 Pro", type: "Huawei P40 Pro" },
      { name: "Huawei P40", type: "Huawei P40" },
      { name: "Huawei P40 Lite", type: "Huawei P40 Lite" },
      { name: "Huawei P40 Lite E", type: "Huawei P40 Lite E" },
      { name: "Huawei Mate 30 Pro", type: "Huawei Mate 30 Pro" },
      { name: "Huawei P30 Pro", type: "Huawei P30 Pro" },
      { name: "Huawei P30 Lite", type: "Huawei P30 Lite" },
      { name: "Huawei Mate 20 Pro", type: "Huawei Mate 20 Pro" },
    ],
    iPad: [
      { name: "iPad", type: "iPad" },
      { name: "iPad Air", type: "iPad Air" },
      { name: "iPad mini", type: "iPad mini" },
      { name: "iPad Pro", type: "iPad Pro" },
    ],

    "Samsung Tab": [
      { name: "Galaxy Tab S9+ 5G", type: "Galaxy Tab S9+ 5G" },

      { name: "Galaxy Tab S9+", type: "Galaxy Tab S9+" },
      { name: "Samsung Galaxy S9 5G", type: "Samsung Galaxy S9 5G" },
      { name: "Galaxy Tab S9", type: "Galaxy Tab S9" },
      { name: "Galaxy Tab S9 FE 5G", type: "Galaxy Tab S9 FE 5G" },
      { name: "Galaxy Tab S9 FE", type: "Galaxy Tab S9 FE" },
      { name: "Galaxy Tab S8 5G", type: "Galaxy Tab S8 5G" },
      { name: "Galaxy Tab S8", type: "Galaxy Tab S8" },
      { name: "Galaxy Tab S8+ 5G", type: "Galaxy Tab S8+ 5G" },
      { name: "Galaxy Tab S8+", type: "Galaxy Tab S8+" },
      { name: "Galaxy Tab S8 5G", type: "Galaxy Tab S8 5G" },
      { name: "Galaxy Tab S8", type: "Galaxy Tab S8" },
      { name: "Galaxy Tab S7 FE 5G", type: "Galaxy Tab S7 FE 5G" },
      { name: "Galaxy Tab S7", type: "Galaxy Tab S7" },
      { name: "Galaxy Tab S7+ 5G", type: "Galaxy Tab S7+ 5G" },
      { name: "Galaxy Tab S7+", type: "Galaxy Tab S7+" },
      { name: "Galaxy Tab S7", type: "Galaxy Tab S7" },
    ],

    MacBook: [
      { name: "MacBookAir", type: "MacBookAir" },
      {
        name: "Macbook Pro with Touch Bar",
        type: "Macbook Pro with Touch Bar",
      },
      {
        name: "MacBook Pro with M processor",
        type: "MacBook Pro with M processor",
      },
    ],

    "Mac Mini": [
      { name: "Mac Mini(2023)", type: "Mac Mini(2023)" },
      { name: "Mac Mini(2020)", type: "Mac Mini(2020)" },
      { name: "Mac Mini(2018)", type: "Mac Mini(2018)" },
      { name: "Mac Studio", type: "Mac Studio" },
    ],

    iMac: [
      { name: "iMac 27 inch", type: "iMac 27 inch" },
      { name: "iMac 24 inch", type: "iMac 24 inch" },
    ],
  };

  function onselect(e) {
    console.log(e);
    let seriess = findCategoryByName(e, Series);
    let typee = "";
    if (seriess == "") {
      seriess = findCategoryByName(e, model);
      typee = findCategoryByName(e, model);
    } else {
      typee = findCategoryByName(seriess, model);
      console.log(seriess);
    }
    console.log(typee);

    let cc = findCategoryByName(typee, category);

    setData({
      category: cc,
      type: typee,
      series: seriess,
      modal: e,
      deviceType: "",
      deviceColor: "",
      storage: "",
      ram: "",
      processor: "",
      layout: "",
      unibody: "",
      underside: "",
      defective: "",
      display: "",
      frame: "",
      backCase: "",
    });
  }

  return (
    <div className="main-container">
      <div className="right-container">
        <div className="chat-container">
          <span className="Name-Marco">Marco</span>
          <div className="message-box friend-message ">
            <p>
              <img src="/images/small.png" alt="" />
              Grüezi, ich bin Remo. Gerne helfe ich Ihnen beim Verkauf
            </p>
          </div>
          <span className="Name-Marco">Marco</span>
          <div className="message-box friend-message ">
            <p>
              <img src="/images/small.png" alt="" />
              Welchen Gerätetyp haben Sie?
            </p>
          </div>
          {data?.category == "" ? (
            <>
              <div className="message-box my-message ">
                <div className="phn-svg ">
                  <svg
                    width="37px"
                    height="45px"
                    viewBox="0 0 37 45"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      fill="none"
                      stroke="none"
                      strokeWidth="1"
                      fillRule="evenodd"
                    >
                      <g fill="#000000">
                        <path d="M13.986,42.13l-0.04-1.12H0.999V10.99h12.996v-3.99H2.869C1.29,7,0,8.3,0,9.88v32.26c0,1.57,1.29,2.88,2.869,2.88h12.997c-0.85-0.67-1.65-1.7-1.65-2.87zM7.998,9h3v0.5h-3V9zM9.497,44.5c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5c0.83,0,1.5,0.67,1.5,1.5S10.327,44.5,9.497,44.5zM33.641,0H18.325c-1.84,0-3.33,1.51-3.33,3.35v38.28c0,1.84,1.49,3.35,3.33,3.35h15.326c1.84,0,3.33-1.51,3.33-3.35V3.35C37,1.51,35.51,0,33.641,0zM24.493,2.5h2.999v0.5h-2.999V2.5zM25.993,44.25c-0.97,0-1.75-0.78-1.75-1.75s0.78-1.75,1.75-1.75c0.97,0,1.75,0.78,1.75,1.75s-0.78,1.75-1.75,1.75zM35.99,40H15.996V5h19.994V40zM25.993,43.5c-0.55,0-1-0.45-1-1s0.45-1,1-1c0.55,0,1,0.45,1,1s-0.45,1-1,1zM9.497,43.88c-0.48,0-0.87-0.39-0.87-0.87s0.39-0.87,0.87-0.87c0.48,0,0.87,0.39,0.87,0.87s-0.39,0.87-0.87,0.87z" />
                      </g>
                    </g>
                  </svg>
                  <span
                    className="p-heading-text"
                    onClick={() =>
                      handleCategoryClick({ category: "Smartphones" })
                    }
                  >
                    Smartphones
                  </span>
                </div>
                <div className="phn-svg ">
                  <svg
                    width="40px"
                    height="49px"
                    viewBox="0 0 40 49"
                    xmlns="http://www.w3.org/2000/svg "
                    className=""
                  >
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g fillRule="nonzero" fill="#000000">
                        <path d="M38.76,5 L13.23,5 C12.55,5 12,5.54 12,6.24 L12,46.77 C12,47.47 12.55,48.01 13.23,48.01 L38.76,48.01 C39.44,48.01 40,47.47 40,46.77 L40,6.24 C40,5.54 39.45,5 38.76,5 Z M26,6.38 C26.34,6.38 26.62,6.66 26.62,7 C26.62,7.34 26.34,7.62 26,7.62 C25.66,7.62 25.38,7.34 25.38,7 C25.38,6.66 25.66,6.38 26,6.38 Z M26.02,47.01 C25.47,47.01 25.02,46.55 25.02,46.01 C25.02,45.47 25.47,45.01 26.02,45.01 C26.57,45.01 27.02,45.47 27.02,46.01 C27.01,46.55 26.56,47.01 26.02,47.01 Z M38,44 L14,44 L14,9 L38,9 L38,44 Z M12,47.93 C11.43,47.81 11,47.34 11,46.72 L11,44 L2,44 L2,4 L34,4 L34,1.5 C34,0.65 33.33,0 32.5,0 L1.5,0 C0.67,0 0,0.65 0,1.5 L0,46.5 C0,47.35 0.67,48 1.5,48 L12,48 L12,47.93 Z M17,1.25 C17.41,1.25 17.75,1.59 17.75,2 C17.75,2.41 17.41,2.75 17,2.75 C16.59,2.75 16.25,2.41 16.25,2 C16.25,1.59 16.59,1.25 17,1.25 Z" />
                      </g>
                    </g>
                  </svg>
                  <span
                    className="p-heading-text "
                    onClick={() => handleCategoryClick({ category: "Tablet" })}
                  >
                    Tablet
                  </span>
                </div>
                <div className="phn-svg">
                  <svg
                    width="70px"
                    height="40px"
                    viewBox="0 0 70 40"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g fillRule="nonzero" fill="#000000">
                        <path d="M42,38 L42,17.5 C42,16.54 41.48,16 40.5,16 L5.5,16 C4.52,16 4,16.5 4,17.5 L4,38 L0,38 C0.05,38.09 0.13,38.32 0.21,38.32 C0.21,38.32 2.28,39.57 4.85,39.74 C7.42,39.92 9.99,40.01 10,40 C10,40 23,40 23,40 L36,40 C36,40 38.36,39.92 40.93,39.75 C43.5,39.58 45.57,38.33 45.57,38.33 C45.65,38.33 45.95,38.1 46.01,38.01 L42,38.01 L42,38 Z M6,18 L40,18 L40,38 L6,38 L6,18 Z M52.95,40 L52.95,40 C52.97,39.99 52.98,39.99 52.99,39.98 C53.13,39.94 53.23,39.81 53.23,39.66 C53.23,39.47 53.08,39.32 52.88,39.32 C52.85,39.32 52.84,39.32 52.81,39.32 C51.45,39.41 50.18,38.5 49.88,37.13 L49,33 L68.47,33 C69.17,33 70,32.17 70,31.47 L70,1.53 C70,0.83 69.17,0 68.47,0 L23.53,0 C22.83,0 22,0.83 22,1.53 L22.02,15 L24,15 L24,2 L68,2 L68,27 L43,27 L43,33 L43,37 L47,37 L47,38 C46.96,39.54 44,40 44,40 L52.95,40 Z M46.95,30.83 C46.92,30.89 46.89,30.95 46.86,31 C46.83,31.05 46.79,31.1 46.76,31.14 C46.73,31.18 46.7,31.21 46.68,31.22 C46.64,31.25 46.61,31.27 46.57,31.29 C46.54,31.31 46.5,31.32 46.46,31.32 C46.44,31.32 46.4,31.31 46.37,31.3 C46.33,31.29 46.3,31.28 46.26,31.27 C46.22,31.26 46.18,31.25 46.15,31.23 C46.11,31.22 46.08,31.22 46.05,31.22 C46.02,31.22 45.98,31.22 45.94,31.24 C45.9,31.25 45.86,31.26 45.82,31.28 C45.78,31.29 45.74,31.3 45.71,31.32 C45.68,31.33 45.65,31.34 45.63,31.34 C45.6,31.34 45.57,31.33 45.54,31.32 C45.51,31.31 45.48,31.29 45.45,31.27 C45.42,31.25 45.39,31.21 45.35,31.17 C45.31,31.13 45.28,31.08 45.23,31.02 C45.19,30.96 45.16,30.9 45.12,30.83 C45.09,30.76 45.06,30.69 45.04,30.61 C45.02,30.54 45,30.46 44.99,30.39 C44.98,30.31 44.97,30.24 44.97,30.17 C44.97,30.06 44.99,29.96 45.02,29.87 C45.05,29.78 45.1,29.7 45.15,29.63 C45.21,29.56 45.27,29.51 45.35,29.47 C45.43,29.43 45.51,29.41 45.6,29.41 C45.67,29.41 45.74,29.43 45.83,29.47 C45.92,29.51 45.98,29.53 46.01,29.53 C46.02,29.53 46.04,29.52 46.07,29.51 C46.1,29.5 46.15,29.48 46.21,29.46 C46.27,29.44 46.31,29.43 46.35,29.42 C46.39,29.41 46.42,29.41 46.46,29.41 C46.56,29.41 46.65,29.43 46.74,29.48 C46.83,29.53 46.9,29.59 46.95,29.67 C46.86,29.73 46.79,29.8 46.74,29.88 C46.7,29.96 46.68,30.05 46.68,30.16 C46.68,30.27 46.71,30.37 46.77,30.47 C46.83,30.56 46.91,30.63 47.02,30.68 C47,30.7 46.97,30.77 46.95,30.83 Z M46,29.31 C46,29.25 46.01,29.19 46.04,29.12 C46.07,29.06 46.1,29 46.15,28.95 C46.19,28.9 46.25,28.86 46.31,28.83 C46.37,28.8 46.44,28.78 46.5,28.78 C46.5,28.79 46.5,28.8 46.5,28.81 L46.5,28.84 C46.5,28.9 46.49,28.97 46.46,29.04 C46.43,29.1 46.4,29.16 46.35,29.21 C46.31,29.26 46.26,29.3 46.2,29.33 C46.14,29.36 46.09,29.38 46.03,29.38 C46.01,29.38 45.99,29.38 45.99,29.37 C46,29.34 46,29.32 46,29.31 Z" />
                      </g>
                    </g>
                  </svg>
                  <span
                    className="p-heading-text"
                    onClick={() =>
                      handleCategoryClick({ category: "Computer" })
                    }
                  >
                    Computer
                  </span>
                </div>
                <br />
              </div>
              <div className="Searchdata">
                <AutoCompelte
                  value={selectedModel}
                  onChange={(e) => {
                    setSelectedModel(e);
                    onselect(e);
                  }}
                  options={modelListing}
                  optionLabel="label"
                  editable
                  placeholder="Suche Modell"
                  className="serachInput"
                />
                <i class="bi bi-search IconSearch"></i>
              </div>
            </>
          ) : (
            <div className="message-box my-message">
              <div className="phn-svg">
                <svg
                  width="37px"
                  height="45px"
                  viewBox="0 0 37 45"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g
                    fill="none"
                    stroke="none"
                    strokeWidth="1"
                    fillRule="evenodd"
                  >
                    <g fill="#000000">
                      <path d="M13.986,42.13l-0.04-1.12H0.999V10.99h12.996v-3.99H2.869C1.29,7,0,8.3,0,9.88v32.26c0,1.57,1.29,2.88,2.869,2.88h12.997c-0.85-0.67-1.65-1.7-1.65-2.87zM7.998,9h3v0.5h-3V9zM9.497,44.5c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5c0.83,0,1.5,0.67,1.5,1.5S10.327,44.5,9.497,44.5zM33.641,0H18.325c-1.84,0-3.33,1.51-3.33,3.35v38.28c0,1.84,1.49,3.35,3.33,3.35h15.326c1.84,0,3.33-1.51,3.33-3.35V3.35C37,1.51,35.51,0,33.641,0zM24.493,2.5h2.999v0.5h-2.999V2.5zM25.993,44.25c-0.97,0-1.75-0.78-1.75-1.75s0.78-1.75,1.75-1.75c0.97,0,1.75,0.78,1.75,1.75s-0.78,1.75-1.75,1.75zM35.99,40H15.996V5h19.994V40zM25.993,43.5c-0.55,0-1-0.45-1-1s0.45-1,1-1c0.55,0,1,0.45,1,1s-0.45,1-1,1zM9.497,43.88c-0.48,0-0.87-0.39-0.87-0.87s0.39-0.87,0.87-0.87c0.48,0,0.87,0.39,0.87,0.87s-0.39,0.87-0.87,0.87z" />
                    </g>
                  </g>
                </svg>
                <span className="p-heading-text">{data.category}</span>
                {data.category && (
                  <i
                    className="bi bi-pencil-fill "
                    onClick={() => clearBelowStates1("category")}
                  ></i>
                )}
              </div>
            </div>
          )}
          {data?.category !== "" && (
            <>
              <span className="Name-Marco">Marco</span>
              <div className="message-box friend-message">
                <p>
                  <img src="/images/small.png" alt="" />
                  {/* {loading ? (
                    <Loader />
                  ) : ( */}
                  {messageData[data?.category]}
                  {/* )} */}
                </p>
              </div>
            </>
          )}

          <div className="message-box my-message ">
            {data?.category !== "" && data?.type == "" ? (
              category[data?.category]?.map((res) => (
                <>
                  <div className="phn-svg" key={res?.name}>
                    <svg
                      width="37px"
                      height="45px"
                      viewBox="0 0 37 45"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        fill="none"
                        stroke="none"
                        strokeWidth="1"
                        fillRule="evenodd"
                      >
                        <g fill="#000000">
                          <path d="M13.986,42.13l-0.04-1.12H0.999V10.99h12.996v-3.99H2.869C1.29,7,0,8.3,0,9.88v32.26c0,1.57,1.29,2.88,2.869,2.88h12.997c-0.85-0.67-1.65-1.7-1.65-2.87zM7.998,9h3v0.5h-3V9zM9.497,44.5c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5c0.83,0,1.5,0.67,1.5,1.5S10.327,44.5,9.497,44.5zM33.641,0H18.325c-1.84,0-3.33,1.51-3.33,3.35v38.28c0,1.84,1.49,3.35,3.33,3.35h15.326c1.84,0,3.33-1.51,3.33-3.35V3.35C37,1.51,35.51,0,33.641,0zM24.493,2.5h2.999v0.5h-2.999V2.5zM25.993,44.25c-0.97,0-1.75-0.78-1.75-1.75s0.78-1.75,1.75-1.75c0.97,0,1.75,0.78,1.75,1.75s-0.78,1.75-1.75,1.75zM35.99,40H15.996V5h19.994V40zM25.993,43.5c-0.55,0-1-0.45-1-1s0.45-1,1-1c0.55,0,1,0.45,1,1s-0.45,1-1,1zM9.497,43.88c-0.48,0-0.87-0.39-0.87-0.87s0.39-0.87,0.87-0.87c0.48,0,0.87,0.39,0.87,0.87s-0.39,0.87-0.87,0.87z" />
                        </g>
                      </g>
                    </svg>
                    <span
                      className="p-heading-text"
                      onClick={() => handleCategoryClick({ type: res?.name })}
                    >
                      {res?.name}
                    </span>
                    {/* <i className="bi bi-pencil-fill" ></i> */}
                  </div>
                  <br />
                </>
              ))
            ) : (
              <>
                <div className="d-flex gap-2 ans-content ">
                  <span className="p-heading-text ">{data?.type}</span>
                  {data?.type && (
                    <i
                      className="bi bi-pencil-fill "
                      onClick={() => clearBelowStates("type")}
                    ></i>
                  )}
                </div>
              </>
            )}
          </div>
          {data?.type !== "" && (
            <>
              <span className="Name-Marco">Marco</span>
              <div className="message-box friend-message">
                <p>
                  <img src="/images/small.png" alt="" />
                  {/* {loading1 ? (
                    <Loader/>
                  ):( */}

                  {messageData[data?.type]}

                  {/* )} */}
                </p>
              </div>
            </>
          )}

          {data?.category !== "" && data?.type !== "" ? (
            data?.type == "Samsung Galaxy" ||
            data?.type == "MacBook" ||
            data?.type == "Mac Mini" ||
            data?.type == "iMac" ||
            data?.type == "iPad" ? (
              <>
                <div className="message-box my-message flex-wrap ">
                  {data?.category !== "" &&
                  data?.type !== "" &&
                  data?.series == "" ? (
                    model[data?.type]?.map((res) => (
                      <>
                        <div className="phn-svg" key={res?.name}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="36"
                            viewBox="0 0 19 36"
                          >
                            <path
                              fill="#B8D4CB"
                              fill-rule="nonzero"
                              d="M15.375 0H3.385C1.946 0 .78 1.182.78 2.622v29.966c0 1.449 1.166 2.639 2.606 2.639h11.997c1.44 0 2.622-1.19 2.622-2.639V2.622A2.644 2.644 0 0 0 15.375 0zm-7.16 1.957h2.347v.391H8.214v-.391zm1.173 32.682c-.759 0-1.37-.61-1.37-1.37 0-.759.619-1.37 1.37-1.37.752 0 1.37.611 1.37 1.37 0 .76-.61 1.37-1.37 1.37zm7.826-3.327H1.562V3.914h15.652v27.398zm-7.826 2.74a.785.785 0 0 1-.782-.782c0-.431.352-.783.782-.783.43 0 .783.352.783.783 0 .43-.352.782-.783.782z"
                            />
                          </svg>

                          <span
                            className="p-heading-text"
                            onClick={() =>
                              handleCategoryClick({ series: res?.type })
                            }
                          >
                            {res?.name}
                          </span>
                        </div>
                      </>
                    ))
                  ) : (
                    <>
                     <div className="d-flex gap-2 ans-content ">
                        <span className="p-heading-text">{data?.series}</span>
                      
                      {data?.series && (
                        <i
                          className="bi bi-pencil-fill "
                          onClick={() => clearBelowStates("series")}
                        ></i>
                      )}
                      </div>
                    </>
                  )}
                </div>
                {data?.series !== "" &&
                  data?.category !== "" &&
                  data?.type !== "" && (
                    <>
                      <span className="Name-Marco">Marco</span>
                      <div className="message-box friend-message">
                        <p>
                          <img src="/images/small.png" alt="" />
                          {/* {loading2 ? (
    <Loader/>
):( */}

                          {messageData[data.series]}

                          {/* )} */}
                        </p>
                      </div>
                    </>
                  )}

                <div className="message-box my-message flex-wrap ">
                  {/* {console.log(data?.series)} */}
                  {data?.category !== "" &&
                  data?.type !== "" &&
                  data?.modal == "" &&
                  data?.series !== "" ? (
                    Series[data?.series]?.map((res) => (
                      <>
                        <div className="phn-svg" key={res?.name}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="36"
                            viewBox="0 0 19 36"
                          >
                            <path
                              fill="#B8D4CB"
                              fill-rule="nonzero"
                              d="M15.375 0H3.385C1.946 0 .78 1.182.78 2.622v29.966c0 1.449 1.166 2.639 2.606 2.639h11.997c1.44 0 2.622-1.19 2.622-2.639V2.622A2.644 2.644 0 0 0 15.375 0zm-7.16 1.957h2.347v.391H8.214v-.391zm1.173 32.682c-.759 0-1.37-.61-1.37-1.37 0-.759.619-1.37 1.37-1.37.752 0 1.37.611 1.37 1.37 0 .76-.61 1.37-1.37 1.37zm7.826-3.327H1.562V3.914h15.652v27.398zm-7.826 2.74a.785.785 0 0 1-.782-.782c0-.431.352-.783.782-.783.43 0 .783.352.783.783 0 .43-.352.782-.783.782z"
                            />
                          </svg>

                          <span
                            className="p-heading-text"
                            onClick={() =>
                              handleCategoryClick({ modal: res?.type })
                            }
                          >
                            {res?.name}
                          </span>
                        </div>
                      </>
                    ))
                  ) : (
                    <>
                      <div className="d-flex gap-2 ans-content ">
                        <span className="p-heading-text">{data?.modal}</span>
                     
                      {data?.modal && (
                        <i
                          className="bi bi-pencil-fill "
                          onClick={() => clearBelowStates("modal")}
                        ></i>
                      )}
                       </div>
                    </>
                  )}
                </div>
                {data?.category !== "" &&
                  data?.series !== "" &&
                  data?.modal !== "" &&
                  data?.type !== "" && (
                    <>
                      <span className="Name-Marco">Marco</span>
                      <div className="message-box friend-message">
                        <p>
                          <img src="/images/small.png" alt="" />
                          Wie ist der Zustand des Geräte?
                        </p>
                      </div>
                    </>
                  )}

                <div className="message-box my-message flex-wrap">
                  {data?.type !== "" &&
                  data?.category !== "" &&
                  data?.modal !== "" &&
                  data?.deviceType == "" ? (
                    deviceType?.map((res) => (
                      <>
                        <div className="phn-svg" key={res?.name}>
                          <span
                            className="p-heading-text"
                            onClick={() =>
                              handleCategoryClick({ deviceType: res?.type })
                            }
                          >
                            {res?.name}
                          </span>
                        </div>
                      </>
                    ))
                  ) : (
                    <>
                     <div className="d-flex gap-2 ans-content ">
                        <span className="p-heading-text">
                          {data?.deviceType}
                        </span>
                      
                      {data?.deviceType && (
                        <i
                          className="bi bi-pencil-fill "
                          onClick={() => clearBelowStates("deviceType")}
                        ></i>
                      )}
                      </div>
                    </>
                  )}
                  <i
                    class="bi bi-question-circle textkk fs-4"
                    onClick={() => setVisible(true)}
                  ></i>
                </div>

                {data?.deviceType !== "Neu (verschweisst)" &&
                data?.deviceType !== "Gebraucht" ? (
                  <>
                    {data?.modal !== "" &&
                      data?.category !== "" &&
                      data?.type !== "" &&
                      data?.deviceType !== "" && (
                        <>
                          <span className="Name-Marco">Marco</span>
                          <div className="message-box friend-message">
                            <p>
                              <img src="/images/small.png" alt="" />
                              {messageData[data?.deviceType]}
                            </p>
                          </div>
                        </>
                      )}

                    <div className="message-box my-message flex-wrap">
                      {data?.type !== "" &&
                      data?.category !== "" &&
                      data?.modal !== "" &&
                      data?.deviceType !== "" &&
                      data?.defective == "" ? (
                        defective[data?.deviceType]?.map((res) => (
                          <>
                            <div className="phn-svg" key={res?.name}>
                              <span
                                className="p-heading-text"
                                onClick={() =>
                                  handleCategoryClick({ defective: res?.type })
                                }
                              >
                                {res?.name}
                              </span>
                            </div>
                          </>
                        ))
                      ) : (
                        <>
                          <div className="d-flex gap-2 ans-content ">
                            <span className="p-heading-text">
                              {data?.defective}
                            </span>
                            {data?.defective && (
                              <i
                                className="bi bi-pencil-fill "
                                onClick={() => clearBelowStates("defective")}
                              ></i>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                    {data?.modal !== "" &&
                      data?.category !== "" &&
                      data?.type !== "" &&
                      data?.deviceType !== "" &&
                      data?.defective !== "" && (
                        <>
                          <span className="Name-Marco">Marco</span>
                          <div className="message-box friend-message ">
                            <p>
                              <img src="/images/small.png" alt="" />
                              {/* {messageData[data?.deviceColor]} */}
                              Welche Farbe hat Ihr Gerät?
                            </p>
                          </div>
                        </>
                      )}
                    <div className="message-box my-message flex-wrap">
                      {data?.type !== "" &&
                      data?.category !== "" &&
                      data?.modal !== "" &&
                      data?.deviceType !== "" &&
                      data?.defective !== "" &&
                      data?.deviceColor == "" ? (
                        color[data?.modal]?.map((res) => (
                          <>
                            <div className="phn-svg" key={res?.name}>
                              <span
                                className="p-heading-text"
                                onClick={() =>
                                  handleCategoryClick({
                                    deviceColor: res?.type,
                                  })
                                }
                              >
                                {res?.name}
                              </span>
                            </div>
                          </>
                        ))
                      ) : (
                        <>
                          <div className="d-flex gap-2 ans-content ">
                            <span className="p-heading-text">
                              {data?.deviceColor}
                            </span>
                            {data?.deviceColor && (
                              <i
                                className="bi bi-pencil-fill "
                                onClick={() => clearBelowStates("deviceColor")}
                              ></i>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    {data?.modal !== "" &&
                      data?.category !== "" &&
                      data?.type !== "" &&
                      data?.deviceType !== "" && (
                        <>
                          <span className="Name-Marco">Marco</span>
                          <div className="message-box friend-message ">
                            <p>
                              <img src="/images/small.png" alt="" />
                              {messageData[data?.deviceType]}
                            </p>
                          </div>
                        </>
                      )}
                    <div className="message-box my-message flex-wrap ">
                      {data?.type !== "" &&
                      data?.category !== "" &&
                      data?.modal !== "" &&
                      data?.deviceType !== "" &&
                      data?.deviceColor == "" ? (
                        color[data?.modal]?.map((res) => (
                          <>
                            <div className="phn-svg" key={res?.name}>
                              <span
                                className="p-heading-text"
                                onClick={() =>
                                  handleCategoryClick({
                                    deviceColor: res?.type,
                                  })
                                }
                              >
                                {res?.name}
                              </span>
                            </div>
                          </>
                        ))
                      ) : (
                        <>
                          <div className="d-flex gap-2 ans-content ">
                            <span className="p-heading-text">
                              {data?.deviceColor}
                            </span>
                            {data?.deviceColor && (
                              <i
                                className="bi bi-pencil-fill "
                                onClick={() => clearBelowStates("deviceColor")}
                              ></i>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
                {data?.modal !== "" &&
                  data?.category !== "" &&
                  data?.type !== "" &&
                  data?.deviceType &&
                  data?.deviceColor && (
                    <>
                      <span className="Name-Marco">Marco</span>
                      <div className="message-box friend-message">
                        <p>
                          <img src="/images/small.png" alt="" />
                          Welche Speichergrösse haben Sie?
                          {/* {console.log(messageData[data?.deviceColor])} */}
                        </p>
                      </div>
                    </>
                  )}

                <div className="message-box my-message flex-wrap">
                  {data?.type !== "" &&
                  data?.category !== "" &&
                  data?.modal !== "" &&
                  data?.deviceType !== "" &&
                  data?.deviceColor !== "" &&
                  data?.storage == "" ? (
                    color[data?.modal]
                      ?.find((res) => res?.name == data?.deviceColor)
                      [data?.deviceColor]?.map((res) => (
                        <>
                          <div className="phn-svg" key={res?.name}>
                            <span
                              className="p-heading-text"
                              onClick={() =>
                                handleCategoryClick({ storage: res?.type })
                              }
                            >
                              {res?.name}
                            </span>
                          </div>
                        </>
                      ))
                  ) : (
                    <>
                     <div className="d-flex gap-2 ans-content ">
                        <span className="p-heading-text">{data?.storage}</span>
                        {data?.storage && (
                          <i
                            className="bi bi-pencil-fill "
                            onClick={() => clearBelowStates("storage")}
                          ></i>
                        )}
                      </div>
                    </>
                  )}
                </div>

                {/* computer section  */}

                {data?.category == "Computer" ? (
                  <>
                    {data?.modal !== "" &&
                      data?.category !== "" &&
                      data?.type !== "" &&
                      data?.deviceType &&
                      data?.deviceColor &&
                      data?.storage && (
                        <>
                          <span className="Name-Marco">Marco</span>
                          <div className="message-box friend-message">
                            <p>
                              <img src="/images/small.png" alt="" />
                              Wieviel Arbeitsspeicher hat Ihr Gerät?
                            </p>
                          </div>
                        </>
                      )}
                    <div className="message-box my-message flex-wrap">
                      {data?.type !== "" &&
                      data?.category !== "" &&
                      data?.modal !== "" &&
                      data?.deviceType !== "" &&
                      data?.deviceColor !== "" &&
                      data?.storage !== "" &&
                      data?.ram == "" ? (
                        ram[data?.storage]?.map((res) => (
                          <>
                            <div className="phn-svg" key={res?.name}>
                              <span
                                className="p-heading-text"
                                onClick={() =>
                                  handleCategoryClick({ ram: res?.type })
                                }
                              >
                                {res?.name}
                              </span>
                            </div>
                          </>
                        ))
                      ) : (
                        <>
                         <div className="d-flex gap-2 ans-content ">
                            <span className="p-heading-text">{data?.ram}</span>
                            {data?.ram && (
                              <i
                                className="bi bi-pencil-fill "
                                onClick={() => clearBelowStates("ram")}
                              ></i>
                            )}
                          </div>
                        </>
                      )}
                    </div>

                    {data?.modal !== "" &&
                      data?.category !== "" &&
                      data?.type !== "" &&
                      data?.deviceType !== "" &&
                      data?.deviceColor !== "" &&
                      data?.storage !== "" &&
                      data?.ram !== "" && (
                        <>
                          <span className="Name-Marco">Marco</span>
                          <div className="message-box friend-message">
                            <p>
                              <img src="/images/small.png" alt="" />
                              Welchen Prozessor hat Ihr Gerät?
                            </p>
                          </div>
                        </>
                      )}
                    <div className="message-box my-message flex-wrap">
                      {data?.type !== "" &&
                      data?.category !== "" &&
                      data?.modal !== "" &&
                      data?.deviceType !== "" &&
                      data?.deviceColor !== "" &&
                      data?.storage !== "" &&
                      data?.ram !== "" &&
                      data?.processor == "" ? (
                        processor[data?.ram][data?.modal]?.map((res) => (
                          <>
                            {/* {console.log(processor[data?.ram][data?.modal])} */}
                            <div className="phn-svg" key={res?.name}>
                              <span
                                className="p-heading-text"
                                onClick={() =>
                                  handleCategoryClick({
                                    processor: res?.type,
                                  })
                                }
                              >
                                {res?.name}
                              </span>
                            </div>
                          </>
                        ))
                      ) : (
                        <>
                         <div className="d-flex gap-2 ans-content ">
                            <span className="p-heading-text">
                              {data?.processor}

                              {/* What storage size do you have? */}
                            </span>
                            {data?.processor && (
                              <i
                                className="bi bi-pencil-fill "
                                onClick={() => clearBelowStates("processor")}
                              ></i>
                            )}
                          </div>
                        </>
                      )}
                    </div>

                    {data?.modal !== "" &&
                      data?.category !== "" &&
                      data?.type !== "" &&
                      data?.deviceType !== "" &&
                      data?.deviceColor !== "" &&
                      data?.storage !== "" &&
                      data?.ram !== "" &&
                      data?.processor !== "" && (
                        <>
                          <span className="Name-Marco">Marco</span>
                          <div className="message-box friend-message">
                            <p>
                              <img src="/images/small.png" alt="" />
                              Welches Tastaturlayout hat das Gerät?
                            </p>
                          </div>
                        </>
                      )}
                    <div className="message-box my-message flex-wrap ">
                      {data?.type !== "" &&
                      data?.category !== "" &&
                      data?.modal !== "" &&
                      data?.deviceType !== "" &&
                      data?.deviceColor !== "" &&
                      data?.storage !== "" &&
                      data?.ram !== "" &&
                      data?.processor !== "" &&
                      data?.layout == "" ? (
                        layout[data?.type]?.map((res) => (
                          <>
                            {/* {console.log(processor[data?.ram][data?.modal])} */}
                            <div className="phn-svg" key={res?.name}>
                              <span
                                className="p-heading-text"
                                onClick={() =>
                                  handleCategoryClick({
                                    layout: res?.type,
                                  })
                                }
                              >
                                {res?.name}
                              </span>
                            </div>
                          </>
                        ))
                      ) : (
                        <>
                          <div className="d-flex gap-2 ans-content ">
                            <span className="p-heading-text ">
                              {data?.layout}

                              {/* What storage size do you have? */}
                            </span>
                            {data?.layout && (
                              <i
                                className="bi bi-pencil-fill "
                                onClick={() => clearBelowStates("layout")}
                              ></i>
                            )}
                          </div>
                        </>
                      )}
                    </div>

                    {/* hkjdhfkdshfkjjdsfhdfhdjshfhshfhfjhdfjh */}
                    {data?.deviceType !== "Neu (verschweisst)" ? (
                      <>
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          data?.type !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.ram !== "" &&
                          data?.processor !== "" &&
                          data?.layout !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message">
                                <p>
                                  <img src="/images/small.png" alt="" />
                                  {extraData[data?.deviceType]}
                                </p>
                              </div>
                            </>
                          )}

                        <div className="message-box my-message flex-wrap">
                          {data?.type !== "" &&
                          data?.category !== "" &&
                          data?.modal !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.ram !== "" &&
                          data?.processor !== "" &&
                          data?.layout !== "" &&
                          data?.display == "" ? (
                            display?.map((res) => (
                              <>
                                <div className="phn-svg" key={res?.name}>
                                  <span
                                    className="p-heading-text"
                                    onClick={() => {
                                      handleCategoryClick({
                                        display: res?.type,
                                      });
                                    }}
                                  >
                                    {res?.name}
                                  </span>
                                </div>
                              </>
                            ))
                          ) : (
                            <>
                             <div className="d-flex gap-2 ans-content ">
                                <span className="p-heading-text">
                                  {data?.display}

                                  {/* What storage size do you have? */}
                                </span>
                                {data?.display && (
                                  <i
                                    className="bi bi-pencil-fill "
                                    onClick={() => clearBelowStates("display")}
                                  ></i>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          data?.type !== "" &&
                          data?.deviceType !== "" &&
                          // data?.defective !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.ram !== "" &&
                          data?.processor !== "" &&
                          data?.layout !== "" &&
                          data?.display !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message ">
                                <p>
                                  <img src="/images/small.png" alt="" />
                                  {extraData4[data?.deviceType]}
                                </p>
                              </div>
                            </>
                          )}

                        <div className="message-box my-message flex-wrap">
                          {data?.type !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.modal !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          // data?.defective !== "" &&
                          data?.storage !== "" &&
                          data?.ram !== "" &&
                          data?.processor !== "" &&
                          data?.layout !== "" &&
                          data?.display !== "" &&
                          data?.cover == "" ? (
                            cover?.map((res) => (
                              <>
                                <div className="phn-svg" key={res?.name}>
                                  <span
                                    className="p-heading-text"
                                    onClick={() => {
                                      handleCategoryClick({ cover: res?.type });
                                    }}
                                  >
                                    {res?.name}
                                  </span>
                                </div>
                              </>
                            ))
                          ) : (
                            <>
                              <div className="d-flex gap-2 ans-content ">
                                <span className="p-heading-text">
                                  {data?.cover}

                                  {/* What storage size do you have? */}
                                </span>
                                {data?.cover && (
                                  <i
                                    className="bi bi-pencil-fill "
                                    onClick={() => clearBelowStates("cover")}
                                  ></i>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.type !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.ram !== "" &&
                          data?.processor !== "" &&
                          data?.layout !== "" &&
                          data?.display !== "" &&
                          data?.cover !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message">
                                <p>
                                  <img src="/images/small.png" alt="" />
                                  {extraData5[data?.deviceType]}
                                </p>
                              </div>
                            </>
                          )}

                        <div className="message-box my-message flex-wrap">
                          {data?.type !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.modal !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.ram !== "" &&
                          data?.processor !== "" &&
                          data?.layout !== "" &&
                          data?.display !== "" &&
                          data?.cover !== "" &&
                          data?.unibody == "" ? (
                            unibody?.map((res) => (
                              <>
                                <div className="phn-svg" key={res?.name}>
                                  <span
                                    className="p-heading-text"
                                    onClick={() => {
                                      handleCategoryClick({
                                        unibody: res?.type,
                                      });
                                    }}
                                  >
                                    {res?.name}
                                  </span>
                                </div>
                              </>
                            ))
                          ) : (
                            <>
                              <div className="d-flex gap-2 ans-content ">
                                <span className="p-heading-text">
                                  {data?.unibody}
                                </span>
                                {data?.unibody && (
                                  <i
                                    className="bi bi-pencil-fill "
                                    onClick={() => clearBelowStates("unibody")}
                                  ></i>
                                )}
                              </div>
                            </>
                          )}
                        </div>

                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.type !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.ram !== "" &&
                          data?.processor !== "" &&
                          data?.layout !== "" &&
                          data?.display !== "" &&
                          data?.cover !== "" &&
                          data?.unibody !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message">
                                <p>
                                  <img src="/images/small.png" alt="" />
                                  {extraData6[data?.deviceType]}
                                </p>
                              </div>
                            </>
                          )}

                        <div className="message-box my-message flex-wrap">
                          {data?.type !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.modal !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.ram !== "" &&
                          data?.processor !== "" &&
                          data?.layout !== "" &&
                          data?.display !== "" &&
                          data?.cover !== "" &&
                          data?.unibody !== "" &&
                          data?.underside == "" ? (
                            underside?.map((res) => (
                              <>
                                <div className="phn-svg" key={res?.name}>
                                  <span
                                    className="p-heading-text"
                                    onClick={() => {
                                      handleCategoryClick({
                                        underside: res?.type,
                                      });
                                    }}
                                  >
                                    {res?.name}
                                  </span>
                                </div>
                              </>
                            ))
                          ) : (
                            <>
                              <div className="d-flex gap-2 ans-content ">
                                <span className="p-heading-text">
                                  {data?.underside}
                                </span>
                                {data?.underside && (
                                  <i
                                    className="bi bi-pencil-fill "
                                    onClick={() =>
                                      clearBelowStates("underside")
                                    }
                                  ></i>
                                )}
                              </div>
                            </>
                          )}
                        </div>

                        {data?.modal !== "" &&
                          data?.series !== "" &&
                          data?.category !== "" &&
                          data?.type !== "" &&
                          (data?.deviceType !== data?.deviceColor) !== "" &&
                          data?.storage !== "" &&
                          data?.ram !== "" &&
                          data?.processor !== "" &&
                          data?.layout !== "" &&
                          data?.display !== "" &&
                          data?.cover !== "" &&
                          data?.unibody !== "" &&
                          data?.underside !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message">
                                <p className="Img-form overall-description-box">
                                  <div className="d-flex justify-content-between align-items-center p-2 message-header ">
                                    <div className="d-flex align-items-center justify-content-left">
                                      <img src="/images/small.png" alt="" />
                                      Hier erhalten Sie Ihr{" "}
                                      <strong>Angebot:</strong>
                                    </div>

                                    <div className="d-flex align-items-center gap-3 message-box-icon">
                                      <span>Link teilen</span>
                                      <i class="bi bi-envelope"></i>
                                      <i class="bi bi-chat-left-text"></i>
                                      <i class="bi bi-link-45deg"></i>
                                    </div>
                                  </div>

                                  <div className="mb-3  row bg-light mx-3 p-4">
                                    <div className="Datatext d-flex">
                                      <div className="col-4  phone-image-dummy justify-content-center">
                                        <img
                                          src="/images/computer.png"
                                          alt="phone-image"
                                        />
                                        <div className="final-price text-center">
                                          <div className="formtext ">
                                            Ihs Preis
                                          </div>
                                          <div class="price-text">
                                            {data.price}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-4 pe-2">
                                        <div className="mb-3">
                                          <div className="formtext">Marke</div>
                                          <div>{data.type}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Untermodell
                                          </div>
                                          <div>{data?.series}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">Modell</div>
                                          <div>{data?.modal}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">Farbe</div>
                                          <div>{data.deviceColor}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Speichergrosse
                                          </div>
                                          <div>{data?.storage}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Allgemeiner Zustand
                                          </div>
                                          <div> {data.deviceType}</div>
                                        </div>
                                      </div>

                                      <div className="col-4">
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Liste der Defekte
                                          </div>
                                          <div> {data.defective}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Zustand Display
                                          </div>
                                          <div> {data.display}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Zustand Deckel
                                          </div>
                                          <div> {data.cover}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Zustand Unibody Gehäuse
                                          </div>
                                          <div> {data.unibody}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Zustand Unterseite
                                          </div>
                                          <div> {data.underside}</div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      className="col-12 mt-3"
                                      onClick={SubmitData}
                                    >
                                      <button className="SellNowButton heartbeat">
                                        Neue Angebot Ansehen{" "}
                                        <VolunteerActivismOutlinedIcon />
                                      </button>
                                    </div>
                                  </div>
                                </p>
                              </div>
                            </>
                          )}
                      </>
                    ) : (
                      <>
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          data?.type !== "" &&
                          (data?.deviceType !== data?.deviceColor) !== "" &&
                          data?.storage !== "" &&
                          data?.ram !== "" &&
                          data?.processor !== "" &&
                          data?.layout !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message">
                                <p className="Img-form overall-description-box">
                                  <div className="d-flex justify-content-between align-items-center p-2  message-header">
                                    <div className="d-flex align-items-center justify-content-left">
                                      <img src="/images/small.png" alt="" />
                                      Hier erhalten Sie Ihr{" "}
                                      <strong>Angebot:</strong>
                                    </div>

                                    <div className="d-flex align-items-center gap-3 message-box-icon">
                                      <span>Link teilen</span>
                                      <i class="bi bi-envelope"></i>
                                      <i class="bi bi-chat-left-text"></i>
                                      <i class="bi bi-link-45deg"></i>
                                    </div>
                                  </div>

                                  <div className="mb-3 row bg-light mx-3 p-4">
                                    <div className="Datatext d-flex">
                                      <div className="col-4 phone-image-dummy justify-content-center">
                                        <img
                                          src="/images/computer.png"
                                          alt="phone-image"
                                        />
                                        <div className="final-price text-center">
                                          <div className="formtext ">
                                            Ihs Preis
                                          </div>
                                          <div class="price-text">
                                            {data.price}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-4 pe-2">
                                        <div className="mb-3">
                                          <div className="formtext">Marke</div>
                                          <div>{data.type}</div>
                                        </div>

                                        <div className="mb-3">
                                          <div className="formtext">Farbe</div>

                                          <div>{data.deviceColor}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Untermodell
                                          </div>
                                          <div>{data?.series}</div>
                                        </div>

                                        <div className="mb-3">
                                          <div className="formtext">
                                            {" "}
                                            Modell
                                          </div>
                                          <div>{data.modal}</div>
                                        </div>
                                      </div>
                                      <div className="col-4">
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Speichergrosse
                                          </div>
                                          <div>{data?.storage}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">RAM</div>
                                          <div>{data.ram}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Processor
                                          </div>
                                          <div>{data.processor}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Zustand Rückseite
                                          </div>
                                          <div>{data.layout}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Allgemeiner Zustand
                                          </div>
                                          <div> {data.deviceType}</div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      className="col-12 mt-3"
                                      onClick={SubmitData}
                                    >
                                      <button className="SellNowButton heartbeat">
                                        Neue Angebot Ansehen{" "}
                                        <VolunteerActivismOutlinedIcon />
                                      </button>
                                    </div>
                                  </div>
                                </p>
                              </div>
                            </>
                          )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {data?.deviceType !== "Neu (verschweisst)" ? (
                      <>
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          data?.type !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message">
                                <p>
                                  <img src="/images/small.png" alt="" />
                                  {extraData[data?.deviceType]}
                                </p>
                              </div>
                            </>
                          )}

                        <div className="message-box my-message flex-wrap">
                          {data?.type !== "" &&
                          data?.category !== "" &&
                          data?.modal !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.display == "" ? (
                            display?.map((res) => (
                              <>
                                <div className="phn-svg" key={res?.name}>
                                  <span
                                    className="p-heading-text"
                                    onClick={() => {
                                      handleCategoryClick({
                                        display: res?.type,
                                      });
                                    }}
                                  >
                                    {res?.name}
                                  </span>
                                </div>
                              </>
                            ))
                          ) : (
                            <>
                             <div className="d-flex gap-2 ans-content ">
                                <span className="p-heading-text">
                                  {data?.display}

                                  {/* What storage size do you have? */}
                                </span>
                                {data?.display && (
                                  <i
                                    className="bi bi-pencil-fill "
                                    onClick={() => clearBelowStates("display")}
                                  ></i>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          data?.type !== "" &&
                          data?.deviceType !== "" &&
                          // data?.defective !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.display !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message ">
                                <p>
                                  <img src="/images/small.png" alt="" />
                                  {extraData2[data?.deviceType]}
                                </p>
                              </div>
                            </>
                          )}

                        <div className="message-box my-message flex-wrap">
                          {data?.type !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.modal !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          // data?.defective !== "" &&
                          data?.storage !== "" &&
                          data?.display !== "" &&
                          data?.frame == "" ? (
                            frame?.map((res) => (
                              <>
                                <div className="phn-svg" key={res?.name}>
                                  <span
                                    className="p-heading-text"
                                    onClick={() => {
                                      handleCategoryClick({ frame: res?.type });
                                    }}
                                  >
                                    {res?.name}
                                  </span>
                                </div>
                              </>
                            ))
                          ) : (
                            <>
                             <div className="d-flex gap-2 ans-content ">
                                <span className="p-heading-text">
                                  {data?.frame}

                                  {/* What storage size do you have? */}
                                </span>
                                {data?.frame && (
                                  <i
                                    className="bi bi-pencil-fill "
                                    onClick={() => clearBelowStates("frame")}
                                  ></i>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.type !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.display !== "" &&
                          data?.frame !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message">
                                <p>
                                  <img src="/images/small.png" alt="" />
                                  {extraData3[data?.deviceType]}
                                </p>
                              </div>
                            </>
                          )}

                        <div className="message-box my-message flex-wrap">
                          {data?.type !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.modal !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.display !== "" &&
                          data?.frame !== "" &&
                          data?.backCase == "" ? (
                            backCase?.map((res) => (
                              <>
                                <div className="phn-svg" key={res?.name}>
                                  <span
                                    className="p-heading-text"
                                    onClick={() => {
                                      handleCategoryClick({
                                        backCase: res?.type,
                                      });
                                    }}
                                  >
                                    {res?.name}
                                  </span>
                                </div>
                              </>
                            ))
                          ) : (
                            <>
                              <div className="d-flex gap-2 ans-content">
                                <span className="p-heading-text">
                                  {data?.backCase}
                                </span>
                                {data?.backCase && (
                                  <i
                                    className="bi bi-pencil-fill "
                                    onClick={() => clearBelowStates("backCase")}
                                  ></i>
                                )}
                              </div>
                            </>
                          )}
                        </div>

                        {data?.modal !== "" &&
                          data?.series !== "" &&
                          data?.category !== "" &&
                          data?.type !== "" &&
                          (data?.deviceType !== data?.deviceColor) !== "" &&
                          data?.storage !== "" &&
                          data?.display !== "" &&
                          data?.frame !== "" &&
                          data?.backCase !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message">
                                <p className="Img-form overall-description-box">
                                  <div className="d-flex justify-content-between align-items-center p-2 message-header ">
                                    <div className="d-flex align-items-center justify-content-left">
                                      <img src="/images/small.png" alt="" />
                                      Hier erhalten Sie Ihr{" "}
                                      <strong>Angebot:</strong>
                                    </div>

                                    <div className="d-flex align-items-center gap-3 message-box-icon">
                                      <span>Link teilen</span>
                                      <i class="bi bi-envelope"></i>
                                      <i class="bi bi-chat-left-text"></i>
                                      <i class="bi bi-link-45deg"></i>
                                    </div>
                                  </div>

                                  <div className="mb-3  row bg-light mx-3 p-4">
                                    <div className="Datatext d-flex">
                                      <div className="col-4  phone-image-dummy justify-content-center">
                                        <img
                                          src="/images/phone-image.png"
                                          alt="phone-image"
                                        />
                                        <div className="final-price text-center">
                                          <div className="formtext ">
                                            Ihs Preis
                                          </div>
                                          <div class="price-text">
                                            {data.price}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-4 pe-2">
                                        <div className="mb-3">
                                          <div className="formtext">Marke</div>
                                          <div>{data.type}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Untermodell
                                          </div>
                                          <div>{data?.series}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">Modell</div>
                                          <div>{data?.modal}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">Farbe</div>
                                          <div>{data.deviceColor}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Speichergrosse
                                          </div>
                                          <div>{data?.storage}</div>
                                        </div>
                                      </div>

                                      <div className="col-4">
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Allgemeiner Zustand
                                          </div>
                                          <div> {data.deviceType}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Liste der Defekte
                                          </div>
                                          <div> {data.defective}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Zustand Display
                                          </div>
                                          <div> {data.display}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Zustand Rahmen
                                          </div>
                                          <div> {data.frame}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Zustand Ruckseite
                                          </div>
                                          <div> {data.backCase}</div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      className="col-12 mt-3"
                                      onClick={SubmitData}
                                    >
                                      <button className="SellNowButton heartbeat">
                                        Neue Angebot Ansehen{" "}
                                        <VolunteerActivismOutlinedIcon />
                                      </button>
                                    </div>
                                  </div>
                                </p>
                              </div>
                            </>
                          )}
                      </>
                    ) : (
                      <>
                        {data?.modal !== "" &&
                          data?.series !== "" &&
                          data?.category !== "" &&
                          data?.type !== "" &&
                          (data?.deviceType !== data?.deviceColor) !== "" &&
                          data?.storage !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message">
                                <p className="Img-form overall-description-box">
                                  <div className="d-flex justify-content-between align-items-center p-2  message-header">
                                    <div className="d-flex align-items-center justify-content-left">
                                      <img src="/images/small.png" alt="" />
                                      Hier erhalten Sie Ihr{" "}
                                      <strong>Angebot:</strong>
                                    </div>

                                    <div className="d-flex align-items-center gap-3 message-box-icon">
                                      <span>Link teilen</span>
                                      <i class="bi bi-envelope"></i>
                                      <i class="bi bi-chat-left-text"></i>
                                      <i class="bi bi-link-45deg"></i>
                                    </div>
                                  </div>

                                  <div className="mb-3  row bg-light mx-3 p-4">
                                    <div className="Datatext d-flex">
                                      <div className="col-4 phone-image-dummy justify-content-center">
                                        <img
                                          src="/images/phone-image.png"
                                          alt="phone-image"
                                        />
                                        <div className="final-price text-center">
                                          <div className="formtext ">
                                            Ihs Preis
                                          </div>
                                          <div class="price-text">
                                            {data.price}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-4 pe-2">
                                        <div className="mb-3">
                                          <div className="formtext">Marke</div>
                                          <div>{data.type}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Untermodell
                                          </div>
                                          <div>{data?.series}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">Modell</div>
                                          <div>{data?.modal}</div>
                                        </div>
                                      </div>

                                      <div className="col-4">
                                        <div className="mb-3">
                                          <div className="formtext">Farbe</div>
                                          {/* {console.log(data.deviceColor)} */}
                                          <div>{data.deviceColor}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Speichergrosse
                                          </div>
                                          <div>{data?.storage}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Allgemeiner Zustand
                                          </div>
                                          <div> {data.deviceType}</div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      className="col-12 mt-3"
                                      onClick={SubmitData}
                                    >
                                      <button className="SellNowButton heartbeat">
                                        Neue Angebot Ansehen{" "}
                                        <VolunteerActivismOutlinedIcon />
                                      </button>
                                    </div>
                                  </div>
                                </p>
                              </div>
                            </>
                          )}
                      </>
                    )}
                  </>
                )}

                {/* computer section  */}
                {/* new section computer overall descripton  */}
                {/* 
                {data?.modal !== "" &&
                  data?.category !== "" &&
                  data?.type !== "" &&
                  (data?.deviceType !== data?.deviceColor) !== "" &&
                  data?.storage !== "" &&
                  data?.ram !== "" &&
                  data?.processor !== "" && 
                  data?.layout !== "" && (

                    <>
                      <span className="Name-Marco">Marco</span>
                      <div className="message-box friend-message">
                        <p className="Img-form overall-description-box">
                          <div className="d-flex justify-content-between align-items-center p-2  message-header">
                            <div className="d-flex align-items-center justify-content-left">
                              <img src="/images/small.png" alt="" />
                              Hier erhalten Sie Ihr <strong>Angebot:</strong>
                            </div>

                            <div className="d-flex align-items-center gap-3 message-box-icon">
                              <span>Link teilen</span>
                              <i class="bi bi-envelope"></i>
                              <i class="bi bi-chat-left-text"></i>
                              <i class="bi bi-link-45deg"></i>
                            </div>
                          </div>

                          <div className="mb-3 row bg-light mx-3 p-4">
                            <div className="Datatext d-flex">
                              <div className="col-4 phone-image-dummy justify-content-center">
                                <img
                                  src="/images/computer.png"
                                  alt="phone-image"
                                />
                                <div className="final-price text-center">
                                  <div className="formtext ">Ihs Preis</div>
                                  <div class="price-text">{data.price}</div>
                                </div>
                              </div>

                              <div className="col-4 pe-2">
                                <div className="mb-3">
                                  <div className="formtext">Marke</div>
                                  <div>{data.type}</div>
                                </div>

                                <div className="mb-3">
                                  <div className="formtext">Farbe</div>

                                  <div>{data.deviceColor}</div>
                                </div>
                                <div className="mb-3">
                                  <div className="formtext">Untermodell</div>
                                  <div>{data?.series}</div>
                                </div>

                                <div className="mb-3">
                                  <div className="formtext"> Modell</div>
                                  <div>{data.modal}</div>
                                </div>
                              </div>
                              <div className="col-4">
                                <div className="mb-3">
                                  <div className="formtext">Speichergrosse</div>
                                  <div>{data?.storage}</div>
                                </div>
                                <div className="mb-3">
                                  <div className="formtext">RAM</div>
                                  <div>{data.ram}</div>
                                </div>
                                <div className="mb-3">
                                  <div className="formtext">Processor</div>
                                  <div>{data.processor}</div>
                                </div>
                                <div className="mb-3">
                                  <div className="formtext">Zustand Rückseite</div>
                                  <div>{data.layout}</div>
                                </div>
                                <div className="mb-3">
                                  <div className="formtext">
                                    Allgemeiner Zustand
                                  </div>
                                  <div> {data.deviceType}</div>
                                </div>
                              </div>
                            </div>

                            <div className="col-12 mt-3" onClick={SubmitData}>
                              <button className="SellNowButton heartbeat">
                                Neue Angebot Ansehen{" "}
                                <VolunteerActivismOutlinedIcon />
                              </button>
                            </div>
                          </div>
                        </p>
                      </div>
                    </>
                  )} */}
              </>
            ) : (
              <>
                <div className="message-box my-message flex-wrap ">
                  {data?.category !== "" &&
                  data?.type !== "" &&
                  data?.modal == "" ? (
                    model[data?.type]?.map((res) => (
                      <>
                        <div className="phn-svg " key={res?.name}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="36"
                            viewBox="0 0 19 36"
                          >
                            <path
                              fill="#B8D4CB"
                              fill-rule="nonzero"
                              d="M15.375 0H3.385C1.946 0 .78 1.182.78 2.622v29.966c0 1.449 1.166 2.639 2.606 2.639h11.997c1.44 0 2.622-1.19 2.622-2.639V2.622A2.644 2.644 0 0 0 15.375 0zm-7.16 1.957h2.347v.391H8.214v-.391zm1.173 32.682c-.759 0-1.37-.61-1.37-1.37 0-.759.619-1.37 1.37-1.37.752 0 1.37.611 1.37 1.37 0 .76-.61 1.37-1.37 1.37zm7.826-3.327H1.562V3.914h15.652v27.398zm-7.826 2.74a.785.785 0 0 1-.782-.782c0-.431.352-.783.782-.783.43 0 .783.352.783.783 0 .43-.352.782-.783.782z"
                            />
                          </svg>

                          <span
                            className="p-heading-text"
                            onClick={() =>
                              handleCategoryClick({ modal: res?.type })
                            }
                          >
                            {res?.name}
                          </span>
                        </div>
                      </>
                    ))
                  ) : (
                    <>
                      <div className="d-flex gap-2 ans-content">
                        <span className="p-heading-text">{data?.modal}</span>
                     
                      {data?.modal && (
                        <i
                          className="bi bi-pencil-fill "
                          onClick={() => clearBelowStates("modal")}
                        ></i>
                      )}
                       </div>
                    </>
                  )}
                </div>
                {data?.modal !== "" &&
                  data?.category !== "" &&
                  data?.type !== "" && (
                    <>
                      <span className="Name-Marco">Marco</span>
                      <div className="message-box friend-message">
                        <p>
                          <img src="/images/small.png" alt="" />
                          Wie ist der Zustand des Geräte?
                        </p>
                      </div>
                    </>
                  )}

                <div className="message-box my-message flex-wrap">
                  {/* {data?.category !== '' && data?.type !== '' && data?.modal == '' ? model[data?.type]?.map(res => ( */}
                  {data?.type !== "" &&
                  data?.category !== "" &&
                  data?.modal !== "" &&
                  data?.deviceType == "" ? (
                    deviceType?.map((res) => (
                      <>
                        {/* {console.log(res)} */}

                        <div className="phn-svg" key={res?.name}>
                          <span
                            className="p-heading-text"
                            onClick={() =>
                              handleCategoryClick({ deviceType: res?.type })
                            }
                          >
                            {res?.name}
                          </span>
                        </div>
                      </>
                    ))
                  ) : (
                    <>
                      <div className=" d-flex gap-2 ans-content">
                        <span className="p-heading-text">
                          {data?.deviceType}
                        </span>
                     

                      {data?.deviceType && (
                        <i
                          className="bi bi-pencil-fill "
                          onClick={() => clearBelowStates("deviceType")}
                        ></i>
                      )}
                       </div>
                    </>
                  )}
                  <i
                    class="bi bi-question-circle textkk fs-4"
                    onClick={() => setVisible(true)}
                  ></i>
                </div>
                {data?.modal !== "" &&
                  data?.category !== "" &&
                  data?.type !== "" &&
                  data?.deviceType !== "" && (
                    <>
                      <span className="Name-Marco">Marco</span>
                      <div className="message-box friend-message">
                        <p>
                          <img src="/images/small.png" alt="" />
                          {messageData[data?.deviceType]}
                        </p>
                      </div>
                    </>
                  )}

                {data?.deviceType == "Mangelhaft/Defekt" ? (
                  <>
                    <div className="message-box my-message flex-wrap">
                      {data?.type !== "" &&
                      data?.category !== "" &&
                      data?.modal !== "" &&
                      data?.deviceType !== "" &&
                      data?.defective == "" ? (
                        defective[data?.deviceType]?.map((res) => (
                          <>
                            <div className="phn-svg" key={res?.name}>
                              <span
                                className="p-heading-text"
                                onClick={() =>
                                  handleCategoryClick({ defective: res?.type })
                                }
                              >
                                {res?.name}
                              </span>
                            </div>
                          </>
                        ))
                      ) : (
                        <>
                          <div className="d-flex gap-2 ans-content">
                            <span className="p-heading-text">
                              {data?.defective}
                            </span>
                            &nbsp;&nbsp;
                            {data?.defective && (
                              <i
                                className="bi bi-pencil-fill "
                                onClick={() => clearBelowStates("defective")}
                              ></i>
                            )}
                          </div>
                        </>
                      )}
                    </div>

                    {data?.modal !== "" &&
                      data?.category !== "" &&
                      data?.type !== "" &&
                      data?.deviceType !== "" &&
                      data?.defective !== "" && (
                        <>
                          <span className="Name-Marco">Marco</span>
                          <div className="message-box friend-message">
                            <p>
                              <img src="/images/small.png" alt="" />
                              {/* {messageData[data?.deviceType]} */}
                              Welche Farbe hat Ihr Gerät?
                            </p>
                          </div>
                        </>
                      )}

                    <div className="message-box my-message flex-wrap">
                      {data?.type !== "" &&
                      data?.category !== "" &&
                      data?.modal !== "" &&
                      data?.deviceType !== "" &&
                      data?.defective !== "" &&
                      data?.deviceColor == "" ? (
                        color[data?.modal]?.map((res) => (
                          <>
                            <div className="phn-svg" key={res?.name}>
                              <span
                                className="p-heading-text"
                                onClick={() =>
                                  handleCategoryClick({
                                    deviceColor: res?.type,
                                  })
                                }
                              >
                                {res?.name}
                              </span>
                            </div>
                          </>
                        ))
                      ) : (
                        <>
                          <div className="d-flex gap-2 ans-content">
                            <span className="p-heading-text">
                              {data?.deviceColor}
                            </span>

                            {data?.deviceColor && (
                              <i
                                className="bi bi-pencil-fill "
                                onClick={() => clearBelowStates("deviceColor")}
                              ></i>
                            )}
                          </div>
                        </>
                      )}
                    </div>

                    {data?.modal !== "" &&
                      data?.category !== "" &&
                      data?.type !== "" &&
                      data?.deviceType &&
                      data?.defective !== "" &&
                      data?.deviceColor && (
                        <>
                          <span className="Name-Marco">Marco</span>
                          <div className="message-box friend-message">
                            <p>
                              <img src="/images/small.png" alt="" />
                              Welche Speichergrösse haben Sie?
                              {/* {console.log(messageData[data?.deviceColor])} */}
                            </p>
                          </div>
                        </>
                      )}

                    <div className="message-box my-message flex-wrap">
                      {data?.type !== "" &&
                      data?.category !== "" &&
                      data?.modal !== "" &&
                      data?.deviceType !== "" &&
                      data?.deviceColor !== "" &&
                      data?.defective !== "" &&
                      data?.storage == "" ? (
                        color[data?.modal]
                          ?.find((res) => res?.name == data?.deviceColor)
                          [data?.deviceColor]?.map((res) => (
                            <>
                              <div className="phn-svg" key={res?.name}>
                                <span
                                  className="p-heading-text"
                                  onClick={() => {
                                    handleCategoryClick({ storage: res?.type });
                                    if (price[data.modal] !== undefined) {
                                      if (
                                        price[data.modal][res?.type] !==
                                        undefined
                                      ) {
                                        console.log(
                                          price[data.modal][res?.type]
                                        );
                                        handleCategoryClick({
                                          price: price[data.modal][res?.type],
                                        });
                                      }
                                    }
                                  }}
                                >
                                  {res?.name}
                                </span>
                              </div>
                            </>
                          ))
                      ) : (
                        <>
                          <div className="d-flex gap-2 ans-content">
                            <span className="p-heading-text">
                              {data?.storage}

                              {/* What storage size do you have? */}
                            </span>
                            {data?.storage && (
                              <i
                                className="bi bi-pencil-fill "
                                onClick={() => clearBelowStates("storage")}
                              ></i>
                            )}
                          </div>
                        </>
                      )}
                    </div>

                    {/* -------------------------------------------------------------------------------------- */}

                    {data?.deviceType !== "Neu (verschweisst)" ? (
                      <>
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          data?.type !== "" &&
                          data?.deviceType !== "" &&
                          data?.defective !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message">
                                <p>
                                  <img src="/images/small.png" alt="" />
                                  {extraData[data?.deviceType]}
                                </p>
                              </div>
                            </>
                          )}

                        <div className="message-box my-message flex-wrap">
                          {data?.type !== "" &&
                          data?.category !== "" &&
                          data?.modal !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.defective !== "" &&
                          data?.storage !== "" &&
                          data?.display == "" ? (
                            display?.map((res) => (
                              <>
                                <div className="phn-svg" key={res?.name}>
                                  <span
                                    className="p-heading-text"
                                    onClick={() => {
                                      handleCategoryClick({
                                        display: res?.type,
                                      });
                                    }}
                                  >
                                    {res?.name}
                                  </span>
                                </div>
                              </>
                            ))
                          ) : (
                            <>
                              <div className="d-flex gap-2 ans-content">
                                <span className="p-heading-text">
                                  {data?.display}

                                  {/* What storage size do you have? */}
                                </span>
                                {data?.display && (
                                  <i
                                    className="bi bi-pencil-fill "
                                    onClick={() => clearBelowStates("display")}
                                  ></i>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          data?.type !== "" &&
                          data?.deviceType !== "" &&
                          data?.defective !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.display !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message ">
                                <p>
                                  <img src="/images/small.png" alt="" />
                                  {extraData2[data?.deviceType]}
                                </p>
                              </div>
                            </>
                          )}

                        <div className="message-box my-message flex-wrap">
                          {data?.type !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.modal !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.defective !== "" &&
                          data?.storage !== "" &&
                          data?.display !== "" &&
                          data?.frame == "" ? (
                            frame?.map((res) => (
                              <>
                                <div className="phn-svg" key={res?.name}>
                                  <span
                                    className="p-heading-text"
                                    onClick={() => {
                                      handleCategoryClick({ frame: res?.type });
                                    }}
                                  >
                                    {res?.name}
                                  </span>
                                </div>
                              </>
                            ))
                          ) : (
                            <>
                              <div className="d-flex gap-2 ans-content">
                                <span className="p-heading-text">
                                  {data?.frame}

                                  {/* What storage size do you have? */}
                                </span>
                                {data?.frame && (
                                  <i
                                    className="bi bi-pencil-fill "
                                    onClick={() => clearBelowStates("frame")}
                                  ></i>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.type !== "" &&
                          data?.deviceType !== "" &&
                          data?.defective !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.display !== "" &&
                          data?.frame !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message">
                                <p>
                                  <img src="/images/small.png" alt="" />
                                  {extraData3[data?.deviceType]}
                                </p>
                              </div>
                            </>
                          )}

                        <div className="message-box my-message flex-wrap">
                          {data?.type !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.modal !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.defective !== "" &&
                          data?.storage !== "" &&
                          data?.display !== "" &&
                          data?.frame !== "" &&
                          data?.backCase == "" ? (
                            backCase?.map((res) => (
                              <>
                                <div className="phn-svg" key={res?.name}>
                                  <span
                                    className="p-heading-text"
                                    onClick={() => {
                                      handleCategoryClick({
                                        backCase: res?.type,
                                      });
                                    }}
                                  >
                                    {res?.name}
                                  </span>
                                </div>
                              </>
                            ))
                          ) : (
                            <>
                              <div className="d-flex gap-2 ans-content">
                                <span className="p-heading-text">
                                  {data?.backCase}

                                  {/* What storage size do you have? */}
                                </span>
                                {data?.backCase && (
                                  <i
                                    className="bi bi-pencil-fill "
                                    onClick={() => clearBelowStates("backCase")}
                                  ></i>
                                )}
                              </div>
                            </>
                          )}
                        </div>

                        {/* Overall Description popup iphone......................... Defective section iphone pop up*/}
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.type !== "" &&
                          data?.defective !== "" &&
                          data?.deviceType !== data?.deviceColor &&
                          data?.storage &&
                          data?.display &&
                          data?.frame &&
                          data?.backCase && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message ">
                                <p className="Img-form overall-description-box">
                                  <div className="d-flex justify-content-between align-items-center p-2  message-header">
                                    <div className="d-flex align-items-center justify-content-left">
                                      <img src="/images/small.png" alt="" />
                                      Hier erhalten Sie Ihr{" "}
                                      <strong>Angebot:</strong>
                                    </div>

                                    <div className="d-flex align-items-center gap-3 message-box-icon">
                                      <span>Link teilen</span>
                                      <i class="bi bi-envelope"></i>
                                      <i class="bi bi-chat-left-text"></i>
                                      <i class="bi bi-link-45deg"></i>
                                    </div>
                                  </div>

                                  <div className="mb-3  row bg-light mx-3 p-4">
                                    <div className="Datatext d-flex">
                                      <div className="col-4 phone-image-dummy justify-content-center">
                                        <img
                                          src="/images/phone-image.png"
                                          alt="phone-image"
                                        />
                                        <div className="final-price text-center">
                                          <div className="formtext ">
                                            Ihs Preis
                                          </div>
                                          <div class="price-text">
                                            {data.price}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-4 pe-2">
                                        <div className="mb-3">
                                          <div className="formtext">Marke</div>
                                          <div>{data.type}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">Farbe</div>
                                          <div>{data.deviceColor}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">Modell</div>
                                          <div>{data.modal}</div>
                                        </div>

                                        <div className="mb-3">
                                          <div className="formtext">
                                            Speichergrosse
                                          </div>
                                          <div>{data.storage}</div>
                                        </div>

                                        <div className="mb-3">
                                          <div className="formtext">
                                            Allgemeiner Zustand
                                          </div>
                                          <div> {data.deviceType}</div>
                                        </div>
                                      </div>

                                      <div className="col-4">
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Liste der Defekte
                                          </div>
                                          <div> {data.defective}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Zustand Display
                                          </div>
                                          <div>{data.display}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Zustand Rahmen
                                          </div>
                                          <div>{data.frame}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Zustand Ruckseite
                                          </div>
                                          <div>{data.backCase}</div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      className="col-12 mt-3"
                                      onClick={SubmitData}
                                    >
                                      <button className="SellNowButton heartbeat">
                                        Neue Angebot Ansehen{" "}
                                        <VolunteerActivismOutlinedIcon />
                                      </button>
                                    </div>
                                  </div>
                                </p>
                              </div>
                            </>
                          )}
                      </>
                    ) : (
                      <>
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          data?.type !== "" &&
                          data?.defective !== "" &&
                          data?.deviceType !== data?.deviceColor &&
                          data?.storage && (
                            <>
                              <div className="message-box friend-message">
                                <p className="Img-form">
                                  <div className="mb-3 mt-5 row bg-light mx-3 p-4">
                                    <div className="Datatext col-md-6">
                                      <div className="mb-3">
                                        <div className="formtext">Marke</div>
                                        <div>{data.type}</div>
                                      </div>
                                      <div className="mb-3">
                                        <div className="formtext">
                                          Allgemeiner Zustand
                                        </div>
                                        <div> {data.deviceType}</div>
                                      </div>
                                      <div className="mb-3">
                                        <div className="formtext">Farbe</div>
                                        <div>{data.deviceColor}</div>
                                      </div>
                                      <div className="mb-3">
                                        <div className="formtext">Modell</div>
                                        <div>{data.modal}</div>
                                      </div>
                                    </div>

                                    <div className="Datatext col-md-6 ">
                                      <div className="mb-3">
                                        <div className="formtext">
                                          Speichergrosse
                                        </div>
                                        <div>{data.storage}</div>
                                      </div>
                                      <div className="mb-3">
                                        <div className="formtext">
                                          Ihs Preis
                                        </div>
                                        <div>{data.price}</div>
                                      </div>
                                    </div>

                                    <div
                                      className="col-12 mt-3"
                                      onClick={SubmitData}
                                    >
                                      <button className="SellNowButton heartbeat">
                                        Neue Angebot Ansehennnnnnnnnnnnnn{" "}
                                        <VolunteerActivismOutlinedIcon />
                                      </button>
                                    </div>
                                  </div>
                                </p>
                              </div>
                            </>
                          )}
                      </>
                    )}
                    {/* -------------------------------------------------------------------------------------- */}
                  </>
                ) : (
                  <>
                    <div className="message-box my-message flex-wrap">
                      {data?.type !== "" &&
                      data?.category !== "" &&
                      data?.modal !== "" &&
                      data?.deviceType !== "" &&
                      data?.deviceColor == "" ? (
                        color[data?.modal]?.map((res) => (
                          <>
                            <div className="phn-svg" key={res?.name}>
                              <span
                                className="p-heading-text"
                                onClick={() =>
                                  handleCategoryClick({
                                    deviceColor: res?.type,
                                  })
                                }
                              >
                                {res?.name}
                              </span>
                            </div>
                          </>
                        ))
                      ) : (
                        <>
                          <div className="d-flex gap-2 ans-content">
                            <span className="p-heading-text">
                              {data?.deviceColor}
                            </span>

                            {data?.deviceColor && (
                              <i
                                className="bi bi-pencil-fill "
                                onClick={() => clearBelowStates("deviceColor")}
                              ></i>
                            )}
                          </div>
                        </>
                      )}
                    </div>

                    {data?.modal !== "" &&
                      data?.category !== "" &&
                      data?.type !== "" &&
                      data?.deviceType &&
                      data?.deviceColor && (
                        <>
                          <span className="Name-Marco">Marco</span>
                          <div className="message-box friend-message">
                            <p>
                              <img src="/images/small.png" alt="" />
                              Welche Speichergrösse haben Sie?
                              {/* {console.log(messageData[data?.deviceColor])} */}
                            </p>
                          </div>
                        </>
                      )}

                    <div className="message-box my-message flex-wrap">
                      {data?.type !== "" &&
                      data?.category !== "" &&
                      data?.modal !== "" &&
                      data?.deviceType !== "" &&
                      data?.deviceColor !== "" &&
                      data?.storage == "" ? (
                        color[data?.modal]
                          ?.find((res) => res?.name == data?.deviceColor)
                          [data?.deviceColor]?.map((res) => (
                            <>
                              <div className="phn-svg" key={res?.name}>
                                <span
                                  className="p-heading-text"
                                  onClick={() => {
                                    handleCategoryClick({ storage: res?.type });
                                    if (price[data.modal] !== undefined) {
                                      if (
                                        price[data.modal][res?.type] !==
                                        undefined
                                      ) {
                                        console.log(
                                          price[data.modal][res?.type]
                                        );
                                        handleCategoryClick({
                                          price: price[data.modal][res?.type],
                                        });
                                      }
                                    }
                                  }}
                                >
                                  {res?.name}
                                </span>
                              </div>
                            </>
                          ))
                      ) : (
                        <>
                          <div className="d-flex gap-2 ans-content">
                            <span className="p-heading-text">
                              {data?.storage}

                              {/* What storage size do you have? */}
                            </span>
                            {data?.storage && (
                              <i
                                className="bi bi-pencil-fill "
                                onClick={() => clearBelowStates("storage")}
                              ></i>
                            )}
                          </div>
                        </>
                      )}
                    </div>

                    {data?.deviceType !== "Neu (verschweisst)" ? (
                      <>
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          data?.type !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message">
                                <p>
                                  <img src="/images/small.png" alt="" />
                                  {extraData[data?.deviceType]}
                                </p>
                              </div>
                            </>
                          )}

                        <div className="message-box my-message flex-wrap">
                          {data?.type !== "" &&
                          data?.category !== "" &&
                          data?.modal !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.display == "" ? (
                            display?.map((res) => (
                              <>
                                <div className="phn-svg" key={res?.name}>
                                  <span
                                    className="p-heading-text"
                                    onClick={() => {
                                      handleCategoryClick({
                                        display: res?.type,
                                      });
                                    }}
                                  >
                                    {res?.name}
                                  </span>
                                </div>
                              </>
                            ))
                          ) : (
                            <>
                              <div className="d-flex gap-2 ans-content">
                                <span className="p-heading-text">
                                  {data?.display}

                                  {/* What storage size do you have? */}
                                </span>
                                {data?.display && (
                                  <i
                                    className="bi bi-pencil-fill "
                                    onClick={() => clearBelowStates("display")}
                                  ></i>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          data?.type !== "" &&
                          data?.deviceType !== "" &&
                          // data?.defective !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.display !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message ">
                                <p>
                                  <img src="/images/small.png" alt="" />
                                  {extraData2[data?.deviceType]}
                                </p>
                              </div>
                            </>
                          )}

                        <div className="message-box my-message flex-wrap">
                          {data?.type !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.modal !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          // data?.defective !== "" &&
                          data?.storage !== "" &&
                          data?.display !== "" &&
                          data?.frame == "" ? (
                            frame?.map((res) => (
                              <>
                                <div className="phn-svg" key={res?.name}>
                                  <span
                                    className="p-heading-text"
                                    onClick={() => {
                                      handleCategoryClick({ frame: res?.type });
                                    }}
                                  >
                                    {res?.name}
                                  </span>
                                </div>
                              </>
                            ))
                          ) : (
                            <>
                              <div className="d-flex gap-2 ans-content">
                                <span className="p-heading-text">
                                  {data?.frame}

                                  {/* What storage size do you have? */}
                                </span>
                                {data?.frame && (
                                  <i
                                    className="bi bi-pencil-fill "
                                    onClick={() => clearBelowStates("frame")}
                                  ></i>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.type !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.display !== "" &&
                          data?.frame !== "" && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message">
                                <p>
                                  <img src="/images/small.png" alt="" />
                                  {extraData3[data?.deviceType]}
                                </p>
                              </div>
                            </>
                          )}

                        <div className="message-box my-message flex-wrap">
                          {data?.type !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.modal !== "" &&
                          data?.deviceType !== "" &&
                          data?.deviceColor !== "" &&
                          data?.storage !== "" &&
                          data?.display !== "" &&
                          data?.frame !== "" &&
                          data?.backCase == "" ? (
                            backCase?.map((res) => (
                              <>
                                <div className="phn-svg" key={res?.name}>
                                  <span
                                    className="p-heading-text"
                                    onClick={() => {
                                      handleCategoryClick({
                                        backCase: res?.type,
                                      });
                                    }}
                                  >
                                    {res?.name}
                                  </span>
                                </div>
                              </>
                            ))
                          ) : (
                            <>
                              <div className="d-flex gap-2 ans-content">
                                <span className="p-heading-text">
                                  {data?.backCase}
                                </span>
                                {data?.backCase && (
                                  <i
                                    className="bi bi-pencil-fill "
                                    onClick={() => clearBelowStates("backCase")}
                                  ></i>
                                )}
                              </div>
                            </>
                          )}
                        </div>

                        {/* Overall Description popup iphone ..............needed section iphone popup */}
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          // data?.series !== "" &&
                          data?.type !== "" &&
                          data?.deviceType !== data?.deviceColor &&
                          data?.storage &&
                          data?.display &&
                          data?.frame &&
                          data?.backCase && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message">
                                <p className="Img-form overall-description-box">
                                  <div className="d-flex justify-content-between align-items-center p-2  message-header">
                                    <div className="d-flex align-items-center justify-content-left">
                                      <img src="/images/small.png" alt="" />
                                      Hier erhalten Sie Ihr{" "}
                                      <strong>Angebot:</strong>
                                    </div>

                                    <div className="d-flex align-items-center gap-3 message-box-icon">
                                      <span>Link teilen</span>
                                      <i class="bi bi-envelope"></i>
                                      <i class="bi bi-chat-left-text"></i>
                                      <i class="bi bi-link-45deg"></i>
                                    </div>
                                  </div>

                                  <div className="mb-3 row bg-light mx-3 p-4">
                                    <div className="Datatext d-flex">
                                      <div className="col-4 phone-image-dummy justify-content-center">
                                        <img
                                          src="/images/phone-image.png"
                                          alt="phone-image"
                                        />
                                        <div className="text-center">
                                          <div className="formtext ">
                                            Ihs Preis
                                          </div>
                                          <div class="final-price price-text">
                                            {data.price}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-4 pe-2">
                                        <div className="mb-3">
                                          <div className="formtext">Marke</div>
                                          <div>{data.type}</div>
                                        </div>

                                        <div className="mb-3">
                                          <div className="formtext">Farbe</div>
                                          <div>{data.deviceColor}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">Modell</div>
                                          <div>{data.modal}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Speichergrosse
                                          </div>
                                          <div>{data.storage}</div>
                                        </div>
                                      </div>
                                      <div className="col-4">
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Allgemeiner Zustand
                                          </div>
                                          <div> {data.deviceType}</div>
                                        </div>

                                        <div className="mb-3">
                                          <div className="formtext">
                                            Zustand Display
                                          </div>
                                          <div>{data.display}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Zustand Rahmen
                                          </div>
                                          <div>{data.frame}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Zustand Ruckseite
                                          </div>
                                          <div>{data.backCase}</div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      className="col-12 mt-3"
                                      onClick={SubmitData}
                                    >
                                      <button className="SellNowButton heartbeat">
                                        Neue Angebot Ansehen{" "}
                                        <VolunteerActivismOutlinedIcon />
                                      </button>
                                    </div>
                                  </div>
                                </p>
                              </div>
                            </>
                          )}
                      </>
                    ) : (
                      <>
                        {/* Overall new section iphone description  */}
                        {data?.modal !== "" &&
                          data?.category !== "" &&
                          data?.type !== "" &&
                          data?.deviceType !== data?.deviceColor &&
                          data?.storage && (
                            <>
                              <span className="Name-Marco">Marco</span>
                              <div className="message-box friend-message ">
                                <p className="Img-form overall-description-box">
                                  <div className="d-flex justify-content-between align-items-center p-2  message-header">
                                    <div className="d-flex align-items-center justify-content-left">
                                      <img src="/images/small.png" alt="" />
                                      Hier erhalten Sie Ihr{" "}
                                      <strong>Angebot:</strong>
                                    </div>

                                    <div className="d-flex align-items-center gap-3 message-box-icon">
                                      <span>Link teilen</span>
                                      <i class="bi bi-envelope"></i>
                                      <i class="bi bi-chat-left-text"></i>
                                      <i class="bi bi-link-45deg"></i>
                                    </div>
                                  </div>

                                  <div className="mb-3  row bg-light mx-3 p-4">
                                    <div className="Datatext d-flex">
                                      <div className="col-4  phone-image-dummy justify-content-center">
                                        <img
                                          src="/images/phone-image.png"
                                          alt="phone-image"
                                        />
                                        <div className="final-price text-center">
                                          <div className="formtext ">
                                            Ihs Preis
                                          </div>
                                          <div class="price-text">
                                            {data.price}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-4 pe-2">
                                        <div className="mb-3">
                                          <div className="formtext">Marke</div>
                                          <div>{data.type}</div>
                                        </div>

                                        <div className="mb-3">
                                          <div className="formtext">Farbe</div>
                                          <div>{data.deviceColor}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">Modell</div>
                                          <div>{data.modal}</div>
                                        </div>
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Speichergrosse
                                          </div>
                                          <div>{data.storage}</div>
                                        </div>
                                      </div>
                                      <div className="col-4 ">
                                        <div className="mb-3">
                                          <div className="formtext">
                                            Allgemeiner Zustand
                                          </div>
                                          <div> {data.deviceType}</div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      className="col-12 mt-3"
                                      onClick={SubmitData}
                                    >
                                      <button className="SellNowButton heartbeat">
                                        Neue Angebot Ansehen{" "}
                                        <VolunteerActivismOutlinedIcon />
                                      </button>
                                    </div>
                                  </div>
                                </p>
                              </div>
                            </>
                          )}
                      </>
                    )}
                  </>
                )}
              </>
            )
          ) : (
            ""
          )}

          {loading ? (
            <div className="message-box friend-message newmwwd">
              <p>
                <img src="/images/small.png" alt="" />

                <Loader />
              </p>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>

      {/* side detail bar  */}

      {/* needed section side bar  */}
      <div className="left-container">
        <div className="left-detail-container">
          <div className="left-container-heading">Ihre Angaben</div>

          {data.category && (
            <div className="mb-5 mt-4  border-bottom ">
              <div className="left-container-heading mb-2"> Gerätetyp</div>
              <div className="Datatext d-flex justify-content-between">
                {data.category}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("category")}
                ></i>
              </div>
            </div>
          )}
          {data.type && (
            <div className="mb-3 mt-4  border-bottom">
              <div className="left-container-heading mb-2">Marke</div>
              <div className="Datatext d-flex justify-content-between">
                {data.type}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("type")}
                ></i>
              </div>
            </div>
          )}
          {data.series && (
            <div className="mb-3 mt-4   border-bottom">
              <div className="left-container-heading mb-2"> Untermodell</div>
              <div className="Datatext d-flex justify-content-between">
                {data.series}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("series")}
                ></i>
              </div>
            </div>
          )}

          {data.modal && (
            <div className="mb-3 mt-4  border-bottom">
              <div className="left-container-heading mb-2">Modell</div>
              <div className="Datatext d-flex justify-content-between">
                {data.modal}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("modal")}
                ></i>
              </div>
            </div>
          )}

          {data.deviceType && (
            <div className="mb-3 mt-4   border-bottom">
              <div className="left-container-heading mb-2">
                Allgemeiner Zustand
              </div>
              <div className="Datatext d-flex justify-content-between">
                {data.deviceType}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("deviceType")}
                ></i>
              </div>
            </div>
          )}

          {data.defective && (
            <div className="mb-3 mt-4   border-bottom">
              <div className="left-container-heading mb-2">
                Liste der Defekte
              </div>
              <div className="Datatext d-flex justify-content-between">
                {data.defective}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("defective")}
                ></i>
              </div>
            </div>
          )}

          {data.deviceColor && (
            <div className="mb-3 mt-4   border-bottom">
              <div className="left-container-heading mb-2">Farbe</div>
              <div className="Datatext d-flex justify-content-between">
                {data.deviceColor}
                {console.log(data.deviceColor)}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("deviceColor")}
                ></i>
              </div>
            </div>
          )}
          {data.storage && (
            <div className="mb-3 mt-4   border-bottom">
              <div className="left-container-heading mb-2">Speichergrösse</div>
              <div className="Datatext d-flex justify-content-between">
                {data.storage}
                {console.log(data.storage)}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("storage")}
                ></i>
              </div>
            </div>
          )}
          {data.ram && (
            <div className="mb-3 mt-4   border-bottom">
              <div className="left-container-heading mb-2">Arbeitsspeicher</div>
              <div className="Datatext d-flex justify-content-between">
                {data.ram}
                {console.log(data.ram)}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("ram")}
                ></i>
              </div>
            </div>
          )}
          {data.processor && (
            <div className="mb-3 mt-4   border-bottom">
              <div className="left-container-heading mb-2">Prozessor</div>
              <div className="Datatext d-flex justify-content-between">
                {data.processor}
                {console.log(data.processor)}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("processor")}
                ></i>
              </div>
            </div>
          )}
          {data.layout && (
            <div className="mb-3 mt-4   border-bottom">
              <div className="left-container-heading mb-2">
                Tastaturlayout
              </div>
              <div className="Datatext d-flex justify-content-between">
                {data.layout}
                {console.log(data.layout)}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("layout")}
                ></i>
              </div>
            </div>
          )}

          {data.display && (
            <div className="mb-3 mt-4   border-bottom">
              <div className="left-container-heading mb-2">Zustand Display</div>
              <div className="Datatext d-flex justify-content-between">
                {data.display}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("display")}
                ></i>
              </div>
            </div>
          )}
          {data.frame && (
            <div className="mb-3 mt-4   border-bottom">
              <div className="left-container-heading mb-2">Zustand Rahmen </div>
              <div className="Datatext d-flex justify-content-between">
                {data.frame}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("frame")}
                ></i>
              </div>
            </div>
          )}
          {data.backCase && (
            <div className="mb-3 mt-4   border-bottom">
              <div className="left-container-heading mb-2">
                Zustand Ruckseite
              </div>
              <div className="Datatext d-flex justify-content-between">
                {data.backCase}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("backCase")}
                ></i>
              </div>
            </div>
          )}
          {data.cover && (
            <div className="mb-3 mt-4   border-bottom">
              <div className="left-container-heading mb-2"> Zustand Deckel</div>
              <div className="Datatext d-flex justify-content-between">
                {data.cover}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("cover")}
                ></i>
              </div>
            </div>
          )}
          {data.unibody && (
            <div className="mb-3 mt-4   border-bottom">
              <div className="left-container-heading mb-2">
                Zustand Unibody Gehäuse
              </div>
              <div className="Datatext d-flex justify-content-between">
                {data.unibody}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("unibody")}
                ></i>
              </div>
            </div>
          )}
          {data.underside && (
            <div className="mb-3 mt-4   border-bottom">
              <div className="left-container-heading mb-2">
                Zustand Unterseite
              </div>
              <div className="Datatext d-flex justify-content-between">
                {data.underside}
                <i
                  className="bi bi-pencil-fill pointer"
                  onClick={() => clearBelowStates("underside")}
                ></i>
              </div>
            </div>
          )}
        </div>
      </div>
      <Dialog
        visible={visible}
        maximizable
        style={{
          width: "50rem",
          color: "#101928",
          background: "white",
          padding: "20px",
        }}
        onHide={() => setVisible(false)}
        headerClassName="addBorder_bottom"
        draggable={false}
      >
        <div>
          <div>
            <h1 className="text-center headingmain">Allgemeiner Zustand</h1>
            <p className="text-center model-text mb-5">
              Definieren Sie Ihren Zustand ob Ihr Gerät neu, gebraucht oder
              mangelhaft / defekt ist.
            </p>
          </div>
          <div className="row ">
            <div className="col-md-4">
              <div className="d-flex justify-content-center flex-column">
                <div className="d-flex justify-content-center">
                  <img
                    src="/images/detail-condition-question-23-1.png"
                    alt=""
                    className="img-phone"
                  />
                </div>
                <div className="model-subtext">
                  <p className="text-center pt-2">Neu (verschweisst)</p>
                  <p className="text-center model-text">
                    Unter der Definition neu verstehen wir ein komplett neues
                    Gerät, welches sich noch in einer verschweissten
                    Originalverpackung befindet inkl. Garantieschein.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex justify-content-center flex-column">
                <div className="d-flex justify-content-center">
                  <img
                    src="/images/detail-condition-question-23-2.png"
                    alt=""
                    className="img-phone"
                  />
                </div>
                <div className="model-subtext">
                  <p className="text-center pt-2">Sichtbare Gebrauchsspuren</p>
                  <p className="text-center model-text">
                    Unter der Definition gebraucht verstehen wir das Ihr Gerät
                    benutzt wurde und Gebrauchsspuren enthalten kann, jedoch
                    muss es voll funktionsfähig sein.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex justify-content-center flex-column">
                <div className="d-flex justify-content-center">
                  <img
                    src="/images/detail-condition-question-23-3.png"
                    alt=""
                    className="img-phone"
                  />
                </div>
                <div className="model-subtext">
                  <p className="text-center pt-2">Mangelhaft / Defekt</p>
                  <p className="text-center model-text">
                    Unter der Definition mangelhaft / defekt verstehen wir
                    Geräte welche einen Mangel (z.B. Glas gebrochen, Batterie
                    schwach, Gerät lässt sich nicht einschalten usw.) aufweisen.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
